(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4ed8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4ed8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bLAFc", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0235f1a586dfacb3$export$ffb0004e005737fa; }, function (v) { return $0235f1a586dfacb3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0235f1a586dfacb3$export$34b9dba7ce09269b; }, function (v) { return $0235f1a586dfacb3$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0235f1a586dfacb3$export$25062201e9e25d76; }, function (v) { return $0235f1a586dfacb3$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0235f1a586dfacb3$export$ffb0004e005737fa;
var $0235f1a586dfacb3$export$34b9dba7ce09269b;
var $0235f1a586dfacb3$export$25062201e9e25d76;
"use strict";
var $0235f1a586dfacb3$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0235f1a586dfacb3$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $0235f1a586dfacb3$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $0235f1a586dfacb3$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$0235f1a586dfacb3$export$ffb0004e005737fa = $0235f1a586dfacb3$var$REACT_FRAGMENT_TYPE;
$0235f1a586dfacb3$export$34b9dba7ce09269b = $0235f1a586dfacb3$var$jsxProd;
$0235f1a586dfacb3$export$25062201e9e25d76 = $0235f1a586dfacb3$var$jsxProd;

});

parcelRegister("5HVm7", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $427d75919e309268$export$dca3b0875bd9a954; }, function (v) { return $427d75919e309268$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $427d75919e309268$export$16fa2f45be04daa8; }, function (v) { return $427d75919e309268$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $427d75919e309268$export$ffb0004e005737fa; }, function (v) { return $427d75919e309268$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $427d75919e309268$export$e2c29f18771995cb; }, function (v) { return $427d75919e309268$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $427d75919e309268$export$221d75b3f55bb0bd; }, function (v) { return $427d75919e309268$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $427d75919e309268$export$5f8d39834fd61797; }, function (v) { return $427d75919e309268$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $427d75919e309268$export$74bf444e3cd11ea5; }, function (v) { return $427d75919e309268$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $427d75919e309268$export$1ced07cd6b1985ce; }, function (v) { return $427d75919e309268$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $427d75919e309268$export$abd8e32b826d7ea7; }, function (v) { return $427d75919e309268$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $427d75919e309268$export$69a3209f1a06c04d; }, function (v) { return $427d75919e309268$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $427d75919e309268$export$e530037191fcd5d7; }, function (v) { return $427d75919e309268$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $427d75919e309268$export$fd42f52fd3ae1109; }, function (v) { return $427d75919e309268$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $427d75919e309268$export$c8a8987d4410bf2d; }, function (v) { return $427d75919e309268$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $427d75919e309268$export$7d1e3a5e95ceca43; }, function (v) { return $427d75919e309268$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $427d75919e309268$export$257a8862b851cb5b; }, function (v) { return $427d75919e309268$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $427d75919e309268$export$a8257692ac88316c; }, function (v) { return $427d75919e309268$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $427d75919e309268$export$488013bae63b21da; }, function (v) { return $427d75919e309268$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $427d75919e309268$export$7c73462e0d25e514; }, function (v) { return $427d75919e309268$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $427d75919e309268$export$7568632d0d33d16d; }, function (v) { return $427d75919e309268$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $427d75919e309268$export$f93f40ac0ca7e3a8; }, function (v) { return $427d75919e309268$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $427d75919e309268$export$1f96ae73734a86cc; }, function (v) { return $427d75919e309268$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $427d75919e309268$export$9a47ced3238df325; }, function (v) { return $427d75919e309268$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $427d75919e309268$export$35808ee640e87ca7; }, function (v) { return $427d75919e309268$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $427d75919e309268$export$fae74005e78b1a27; }, function (v) { return $427d75919e309268$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $427d75919e309268$export$dc8fbce3eb94dc1e; }, function (v) { return $427d75919e309268$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $427d75919e309268$export$6a7bc4e911dc01cf; }, function (v) { return $427d75919e309268$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $427d75919e309268$export$6d9c69b0de29b591; }, function (v) { return $427d75919e309268$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $427d75919e309268$export$f680877a34711e37; }, function (v) { return $427d75919e309268$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $427d75919e309268$export$d5a552a76deda3c2; }, function (v) { return $427d75919e309268$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $427d75919e309268$export$aaabe4eda9ed9969; }, function (v) { return $427d75919e309268$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $427d75919e309268$export$e5c5a5f917a5871c; }, function (v) { return $427d75919e309268$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $427d75919e309268$export$1538c33de8887b59; }, function (v) { return $427d75919e309268$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $427d75919e309268$export$fca7f784ae7a249a; }, function (v) { return $427d75919e309268$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $427d75919e309268$export$13e3392192263954; }, function (v) { return $427d75919e309268$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $427d75919e309268$export$b8f5890fc79d6aca; }, function (v) { return $427d75919e309268$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $427d75919e309268$export$60241385465d0a34; }, function (v) { return $427d75919e309268$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $427d75919e309268$export$306c0aa65ff9ec16; }, function (v) { return $427d75919e309268$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $427d75919e309268$export$7b286972b8d8ccbf; }, function (v) { return $427d75919e309268$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $427d75919e309268$export$83d89fbfd8236492; }, function (v) { return $427d75919e309268$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $6zqIC = parcelRequire("6zqIC");
var $427d75919e309268$export$dca3b0875bd9a954;
var $427d75919e309268$export$16fa2f45be04daa8;
var $427d75919e309268$export$ffb0004e005737fa;
var $427d75919e309268$export$e2c29f18771995cb;
var $427d75919e309268$export$221d75b3f55bb0bd;
var $427d75919e309268$export$5f8d39834fd61797;
var $427d75919e309268$export$74bf444e3cd11ea5;
var $427d75919e309268$export$1ced07cd6b1985ce;
var $427d75919e309268$export$abd8e32b826d7ea7;
var $427d75919e309268$export$69a3209f1a06c04d;
var $427d75919e309268$export$e530037191fcd5d7;
var $427d75919e309268$export$fd42f52fd3ae1109;
var $427d75919e309268$export$c8a8987d4410bf2d;
var $427d75919e309268$export$7d1e3a5e95ceca43;
var $427d75919e309268$export$257a8862b851cb5b;
var $427d75919e309268$export$a8257692ac88316c;
var $427d75919e309268$export$488013bae63b21da;
var $427d75919e309268$export$7c73462e0d25e514;
var $427d75919e309268$export$7568632d0d33d16d;
var $427d75919e309268$export$f93f40ac0ca7e3a8;
var $427d75919e309268$export$1f96ae73734a86cc;
var $427d75919e309268$export$9a47ced3238df325;
var $427d75919e309268$export$35808ee640e87ca7;
var $427d75919e309268$export$fae74005e78b1a27;
var $427d75919e309268$export$dc8fbce3eb94dc1e;
var $427d75919e309268$export$6a7bc4e911dc01cf;
var $427d75919e309268$export$6d9c69b0de29b591;
var $427d75919e309268$export$f680877a34711e37;
var $427d75919e309268$export$d5a552a76deda3c2;
var $427d75919e309268$export$aaabe4eda9ed9969;
var $427d75919e309268$export$e5c5a5f917a5871c;
var $427d75919e309268$export$1538c33de8887b59;
var $427d75919e309268$export$fca7f784ae7a249a;
var $427d75919e309268$export$13e3392192263954;
var $427d75919e309268$export$b8f5890fc79d6aca;
var $427d75919e309268$export$60241385465d0a34;
var $427d75919e309268$export$306c0aa65ff9ec16;
var $427d75919e309268$export$7b286972b8d8ccbf;
var $427d75919e309268$export$83d89fbfd8236492;
"use strict";
var $427d75919e309268$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $427d75919e309268$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $427d75919e309268$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $427d75919e309268$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $427d75919e309268$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $427d75919e309268$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $427d75919e309268$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $427d75919e309268$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $427d75919e309268$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $427d75919e309268$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $427d75919e309268$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $427d75919e309268$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $427d75919e309268$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $6zqIC._)(maybeIterable))) return null;
    maybeIterable = $427d75919e309268$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$427d75919e309268$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $427d75919e309268$var$ReactNoopUpdateQueue = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $427d75919e309268$var$assign = Object.assign, $427d75919e309268$var$emptyObject = {};
function $427d75919e309268$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $427d75919e309268$var$emptyObject;
    this.updater = updater || $427d75919e309268$var$ReactNoopUpdateQueue;
}
$427d75919e309268$var$Component.prototype.isReactComponent = {};
$427d75919e309268$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== (typeof partialState === "undefined" ? "undefined" : (0, $6zqIC._)(partialState)) && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$427d75919e309268$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $427d75919e309268$var$ComponentDummy() {}
$427d75919e309268$var$ComponentDummy.prototype = $427d75919e309268$var$Component.prototype;
function $427d75919e309268$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $427d75919e309268$var$emptyObject;
    this.updater = updater || $427d75919e309268$var$ReactNoopUpdateQueue;
}
var $427d75919e309268$var$pureComponentPrototype = $427d75919e309268$var$PureComponent.prototype = new $427d75919e309268$var$ComponentDummy();
$427d75919e309268$var$pureComponentPrototype.constructor = $427d75919e309268$var$PureComponent;
$427d75919e309268$var$assign($427d75919e309268$var$pureComponentPrototype, $427d75919e309268$var$Component.prototype);
$427d75919e309268$var$pureComponentPrototype.isPureReactComponent = !0;
var $427d75919e309268$var$isArrayImpl = Array.isArray, $427d75919e309268$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $427d75919e309268$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $427d75919e309268$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $427d75919e309268$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $427d75919e309268$var$cloneAndReplaceKey(oldElement, newKey) {
    return $427d75919e309268$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $427d75919e309268$var$isValidElement(object) {
    return "object" === (typeof object === "undefined" ? "undefined" : (0, $6zqIC._)(object)) && null !== object && object.$$typeof === $427d75919e309268$var$REACT_ELEMENT_TYPE;
}
function $427d75919e309268$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $427d75919e309268$var$userProvidedKeyEscapeRegex = /\/+/g;
function $427d75919e309268$var$getElementKey(element, index) {
    return "object" === (typeof element === "undefined" ? "undefined" : (0, $6zqIC._)(element)) && null !== element && null != element.key ? $427d75919e309268$var$escape("" + element.key) : index.toString(36);
}
function $427d75919e309268$var$noop$1() {}
function $427d75919e309268$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($427d75919e309268$var$noop$1, $427d75919e309268$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $427d75919e309268$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children === "undefined" ? "undefined" : (0, $6zqIC._)(children);
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $427d75919e309268$var$REACT_ELEMENT_TYPE:
                case $427d75919e309268$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $427d75919e309268$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $427d75919e309268$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $427d75919e309268$var$getElementKey(children, 0) : nameSoFar, $427d75919e309268$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($427d75919e309268$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $427d75919e309268$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($427d75919e309268$var$isValidElement(callback) && (callback = $427d75919e309268$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($427d75919e309268$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($427d75919e309268$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $427d75919e309268$var$getElementKey(nameSoFar, i), invokeCallback += $427d75919e309268$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $427d75919e309268$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $427d75919e309268$var$getElementKey(nameSoFar, i++), invokeCallback += $427d75919e309268$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $427d75919e309268$var$mapIntoArray($427d75919e309268$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $427d75919e309268$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $427d75919e309268$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $427d75919e309268$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $427d75919e309268$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $6zqIC._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $6zqIC._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $427d75919e309268$var$noop() {}
$427d75919e309268$export$dca3b0875bd9a954 = {
    map: $427d75919e309268$var$mapChildren,
    forEach: function forEach(children, forEachFunc, forEachContext) {
        $427d75919e309268$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function count(children) {
        var n = 0;
        $427d75919e309268$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function toArray(children) {
        return $427d75919e309268$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function only(children) {
        if (!$427d75919e309268$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$427d75919e309268$export$16fa2f45be04daa8 = $427d75919e309268$var$Component;
$427d75919e309268$export$ffb0004e005737fa = $427d75919e309268$var$REACT_FRAGMENT_TYPE;
$427d75919e309268$export$e2c29f18771995cb = $427d75919e309268$var$REACT_PROFILER_TYPE;
$427d75919e309268$export$221d75b3f55bb0bd = $427d75919e309268$var$PureComponent;
$427d75919e309268$export$5f8d39834fd61797 = $427d75919e309268$var$REACT_STRICT_MODE_TYPE;
$427d75919e309268$export$74bf444e3cd11ea5 = $427d75919e309268$var$REACT_SUSPENSE_TYPE;
$427d75919e309268$export$1ced07cd6b1985ce = $427d75919e309268$var$ReactSharedInternals;
$427d75919e309268$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function c(size) {
        return $427d75919e309268$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$427d75919e309268$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$427d75919e309268$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $427d75919e309268$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$427d75919e309268$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $427d75919e309268$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$427d75919e309268$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $427d75919e309268$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $427d75919e309268$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$427d75919e309268$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$427d75919e309268$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $427d75919e309268$var$ReactElement(type, key, void 0, void 0, null, props);
};
$427d75919e309268$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$427d75919e309268$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $427d75919e309268$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$427d75919e309268$export$a8257692ac88316c = $427d75919e309268$var$isValidElement;
$427d75919e309268$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $427d75919e309268$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $427d75919e309268$var$lazyInitializer
    };
};
$427d75919e309268$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $427d75919e309268$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$427d75919e309268$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $427d75919e309268$var$ReactSharedInternals.T, currentTransition = {};
    $427d75919e309268$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $427d75919e309268$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $6zqIC._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($427d75919e309268$var$noop, $427d75919e309268$var$reportGlobalError);
    } catch (error) {
        $427d75919e309268$var$reportGlobalError(error);
    } finally{
        $427d75919e309268$var$ReactSharedInternals.T = prevTransition;
    }
};
$427d75919e309268$export$f93f40ac0ca7e3a8 = function() {
    return $427d75919e309268$var$ReactSharedInternals.H.useCacheRefresh();
};
$427d75919e309268$export$1f96ae73734a86cc = function(usable) {
    return $427d75919e309268$var$ReactSharedInternals.H.use(usable);
};
$427d75919e309268$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $427d75919e309268$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$427d75919e309268$export$35808ee640e87ca7 = function(callback, deps) {
    return $427d75919e309268$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$427d75919e309268$export$fae74005e78b1a27 = function(Context) {
    return $427d75919e309268$var$ReactSharedInternals.H.useContext(Context);
};
$427d75919e309268$export$dc8fbce3eb94dc1e = function() {};
$427d75919e309268$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $427d75919e309268$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$427d75919e309268$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $427d75919e309268$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$427d75919e309268$export$f680877a34711e37 = function() {
    return $427d75919e309268$var$ReactSharedInternals.H.useId();
};
$427d75919e309268$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $427d75919e309268$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$427d75919e309268$export$aaabe4eda9ed9969 = function(create, deps) {
    return $427d75919e309268$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$427d75919e309268$export$e5c5a5f917a5871c = function(create, deps) {
    return $427d75919e309268$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$427d75919e309268$export$1538c33de8887b59 = function(create, deps) {
    return $427d75919e309268$var$ReactSharedInternals.H.useMemo(create, deps);
};
$427d75919e309268$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $427d75919e309268$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$427d75919e309268$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $427d75919e309268$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$427d75919e309268$export$b8f5890fc79d6aca = function(initialValue) {
    return $427d75919e309268$var$ReactSharedInternals.H.useRef(initialValue);
};
$427d75919e309268$export$60241385465d0a34 = function(initialState) {
    return $427d75919e309268$var$ReactSharedInternals.H.useState(initialState);
};
$427d75919e309268$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $427d75919e309268$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$427d75919e309268$export$7b286972b8d8ccbf = function() {
    return $427d75919e309268$var$ReactSharedInternals.H.useTransition();
};
$427d75919e309268$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("6zqIC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4c8abcbf1af2a7b7$export$71511d61b312f219; });
function $4c8abcbf1af2a7b7$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("2Q1CL", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $2111b2a4c096959e$export$882461b6382ed46c; }, function (v) { return $2111b2a4c096959e$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $2111b2a4c096959e$export$757ceba2d55c277e; }, function (v) { return $2111b2a4c096959e$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $2111b2a4c096959e$export$83d89fbfd8236492; }, function (v) { return $2111b2a4c096959e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $6zqIC = parcelRequire("6zqIC");
var $2111b2a4c096959e$export$882461b6382ed46c;
var $2111b2a4c096959e$export$757ceba2d55c277e;
var $2111b2a4c096959e$export$83d89fbfd8236492;
"use strict";

var $bv0px = parcelRequire("bv0px");

var $4Bt61 = parcelRequire("4Bt61");

var $bQr77 = parcelRequire("bQr77");
function $2111b2a4c096959e$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $2111b2a4c096959e$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $2111b2a4c096959e$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $2111b2a4c096959e$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $2111b2a4c096959e$var$assertIsMounted(fiber) {
    if ($2111b2a4c096959e$var$getNearestMountedFiber(fiber) !== fiber) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(188));
}
function $2111b2a4c096959e$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $2111b2a4c096959e$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $2111b2a4c096959e$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $2111b2a4c096959e$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($2111b2a4c096959e$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $2111b2a4c096959e$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $2111b2a4c096959e$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $2111b2a4c096959e$var$assign = Object.assign, $2111b2a4c096959e$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $2111b2a4c096959e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $2111b2a4c096959e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2111b2a4c096959e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $2111b2a4c096959e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $2111b2a4c096959e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $2111b2a4c096959e$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $2111b2a4c096959e$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $2111b2a4c096959e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $2111b2a4c096959e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $2111b2a4c096959e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $2111b2a4c096959e$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $2111b2a4c096959e$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $2111b2a4c096959e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $2111b2a4c096959e$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $2111b2a4c096959e$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $2111b2a4c096959e$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $2111b2a4c096959e$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $6zqIC._)(maybeIterable))) return null;
    maybeIterable = $2111b2a4c096959e$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$2111b2a4c096959e$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $2111b2a4c096959e$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $2111b2a4c096959e$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $2111b2a4c096959e$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $2111b2a4c096959e$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $2111b2a4c096959e$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $2111b2a4c096959e$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $2111b2a4c096959e$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $2111b2a4c096959e$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $2111b2a4c096959e$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === (typeof type === "undefined" ? "undefined" : (0, $6zqIC._)(type))) switch(type.$$typeof){
        case $2111b2a4c096959e$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $2111b2a4c096959e$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $2111b2a4c096959e$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $2111b2a4c096959e$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $2111b2a4c096959e$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $2111b2a4c096959e$var$getComponentNameFromType(type.type) || "Memo";
        case $2111b2a4c096959e$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $2111b2a4c096959e$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $2111b2a4c096959e$var$isArrayImpl = Array.isArray, $2111b2a4c096959e$var$ReactSharedInternals = $4Bt61.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $2111b2a4c096959e$var$ReactDOMSharedInternals = $bQr77.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $2111b2a4c096959e$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $2111b2a4c096959e$var$valueStack = [], $2111b2a4c096959e$var$index = -1;
function $2111b2a4c096959e$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $2111b2a4c096959e$var$pop(cursor) {
    0 > $2111b2a4c096959e$var$index || (cursor.current = $2111b2a4c096959e$var$valueStack[$2111b2a4c096959e$var$index], $2111b2a4c096959e$var$valueStack[$2111b2a4c096959e$var$index] = null, $2111b2a4c096959e$var$index--);
}
function $2111b2a4c096959e$var$push(cursor, value) {
    $2111b2a4c096959e$var$index++;
    $2111b2a4c096959e$var$valueStack[$2111b2a4c096959e$var$index] = cursor.current;
    cursor.current = value;
}
var $2111b2a4c096959e$var$contextStackCursor = $2111b2a4c096959e$var$createCursor(null), $2111b2a4c096959e$var$contextFiberStackCursor = $2111b2a4c096959e$var$createCursor(null), $2111b2a4c096959e$var$rootInstanceStackCursor = $2111b2a4c096959e$var$createCursor(null), $2111b2a4c096959e$var$hostTransitionProviderCursor = $2111b2a4c096959e$var$createCursor(null);
function $2111b2a4c096959e$var$pushHostContainer(fiber, nextRootInstance) {
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$rootInstanceStackCursor, nextRootInstance);
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$contextFiberStackCursor, fiber);
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $2111b2a4c096959e$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $2111b2a4c096959e$var$getOwnHostContext(nextRootInstance), fiber = $2111b2a4c096959e$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$contextStackCursor);
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$contextStackCursor, fiber);
}
function $2111b2a4c096959e$var$popHostContainer() {
    $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$contextStackCursor);
    $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$contextFiberStackCursor);
    $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$rootInstanceStackCursor);
}
function $2111b2a4c096959e$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $2111b2a4c096959e$var$push($2111b2a4c096959e$var$hostTransitionProviderCursor, fiber);
    var context = $2111b2a4c096959e$var$contextStackCursor.current;
    var JSCompiler_inline_result = $2111b2a4c096959e$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($2111b2a4c096959e$var$push($2111b2a4c096959e$var$contextFiberStackCursor, fiber), $2111b2a4c096959e$var$push($2111b2a4c096959e$var$contextStackCursor, JSCompiler_inline_result));
}
function $2111b2a4c096959e$var$popHostContext(fiber) {
    $2111b2a4c096959e$var$contextFiberStackCursor.current === fiber && ($2111b2a4c096959e$var$pop($2111b2a4c096959e$var$contextStackCursor), $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$contextFiberStackCursor));
    $2111b2a4c096959e$var$hostTransitionProviderCursor.current === fiber && ($2111b2a4c096959e$var$pop($2111b2a4c096959e$var$hostTransitionProviderCursor), $2111b2a4c096959e$var$HostTransitionContext._currentValue = $2111b2a4c096959e$var$sharedNotPendingObject);
}
var $2111b2a4c096959e$var$hasOwnProperty = Object.prototype.hasOwnProperty, $2111b2a4c096959e$var$scheduleCallback$3 = $bv0px.unstable_scheduleCallback, $2111b2a4c096959e$var$cancelCallback$1 = $bv0px.unstable_cancelCallback, $2111b2a4c096959e$var$shouldYield = $bv0px.unstable_shouldYield, $2111b2a4c096959e$var$requestPaint = $bv0px.unstable_requestPaint, $2111b2a4c096959e$var$now = $bv0px.unstable_now, $2111b2a4c096959e$var$getCurrentPriorityLevel = $bv0px.unstable_getCurrentPriorityLevel, $2111b2a4c096959e$var$ImmediatePriority = $bv0px.unstable_ImmediatePriority, $2111b2a4c096959e$var$UserBlockingPriority = $bv0px.unstable_UserBlockingPriority, $2111b2a4c096959e$var$NormalPriority$1 = $bv0px.unstable_NormalPriority, $2111b2a4c096959e$var$LowPriority = $bv0px.unstable_LowPriority, $2111b2a4c096959e$var$IdlePriority = $bv0px.unstable_IdlePriority, $2111b2a4c096959e$var$log$1 = $bv0px.log, $2111b2a4c096959e$var$unstable_setDisableYieldValue = $bv0px.unstable_setDisableYieldValue, $2111b2a4c096959e$var$rendererID = null, $2111b2a4c096959e$var$injectedHook = null;
function $2111b2a4c096959e$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $2111b2a4c096959e$var$log$1 && $2111b2a4c096959e$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($2111b2a4c096959e$var$injectedHook && "function" === typeof $2111b2a4c096959e$var$injectedHook.setStrictMode) try {
        $2111b2a4c096959e$var$injectedHook.setStrictMode($2111b2a4c096959e$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $2111b2a4c096959e$var$clz32 = Math.clz32 ? Math.clz32 : $2111b2a4c096959e$var$clz32Fallback, $2111b2a4c096959e$var$log = Math.log, $2111b2a4c096959e$var$LN2 = Math.LN2;
function $2111b2a4c096959e$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($2111b2a4c096959e$var$log(x) / $2111b2a4c096959e$var$LN2 | 0) | 0;
}
var $2111b2a4c096959e$var$nextTransitionLane = 256, $2111b2a4c096959e$var$nextRetryLane = 4194304;
function $2111b2a4c096959e$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $2111b2a4c096959e$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $2111b2a4c096959e$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $2111b2a4c096959e$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $2111b2a4c096959e$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $2111b2a4c096959e$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $2111b2a4c096959e$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $2111b2a4c096959e$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $2111b2a4c096959e$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $2111b2a4c096959e$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2111b2a4c096959e$var$claimNextTransitionLane() {
    var lane = $2111b2a4c096959e$var$nextTransitionLane;
    $2111b2a4c096959e$var$nextTransitionLane <<= 1;
    0 === ($2111b2a4c096959e$var$nextTransitionLane & 4194048) && ($2111b2a4c096959e$var$nextTransitionLane = 256);
    return lane;
}
function $2111b2a4c096959e$var$claimNextRetryLane() {
    var lane = $2111b2a4c096959e$var$nextRetryLane;
    $2111b2a4c096959e$var$nextRetryLane <<= 1;
    0 === ($2111b2a4c096959e$var$nextRetryLane & 62914560) && ($2111b2a4c096959e$var$nextRetryLane = 4194304);
    return lane;
}
function $2111b2a4c096959e$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $2111b2a4c096959e$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $2111b2a4c096959e$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $2111b2a4c096959e$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $2111b2a4c096959e$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $2111b2a4c096959e$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $2111b2a4c096959e$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $2111b2a4c096959e$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $2111b2a4c096959e$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $2111b2a4c096959e$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $2111b2a4c096959e$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $2111b2a4c096959e$var$resolveUpdatePriority() {
    var updatePriority = $2111b2a4c096959e$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $2111b2a4c096959e$var$getEventPriority(updatePriority.type);
}
function $2111b2a4c096959e$var$runWithPriority(priority, fn) {
    var previousPriority = $2111b2a4c096959e$var$ReactDOMSharedInternals.p;
    try {
        return $2111b2a4c096959e$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $2111b2a4c096959e$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $2111b2a4c096959e$var$randomKey = Math.random().toString(36).slice(2), $2111b2a4c096959e$var$internalInstanceKey = "__reactFiber$" + $2111b2a4c096959e$var$randomKey, $2111b2a4c096959e$var$internalPropsKey = "__reactProps$" + $2111b2a4c096959e$var$randomKey, $2111b2a4c096959e$var$internalContainerInstanceKey = "__reactContainer$" + $2111b2a4c096959e$var$randomKey, $2111b2a4c096959e$var$internalEventHandlersKey = "__reactEvents$" + $2111b2a4c096959e$var$randomKey, $2111b2a4c096959e$var$internalEventHandlerListenersKey = "__reactListeners$" + $2111b2a4c096959e$var$randomKey, $2111b2a4c096959e$var$internalEventHandlesSetKey = "__reactHandles$" + $2111b2a4c096959e$var$randomKey, $2111b2a4c096959e$var$internalRootNodeResourcesKey = "__reactResources$" + $2111b2a4c096959e$var$randomKey, $2111b2a4c096959e$var$internalHoistableMarker = "__reactMarker$" + $2111b2a4c096959e$var$randomKey;
function $2111b2a4c096959e$var$detachDeletedInstance(node) {
    delete node[$2111b2a4c096959e$var$internalInstanceKey];
    delete node[$2111b2a4c096959e$var$internalPropsKey];
    delete node[$2111b2a4c096959e$var$internalEventHandlersKey];
    delete node[$2111b2a4c096959e$var$internalEventHandlerListenersKey];
    delete node[$2111b2a4c096959e$var$internalEventHandlesSetKey];
}
function $2111b2a4c096959e$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$2111b2a4c096959e$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$2111b2a4c096959e$var$internalContainerInstanceKey] || parentNode[$2111b2a4c096959e$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $2111b2a4c096959e$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$2111b2a4c096959e$var$internalInstanceKey]) return parentNode;
                targetNode = $2111b2a4c096959e$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $2111b2a4c096959e$var$getInstanceFromNode(node) {
    if (node = node[$2111b2a4c096959e$var$internalInstanceKey] || node[$2111b2a4c096959e$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $2111b2a4c096959e$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($2111b2a4c096959e$var$formatProdErrorMessage(33));
}
function $2111b2a4c096959e$var$getResourcesFromRoot(root) {
    var resources = root[$2111b2a4c096959e$var$internalRootNodeResourcesKey];
    resources || (resources = root[$2111b2a4c096959e$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $2111b2a4c096959e$var$markNodeAsHoistable(node) {
    node[$2111b2a4c096959e$var$internalHoistableMarker] = !0;
}
var $2111b2a4c096959e$var$allNativeEvents = new Set(), $2111b2a4c096959e$var$registrationNameDependencies = {};
function $2111b2a4c096959e$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $2111b2a4c096959e$var$registerDirectEvent(registrationName, dependencies);
    $2111b2a4c096959e$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $2111b2a4c096959e$var$registerDirectEvent(registrationName, dependencies) {
    $2111b2a4c096959e$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$2111b2a4c096959e$var$allNativeEvents.add(dependencies[registrationName]);
}
var $2111b2a4c096959e$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $2111b2a4c096959e$var$illegalAttributeNameCache = {}, $2111b2a4c096959e$var$validatedAttributeNameCache = {};
function $2111b2a4c096959e$var$isAttributeNameSafe(attributeName) {
    if ($2111b2a4c096959e$var$hasOwnProperty.call($2111b2a4c096959e$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($2111b2a4c096959e$var$hasOwnProperty.call($2111b2a4c096959e$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($2111b2a4c096959e$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $2111b2a4c096959e$var$validatedAttributeNameCache[attributeName] = !0;
    $2111b2a4c096959e$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $2111b2a4c096959e$var$setValueForAttribute(node, name, value) {
    if ($2111b2a4c096959e$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $2111b2a4c096959e$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $2111b2a4c096959e$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $2111b2a4c096959e$var$prefix, $2111b2a4c096959e$var$suffix;
function $2111b2a4c096959e$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $2111b2a4c096959e$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $2111b2a4c096959e$var$prefix = match && match[1] || "";
        $2111b2a4c096959e$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $2111b2a4c096959e$var$prefix + name + $2111b2a4c096959e$var$suffix;
}
var $2111b2a4c096959e$var$reentry = !1;
function $2111b2a4c096959e$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $2111b2a4c096959e$var$reentry) return "";
    $2111b2a4c096959e$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function DetermineComponentFrameRoot() {
                try {
                    if (construct) {
                        var Fake = function Fake() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function set() {
                                throw Error();
                            }
                        });
                        if ("object" === (typeof Reflect === "undefined" ? "undefined" : (0, $6zqIC._)(Reflect)) && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $2111b2a4c096959e$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $2111b2a4c096959e$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $2111b2a4c096959e$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $2111b2a4c096959e$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $2111b2a4c096959e$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $2111b2a4c096959e$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $2111b2a4c096959e$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $2111b2a4c096959e$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $2111b2a4c096959e$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $2111b2a4c096959e$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $2111b2a4c096959e$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $2111b2a4c096959e$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $2111b2a4c096959e$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $2111b2a4c096959e$var$getToStringValue(value) {
    switch(typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $2111b2a4c096959e$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $2111b2a4c096959e$var$trackValueOnNode(node) {
    var valueField = $2111b2a4c096959e$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function get1() {
                return get.call(this);
            },
            set: function set1(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function getValue() {
                return currentValue;
            },
            setValue: function setValue(value) {
                currentValue = "" + value;
            },
            stopTracking: function stopTracking() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $2111b2a4c096959e$var$track(node) {
    node._valueTracker || (node._valueTracker = $2111b2a4c096959e$var$trackValueOnNode(node));
}
function $2111b2a4c096959e$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $2111b2a4c096959e$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $2111b2a4c096959e$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $2111b2a4c096959e$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $6zqIC._)(type)) && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $2111b2a4c096959e$var$getToStringValue(value);
        } else element.value !== "" + $2111b2a4c096959e$var$getToStringValue(value) && (element.value = "" + $2111b2a4c096959e$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $2111b2a4c096959e$var$setDefaultValue(element, type, $2111b2a4c096959e$var$getToStringValue(value)) : null != defaultValue ? $2111b2a4c096959e$var$setDefaultValue(element, type, $2111b2a4c096959e$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $6zqIC._)(checked)));
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $6zqIC._)(name)) && "boolean" !== typeof name ? element.name = "" + $2111b2a4c096959e$var$getToStringValue(name) : element.removeAttribute("name");
}
function $2111b2a4c096959e$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $6zqIC._)(type)) && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $2111b2a4c096959e$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $2111b2a4c096959e$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $6zqIC._)(checked)) && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $6zqIC._)(name)) && "boolean" !== typeof name && (element.name = name);
}
function $2111b2a4c096959e$var$setDefaultValue(node, type, value) {
    "number" === type && $2111b2a4c096959e$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $2111b2a4c096959e$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $2111b2a4c096959e$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $2111b2a4c096959e$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $2111b2a4c096959e$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $2111b2a4c096959e$var$getToStringValue(defaultValue) : "";
}
function $2111b2a4c096959e$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(92));
            if ($2111b2a4c096959e$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $2111b2a4c096959e$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $2111b2a4c096959e$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $2111b2a4c096959e$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $2111b2a4c096959e$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $2111b2a4c096959e$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $2111b2a4c096959e$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== (typeof styles === "undefined" ? "undefined" : (0, $6zqIC._)(styles))) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $2111b2a4c096959e$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $2111b2a4c096959e$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $2111b2a4c096959e$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2111b2a4c096959e$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $2111b2a4c096959e$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $2111b2a4c096959e$var$sanitizeURL(url) {
    return $2111b2a4c096959e$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $2111b2a4c096959e$var$currentReplayingEvent = null;
function $2111b2a4c096959e$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $2111b2a4c096959e$var$restoreTarget = null, $2111b2a4c096959e$var$restoreQueue = null;
function $2111b2a4c096959e$var$restoreStateOfTarget(target) {
    var internalInstance = $2111b2a4c096959e$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$2111b2a4c096959e$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $2111b2a4c096959e$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$2111b2a4c096959e$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(90));
                            $2111b2a4c096959e$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $2111b2a4c096959e$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $2111b2a4c096959e$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $2111b2a4c096959e$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $2111b2a4c096959e$var$isInsideEventHandler = !1;
function $2111b2a4c096959e$var$batchedUpdates$1(fn, a, b) {
    if ($2111b2a4c096959e$var$isInsideEventHandler) return fn(a, b);
    $2111b2a4c096959e$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($2111b2a4c096959e$var$isInsideEventHandler = !1, null !== $2111b2a4c096959e$var$restoreTarget || null !== $2111b2a4c096959e$var$restoreQueue) {
            if ($2111b2a4c096959e$var$flushSyncWork$1(), $2111b2a4c096959e$var$restoreTarget && (a = $2111b2a4c096959e$var$restoreTarget, fn = $2111b2a4c096959e$var$restoreQueue, $2111b2a4c096959e$var$restoreQueue = $2111b2a4c096959e$var$restoreTarget = null, $2111b2a4c096959e$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$2111b2a4c096959e$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $2111b2a4c096959e$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$2111b2a4c096959e$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(231, registrationName, typeof stateNode === "undefined" ? "undefined" : (0, $6zqIC._)(stateNode)));
    return stateNode;
}
var $2111b2a4c096959e$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2111b2a4c096959e$var$passiveBrowserEventsSupported = !1;
if ($2111b2a4c096959e$var$canUseDOM) try {
    var $2111b2a4c096959e$var$options = {};
    Object.defineProperty($2111b2a4c096959e$var$options, "passive", {
        get: function get() {
            $2111b2a4c096959e$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $2111b2a4c096959e$var$options, $2111b2a4c096959e$var$options);
    window.removeEventListener("test", $2111b2a4c096959e$var$options, $2111b2a4c096959e$var$options);
} catch (e) {
    $2111b2a4c096959e$var$passiveBrowserEventsSupported = !1;
}
var $2111b2a4c096959e$var$root = null, $2111b2a4c096959e$var$startText = null, $2111b2a4c096959e$var$fallbackText = null;
function $2111b2a4c096959e$var$getData() {
    if ($2111b2a4c096959e$var$fallbackText) return $2111b2a4c096959e$var$fallbackText;
    var start, startValue = $2111b2a4c096959e$var$startText, startLength = startValue.length, end, endValue = "value" in $2111b2a4c096959e$var$root ? $2111b2a4c096959e$var$root.value : $2111b2a4c096959e$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $2111b2a4c096959e$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $2111b2a4c096959e$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $2111b2a4c096959e$var$functionThatReturnsTrue() {
    return !0;
}
function $2111b2a4c096959e$var$functionThatReturnsFalse() {
    return !1;
}
function $2111b2a4c096959e$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $2111b2a4c096959e$var$functionThatReturnsTrue : $2111b2a4c096959e$var$functionThatReturnsFalse;
        this.isPropagationStopped = $2111b2a4c096959e$var$functionThatReturnsFalse;
        return this;
    }
    $2111b2a4c096959e$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== (0, $6zqIC._)(event.returnValue) && (event.returnValue = !1), this.isDefaultPrevented = $2111b2a4c096959e$var$functionThatReturnsTrue);
        },
        stopPropagation: function stopPropagation() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== (0, $6zqIC._)(event.cancelBubble) && (event.cancelBubble = !0), this.isPropagationStopped = $2111b2a4c096959e$var$functionThatReturnsTrue);
        },
        persist: function persist() {},
        isPersistent: $2111b2a4c096959e$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $2111b2a4c096959e$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2111b2a4c096959e$var$SyntheticEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$EventInterface), $2111b2a4c096959e$var$UIEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$EventInterface, {
    view: 0,
    detail: 0
}), $2111b2a4c096959e$var$SyntheticUIEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$UIEventInterface), $2111b2a4c096959e$var$lastMovementX, $2111b2a4c096959e$var$lastMovementY, $2111b2a4c096959e$var$lastMouseEvent, $2111b2a4c096959e$var$MouseEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2111b2a4c096959e$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function movementX(event) {
        if ("movementX" in event) return event.movementX;
        event !== $2111b2a4c096959e$var$lastMouseEvent && ($2111b2a4c096959e$var$lastMouseEvent && "mousemove" === event.type ? ($2111b2a4c096959e$var$lastMovementX = event.screenX - $2111b2a4c096959e$var$lastMouseEvent.screenX, $2111b2a4c096959e$var$lastMovementY = event.screenY - $2111b2a4c096959e$var$lastMouseEvent.screenY) : $2111b2a4c096959e$var$lastMovementY = $2111b2a4c096959e$var$lastMovementX = 0, $2111b2a4c096959e$var$lastMouseEvent = event);
        return $2111b2a4c096959e$var$lastMovementX;
    },
    movementY: function movementY(event) {
        return "movementY" in event ? event.movementY : $2111b2a4c096959e$var$lastMovementY;
    }
}), $2111b2a4c096959e$var$SyntheticMouseEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$MouseEventInterface), $2111b2a4c096959e$var$DragEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$MouseEventInterface, {
    dataTransfer: 0
}), $2111b2a4c096959e$var$SyntheticDragEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$DragEventInterface), $2111b2a4c096959e$var$FocusEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$UIEventInterface, {
    relatedTarget: 0
}), $2111b2a4c096959e$var$SyntheticFocusEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$FocusEventInterface), $2111b2a4c096959e$var$AnimationEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2111b2a4c096959e$var$SyntheticAnimationEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$AnimationEventInterface), $2111b2a4c096959e$var$ClipboardEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$EventInterface, {
    clipboardData: function clipboardData(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $2111b2a4c096959e$var$SyntheticClipboardEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$ClipboardEventInterface), $2111b2a4c096959e$var$CompositionEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$EventInterface, {
    data: 0
}), $2111b2a4c096959e$var$SyntheticCompositionEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$CompositionEventInterface), $2111b2a4c096959e$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2111b2a4c096959e$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2111b2a4c096959e$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2111b2a4c096959e$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $2111b2a4c096959e$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $2111b2a4c096959e$var$getEventModifierState() {
    return $2111b2a4c096959e$var$modifierStateGetter;
}
var $2111b2a4c096959e$var$KeyboardEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$UIEventInterface, {
    key: function key(nativeEvent) {
        if (nativeEvent.key) {
            var key = $2111b2a4c096959e$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $2111b2a4c096959e$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $2111b2a4c096959e$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2111b2a4c096959e$var$getEventModifierState,
    charCode: function charCode(event) {
        return "keypress" === event.type ? $2111b2a4c096959e$var$getEventCharCode(event) : 0;
    },
    keyCode: function keyCode(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function which(event) {
        return "keypress" === event.type ? $2111b2a4c096959e$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $2111b2a4c096959e$var$SyntheticKeyboardEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$KeyboardEventInterface), $2111b2a4c096959e$var$PointerEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2111b2a4c096959e$var$SyntheticPointerEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$PointerEventInterface), $2111b2a4c096959e$var$TouchEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2111b2a4c096959e$var$getEventModifierState
}), $2111b2a4c096959e$var$SyntheticTouchEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$TouchEventInterface), $2111b2a4c096959e$var$TransitionEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2111b2a4c096959e$var$SyntheticTransitionEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$TransitionEventInterface), $2111b2a4c096959e$var$WheelEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$MouseEventInterface, {
    deltaX: function deltaX(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function deltaY(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2111b2a4c096959e$var$SyntheticWheelEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$WheelEventInterface), $2111b2a4c096959e$var$ToggleEventInterface = $2111b2a4c096959e$var$assign({}, $2111b2a4c096959e$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $2111b2a4c096959e$var$SyntheticToggleEvent = $2111b2a4c096959e$var$createSyntheticEvent($2111b2a4c096959e$var$ToggleEventInterface), $2111b2a4c096959e$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $2111b2a4c096959e$var$canUseCompositionEvent = $2111b2a4c096959e$var$canUseDOM && "CompositionEvent" in window, $2111b2a4c096959e$var$documentMode = null;
$2111b2a4c096959e$var$canUseDOM && "documentMode" in document && ($2111b2a4c096959e$var$documentMode = document.documentMode);
var $2111b2a4c096959e$var$canUseTextInputEvent = $2111b2a4c096959e$var$canUseDOM && "TextEvent" in window && !$2111b2a4c096959e$var$documentMode, $2111b2a4c096959e$var$useFallbackCompositionData = $2111b2a4c096959e$var$canUseDOM && (!$2111b2a4c096959e$var$canUseCompositionEvent || $2111b2a4c096959e$var$documentMode && 8 < $2111b2a4c096959e$var$documentMode && 11 >= $2111b2a4c096959e$var$documentMode), $2111b2a4c096959e$var$SPACEBAR_CHAR = String.fromCharCode(32), $2111b2a4c096959e$var$hasSpaceKeypress = !1;
function $2111b2a4c096959e$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $2111b2a4c096959e$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2111b2a4c096959e$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === (typeof nativeEvent === "undefined" ? "undefined" : (0, $6zqIC._)(nativeEvent)) && "data" in nativeEvent ? nativeEvent.data : null;
}
var $2111b2a4c096959e$var$isComposing = !1;
function $2111b2a4c096959e$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $2111b2a4c096959e$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $2111b2a4c096959e$var$hasSpaceKeypress = !0;
            return $2111b2a4c096959e$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $2111b2a4c096959e$var$SPACEBAR_CHAR && $2111b2a4c096959e$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $2111b2a4c096959e$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($2111b2a4c096959e$var$isComposing) return "compositionend" === domEventName || !$2111b2a4c096959e$var$canUseCompositionEvent && $2111b2a4c096959e$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $2111b2a4c096959e$var$getData(), $2111b2a4c096959e$var$fallbackText = $2111b2a4c096959e$var$startText = $2111b2a4c096959e$var$root = null, $2111b2a4c096959e$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $2111b2a4c096959e$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $2111b2a4c096959e$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2111b2a4c096959e$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$2111b2a4c096959e$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $2111b2a4c096959e$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $2111b2a4c096959e$var$restoreTarget ? $2111b2a4c096959e$var$restoreQueue ? $2111b2a4c096959e$var$restoreQueue.push(target) : $2111b2a4c096959e$var$restoreQueue = [
        target
    ] : $2111b2a4c096959e$var$restoreTarget = target;
    inst = $2111b2a4c096959e$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $2111b2a4c096959e$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $2111b2a4c096959e$var$activeElement$1 = null, $2111b2a4c096959e$var$activeElementInst$1 = null;
function $2111b2a4c096959e$var$runEventInBatch(dispatchQueue) {
    $2111b2a4c096959e$var$processDispatchQueue(dispatchQueue, 0);
}
function $2111b2a4c096959e$var$getInstIfValueChanged(targetInst) {
    var targetNode = $2111b2a4c096959e$var$getNodeFromInstance(targetInst);
    if ($2111b2a4c096959e$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $2111b2a4c096959e$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $2111b2a4c096959e$var$isInputEventSupported = !1;
if ($2111b2a4c096959e$var$canUseDOM) {
    var $2111b2a4c096959e$var$JSCompiler_inline_result$jscomp$282;
    if ($2111b2a4c096959e$var$canUseDOM) {
        var $2111b2a4c096959e$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$2111b2a4c096959e$var$isSupported$jscomp$inline_417) {
            var $2111b2a4c096959e$var$element$jscomp$inline_418 = document.createElement("div");
            $2111b2a4c096959e$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $2111b2a4c096959e$var$isSupported$jscomp$inline_417 = "function" === typeof $2111b2a4c096959e$var$element$jscomp$inline_418.oninput;
        }
        $2111b2a4c096959e$var$JSCompiler_inline_result$jscomp$282 = $2111b2a4c096959e$var$isSupported$jscomp$inline_417;
    } else $2111b2a4c096959e$var$JSCompiler_inline_result$jscomp$282 = !1;
    $2111b2a4c096959e$var$isInputEventSupported = $2111b2a4c096959e$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $2111b2a4c096959e$var$stopWatchingForValueChange() {
    $2111b2a4c096959e$var$activeElement$1 && ($2111b2a4c096959e$var$activeElement$1.detachEvent("onpropertychange", $2111b2a4c096959e$var$handlePropertyChange), $2111b2a4c096959e$var$activeElementInst$1 = $2111b2a4c096959e$var$activeElement$1 = null);
}
function $2111b2a4c096959e$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $2111b2a4c096959e$var$getInstIfValueChanged($2111b2a4c096959e$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $2111b2a4c096959e$var$createAndAccumulateChangeEvent(dispatchQueue, $2111b2a4c096959e$var$activeElementInst$1, nativeEvent, $2111b2a4c096959e$var$getEventTarget(nativeEvent));
        $2111b2a4c096959e$var$batchedUpdates$1($2111b2a4c096959e$var$runEventInBatch, dispatchQueue);
    }
}
function $2111b2a4c096959e$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($2111b2a4c096959e$var$stopWatchingForValueChange(), $2111b2a4c096959e$var$activeElement$1 = target, $2111b2a4c096959e$var$activeElementInst$1 = targetInst, $2111b2a4c096959e$var$activeElement$1.attachEvent("onpropertychange", $2111b2a4c096959e$var$handlePropertyChange)) : "focusout" === domEventName && $2111b2a4c096959e$var$stopWatchingForValueChange();
}
function $2111b2a4c096959e$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $2111b2a4c096959e$var$getInstIfValueChanged($2111b2a4c096959e$var$activeElementInst$1);
}
function $2111b2a4c096959e$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $2111b2a4c096959e$var$getInstIfValueChanged(targetInst);
}
function $2111b2a4c096959e$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $2111b2a4c096959e$var$getInstIfValueChanged(targetInst);
}
function $2111b2a4c096959e$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $2111b2a4c096959e$var$objectIs = "function" === typeof Object.is ? Object.is : $2111b2a4c096959e$var$is;
function $2111b2a4c096959e$var$shallowEqual(objA, objB) {
    if ($2111b2a4c096959e$var$objectIs(objA, objB)) return !0;
    if ("object" !== (typeof objA === "undefined" ? "undefined" : (0, $6zqIC._)(objA)) || null === objA || "object" !== (typeof objB === "undefined" ? "undefined" : (0, $6zqIC._)(objB)) || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$2111b2a4c096959e$var$hasOwnProperty.call(objB, currentKey) || !$2111b2a4c096959e$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $2111b2a4c096959e$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $2111b2a4c096959e$var$getNodeForCharacterOffset(root, offset) {
    var node = $2111b2a4c096959e$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $2111b2a4c096959e$var$getLeafNode(node);
    }
}
function $2111b2a4c096959e$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $2111b2a4c096959e$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $2111b2a4c096959e$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $2111b2a4c096959e$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $2111b2a4c096959e$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $2111b2a4c096959e$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $2111b2a4c096959e$var$skipSelectionChangeEvent = $2111b2a4c096959e$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $2111b2a4c096959e$var$activeElement = null, $2111b2a4c096959e$var$activeElementInst = null, $2111b2a4c096959e$var$lastSelection = null, $2111b2a4c096959e$var$mouseDown = !1;
function $2111b2a4c096959e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $2111b2a4c096959e$var$mouseDown || null == $2111b2a4c096959e$var$activeElement || $2111b2a4c096959e$var$activeElement !== $2111b2a4c096959e$var$getActiveElement(doc) || (doc = $2111b2a4c096959e$var$activeElement, "selectionStart" in doc && $2111b2a4c096959e$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $2111b2a4c096959e$var$lastSelection && $2111b2a4c096959e$var$shallowEqual($2111b2a4c096959e$var$lastSelection, doc) || ($2111b2a4c096959e$var$lastSelection = doc, doc = $2111b2a4c096959e$var$accumulateTwoPhaseListeners($2111b2a4c096959e$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $2111b2a4c096959e$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $2111b2a4c096959e$var$activeElement)));
}
function $2111b2a4c096959e$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $2111b2a4c096959e$var$vendorPrefixes = {
    animationend: $2111b2a4c096959e$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $2111b2a4c096959e$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $2111b2a4c096959e$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $2111b2a4c096959e$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $2111b2a4c096959e$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $2111b2a4c096959e$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $2111b2a4c096959e$var$makePrefixMap("Transition", "TransitionEnd")
}, $2111b2a4c096959e$var$prefixedEventNames = {}, $2111b2a4c096959e$var$style = {};
$2111b2a4c096959e$var$canUseDOM && ($2111b2a4c096959e$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $2111b2a4c096959e$var$vendorPrefixes.animationend.animation, delete $2111b2a4c096959e$var$vendorPrefixes.animationiteration.animation, delete $2111b2a4c096959e$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $2111b2a4c096959e$var$vendorPrefixes.transitionend.transition);
function $2111b2a4c096959e$var$getVendorPrefixedEventName(eventName) {
    if ($2111b2a4c096959e$var$prefixedEventNames[eventName]) return $2111b2a4c096959e$var$prefixedEventNames[eventName];
    if (!$2111b2a4c096959e$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $2111b2a4c096959e$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $2111b2a4c096959e$var$style) return $2111b2a4c096959e$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $2111b2a4c096959e$var$ANIMATION_END = $2111b2a4c096959e$var$getVendorPrefixedEventName("animationend"), $2111b2a4c096959e$var$ANIMATION_ITERATION = $2111b2a4c096959e$var$getVendorPrefixedEventName("animationiteration"), $2111b2a4c096959e$var$ANIMATION_START = $2111b2a4c096959e$var$getVendorPrefixedEventName("animationstart"), $2111b2a4c096959e$var$TRANSITION_RUN = $2111b2a4c096959e$var$getVendorPrefixedEventName("transitionrun"), $2111b2a4c096959e$var$TRANSITION_START = $2111b2a4c096959e$var$getVendorPrefixedEventName("transitionstart"), $2111b2a4c096959e$var$TRANSITION_CANCEL = $2111b2a4c096959e$var$getVendorPrefixedEventName("transitioncancel"), $2111b2a4c096959e$var$TRANSITION_END = $2111b2a4c096959e$var$getVendorPrefixedEventName("transitionend"), $2111b2a4c096959e$var$topLevelEventsToReactNames = new Map(), $2111b2a4c096959e$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$2111b2a4c096959e$var$simpleEventPluginEvents.push("scrollEnd");
function $2111b2a4c096959e$var$registerSimpleEvent(domEventName, reactName) {
    $2111b2a4c096959e$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $2111b2a4c096959e$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $2111b2a4c096959e$var$CapturedStacks = new WeakMap();
function $2111b2a4c096959e$var$createCapturedValueAtFiber(value, source) {
    if ("object" === (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) && null !== value) {
        var existing = $2111b2a4c096959e$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $2111b2a4c096959e$var$getStackByFiberInDevAndProd(source)
        };
        $2111b2a4c096959e$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $2111b2a4c096959e$var$getStackByFiberInDevAndProd(source)
    };
}
var $2111b2a4c096959e$var$concurrentQueues = [], $2111b2a4c096959e$var$concurrentQueuesIndex = 0, $2111b2a4c096959e$var$concurrentlyUpdatedLanes = 0;
function $2111b2a4c096959e$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $2111b2a4c096959e$var$concurrentQueuesIndex, i = $2111b2a4c096959e$var$concurrentlyUpdatedLanes = $2111b2a4c096959e$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $2111b2a4c096959e$var$concurrentQueues[i];
        $2111b2a4c096959e$var$concurrentQueues[i++] = null;
        var queue = $2111b2a4c096959e$var$concurrentQueues[i];
        $2111b2a4c096959e$var$concurrentQueues[i++] = null;
        var update = $2111b2a4c096959e$var$concurrentQueues[i];
        $2111b2a4c096959e$var$concurrentQueues[i++] = null;
        var lane = $2111b2a4c096959e$var$concurrentQueues[i];
        $2111b2a4c096959e$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $2111b2a4c096959e$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $2111b2a4c096959e$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $2111b2a4c096959e$var$concurrentQueues[$2111b2a4c096959e$var$concurrentQueuesIndex++] = fiber;
    $2111b2a4c096959e$var$concurrentQueues[$2111b2a4c096959e$var$concurrentQueuesIndex++] = queue;
    $2111b2a4c096959e$var$concurrentQueues[$2111b2a4c096959e$var$concurrentQueuesIndex++] = update;
    $2111b2a4c096959e$var$concurrentQueues[$2111b2a4c096959e$var$concurrentQueuesIndex++] = lane;
    $2111b2a4c096959e$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $2111b2a4c096959e$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $2111b2a4c096959e$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $2111b2a4c096959e$var$getRootForUpdatedFiber(fiber);
}
function $2111b2a4c096959e$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $2111b2a4c096959e$var$enqueueUpdate$1(fiber, null, null, lane);
    return $2111b2a4c096959e$var$getRootForUpdatedFiber(fiber);
}
function $2111b2a4c096959e$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $2111b2a4c096959e$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $2111b2a4c096959e$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $2111b2a4c096959e$var$nestedUpdateCount) throw $2111b2a4c096959e$var$nestedUpdateCount = 0, $2111b2a4c096959e$var$rootWithNestedUpdates = null, Error($2111b2a4c096959e$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $2111b2a4c096959e$var$emptyContextObject = {};
function $2111b2a4c096959e$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $2111b2a4c096959e$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $2111b2a4c096959e$var$FiberNode(tag, pendingProps, key, mode);
}
function $2111b2a4c096959e$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $2111b2a4c096959e$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $2111b2a4c096959e$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $2111b2a4c096959e$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $2111b2a4c096959e$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $2111b2a4c096959e$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $2111b2a4c096959e$var$isHostHoistableType(type, pendingProps, $2111b2a4c096959e$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $2111b2a4c096959e$var$REACT_ACTIVITY_TYPE:
            return type = $2111b2a4c096959e$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $2111b2a4c096959e$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $2111b2a4c096959e$var$REACT_FRAGMENT_TYPE:
            return $2111b2a4c096959e$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $2111b2a4c096959e$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $2111b2a4c096959e$var$REACT_PROFILER_TYPE:
            return type = $2111b2a4c096959e$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $2111b2a4c096959e$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $2111b2a4c096959e$var$REACT_SUSPENSE_TYPE:
            return type = $2111b2a4c096959e$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $2111b2a4c096959e$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $2111b2a4c096959e$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $2111b2a4c096959e$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $2111b2a4c096959e$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === (typeof type === "undefined" ? "undefined" : (0, $6zqIC._)(type)) && null !== type) switch(type.$$typeof){
                case $2111b2a4c096959e$var$REACT_PROVIDER_TYPE:
                case $2111b2a4c096959e$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $2111b2a4c096959e$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $2111b2a4c096959e$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $2111b2a4c096959e$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $2111b2a4c096959e$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($2111b2a4c096959e$var$formatProdErrorMessage(130, null === type ? "null" : typeof type === "undefined" ? "undefined" : (0, $6zqIC._)(type), ""));
            owner = null;
    }
    key = $2111b2a4c096959e$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $2111b2a4c096959e$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $2111b2a4c096959e$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $2111b2a4c096959e$var$createFiberFromText(content, mode, lanes) {
    content = $2111b2a4c096959e$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $2111b2a4c096959e$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $2111b2a4c096959e$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $2111b2a4c096959e$var$forkStack = [], $2111b2a4c096959e$var$forkStackIndex = 0, $2111b2a4c096959e$var$treeForkProvider = null, $2111b2a4c096959e$var$treeForkCount = 0, $2111b2a4c096959e$var$idStack = [], $2111b2a4c096959e$var$idStackIndex = 0, $2111b2a4c096959e$var$treeContextProvider = null, $2111b2a4c096959e$var$treeContextId = 1, $2111b2a4c096959e$var$treeContextOverflow = "";
function $2111b2a4c096959e$var$pushTreeFork(workInProgress, totalChildren) {
    $2111b2a4c096959e$var$forkStack[$2111b2a4c096959e$var$forkStackIndex++] = $2111b2a4c096959e$var$treeForkCount;
    $2111b2a4c096959e$var$forkStack[$2111b2a4c096959e$var$forkStackIndex++] = $2111b2a4c096959e$var$treeForkProvider;
    $2111b2a4c096959e$var$treeForkProvider = workInProgress;
    $2111b2a4c096959e$var$treeForkCount = totalChildren;
}
function $2111b2a4c096959e$var$pushTreeId(workInProgress, totalChildren, index) {
    $2111b2a4c096959e$var$idStack[$2111b2a4c096959e$var$idStackIndex++] = $2111b2a4c096959e$var$treeContextId;
    $2111b2a4c096959e$var$idStack[$2111b2a4c096959e$var$idStackIndex++] = $2111b2a4c096959e$var$treeContextOverflow;
    $2111b2a4c096959e$var$idStack[$2111b2a4c096959e$var$idStackIndex++] = $2111b2a4c096959e$var$treeContextProvider;
    $2111b2a4c096959e$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $2111b2a4c096959e$var$treeContextId;
    workInProgress = $2111b2a4c096959e$var$treeContextOverflow;
    var baseLength = 32 - $2111b2a4c096959e$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $2111b2a4c096959e$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $2111b2a4c096959e$var$treeContextId = 1 << 32 - $2111b2a4c096959e$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $2111b2a4c096959e$var$treeContextOverflow = length + workInProgress;
    } else $2111b2a4c096959e$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $2111b2a4c096959e$var$treeContextOverflow = workInProgress;
}
function $2111b2a4c096959e$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($2111b2a4c096959e$var$pushTreeFork(workInProgress, 1), $2111b2a4c096959e$var$pushTreeId(workInProgress, 1, 0));
}
function $2111b2a4c096959e$var$popTreeContext(workInProgress) {
    for(; workInProgress === $2111b2a4c096959e$var$treeForkProvider;)$2111b2a4c096959e$var$treeForkProvider = $2111b2a4c096959e$var$forkStack[--$2111b2a4c096959e$var$forkStackIndex], $2111b2a4c096959e$var$forkStack[$2111b2a4c096959e$var$forkStackIndex] = null, $2111b2a4c096959e$var$treeForkCount = $2111b2a4c096959e$var$forkStack[--$2111b2a4c096959e$var$forkStackIndex], $2111b2a4c096959e$var$forkStack[$2111b2a4c096959e$var$forkStackIndex] = null;
    for(; workInProgress === $2111b2a4c096959e$var$treeContextProvider;)$2111b2a4c096959e$var$treeContextProvider = $2111b2a4c096959e$var$idStack[--$2111b2a4c096959e$var$idStackIndex], $2111b2a4c096959e$var$idStack[$2111b2a4c096959e$var$idStackIndex] = null, $2111b2a4c096959e$var$treeContextOverflow = $2111b2a4c096959e$var$idStack[--$2111b2a4c096959e$var$idStackIndex], $2111b2a4c096959e$var$idStack[$2111b2a4c096959e$var$idStackIndex] = null, $2111b2a4c096959e$var$treeContextId = $2111b2a4c096959e$var$idStack[--$2111b2a4c096959e$var$idStackIndex], $2111b2a4c096959e$var$idStack[$2111b2a4c096959e$var$idStackIndex] = null;
}
var $2111b2a4c096959e$var$hydrationParentFiber = null, $2111b2a4c096959e$var$nextHydratableInstance = null, $2111b2a4c096959e$var$isHydrating = !1, $2111b2a4c096959e$var$hydrationErrors = null, $2111b2a4c096959e$var$rootOrSingletonContext = !1, $2111b2a4c096959e$var$HydrationMismatchException = Error($2111b2a4c096959e$var$formatProdErrorMessage(519));
function $2111b2a4c096959e$var$throwOnHydrationMismatch(fiber) {
    var error = Error($2111b2a4c096959e$var$formatProdErrorMessage(418, ""));
    $2111b2a4c096959e$var$queueHydrationError($2111b2a4c096959e$var$createCapturedValueAtFiber(error, fiber));
    throw $2111b2a4c096959e$var$HydrationMismatchException;
}
function $2111b2a4c096959e$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$2111b2a4c096959e$var$internalInstanceKey] = fiber;
    instance[$2111b2a4c096959e$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("cancel", instance);
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $2111b2a4c096959e$var$mediaEventTypes.length; type++)$2111b2a4c096959e$var$listenToNonDelegatedEvent($2111b2a4c096959e$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("error", instance);
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("invalid", instance);
            $2111b2a4c096959e$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $2111b2a4c096959e$var$track(instance);
            break;
        case "select":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("invalid", instance), $2111b2a4c096959e$var$initTextarea(instance, props.value, props.defaultValue, props.children), $2111b2a4c096959e$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== (typeof type === "undefined" ? "undefined" : (0, $6zqIC._)(type)) || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $2111b2a4c096959e$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($2111b2a4c096959e$var$listenToNonDelegatedEvent("beforetoggle", instance), $2111b2a4c096959e$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $2111b2a4c096959e$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $2111b2a4c096959e$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $2111b2a4c096959e$var$noop$1), instance = !0) : instance = !1;
    instance || $2111b2a4c096959e$var$throwOnHydrationMismatch(fiber);
}
function $2111b2a4c096959e$var$popToNextHostParent(fiber) {
    for($2111b2a4c096959e$var$hydrationParentFiber = fiber.return; $2111b2a4c096959e$var$hydrationParentFiber;)switch($2111b2a4c096959e$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $2111b2a4c096959e$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $2111b2a4c096959e$var$rootOrSingletonContext = !0;
            return;
        default:
            $2111b2a4c096959e$var$hydrationParentFiber = $2111b2a4c096959e$var$hydrationParentFiber.return;
    }
}
function $2111b2a4c096959e$var$popHydrationState(fiber) {
    if (fiber !== $2111b2a4c096959e$var$hydrationParentFiber) return !1;
    if (!$2111b2a4c096959e$var$isHydrating) return $2111b2a4c096959e$var$popToNextHostParent(fiber), $2111b2a4c096959e$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $2111b2a4c096959e$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $2111b2a4c096959e$var$nextHydratableInstance && $2111b2a4c096959e$var$throwOnHydrationMismatch(fiber);
    $2111b2a4c096959e$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $2111b2a4c096959e$var$nextHydratableInstance = $2111b2a4c096959e$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $2111b2a4c096959e$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $2111b2a4c096959e$var$nextHydratableInstance, $2111b2a4c096959e$var$isSingletonScope(fiber.type) ? (fiber = $2111b2a4c096959e$var$previousHydratableOnEnteringScopedSingleton, $2111b2a4c096959e$var$previousHydratableOnEnteringScopedSingleton = null, $2111b2a4c096959e$var$nextHydratableInstance = fiber) : $2111b2a4c096959e$var$nextHydratableInstance = tag) : $2111b2a4c096959e$var$nextHydratableInstance = $2111b2a4c096959e$var$hydrationParentFiber ? $2111b2a4c096959e$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $2111b2a4c096959e$var$resetHydrationState() {
    $2111b2a4c096959e$var$nextHydratableInstance = $2111b2a4c096959e$var$hydrationParentFiber = null;
    $2111b2a4c096959e$var$isHydrating = !1;
}
function $2111b2a4c096959e$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $2111b2a4c096959e$var$hydrationErrors;
    null !== queuedErrors && (null === $2111b2a4c096959e$var$workInProgressRootRecoverableErrors ? $2111b2a4c096959e$var$workInProgressRootRecoverableErrors = queuedErrors : $2111b2a4c096959e$var$workInProgressRootRecoverableErrors.push.apply($2111b2a4c096959e$var$workInProgressRootRecoverableErrors, queuedErrors), $2111b2a4c096959e$var$hydrationErrors = null);
    return queuedErrors;
}
function $2111b2a4c096959e$var$queueHydrationError(error) {
    null === $2111b2a4c096959e$var$hydrationErrors ? $2111b2a4c096959e$var$hydrationErrors = [
        error
    ] : $2111b2a4c096959e$var$hydrationErrors.push(error);
}
var $2111b2a4c096959e$var$valueCursor = $2111b2a4c096959e$var$createCursor(null), $2111b2a4c096959e$var$currentlyRenderingFiber$1 = null, $2111b2a4c096959e$var$lastContextDependency = null;
function $2111b2a4c096959e$var$pushProvider(providerFiber, context, nextValue) {
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $2111b2a4c096959e$var$popProvider(context) {
    context._currentValue = $2111b2a4c096959e$var$valueCursor.current;
    $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$valueCursor);
}
function $2111b2a4c096959e$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $2111b2a4c096959e$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $2111b2a4c096959e$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $2111b2a4c096959e$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $2111b2a4c096959e$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $2111b2a4c096959e$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $2111b2a4c096959e$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($2111b2a4c096959e$var$HostTransitionContext) : current = [
                $2111b2a4c096959e$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $2111b2a4c096959e$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $2111b2a4c096959e$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$2111b2a4c096959e$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $2111b2a4c096959e$var$prepareToReadContext(workInProgress) {
    $2111b2a4c096959e$var$currentlyRenderingFiber$1 = workInProgress;
    $2111b2a4c096959e$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $2111b2a4c096959e$var$readContext(context) {
    return $2111b2a4c096959e$var$readContextForConsumer($2111b2a4c096959e$var$currentlyRenderingFiber$1, context);
}
function $2111b2a4c096959e$var$readContextDuringReconciliation(consumer, context) {
    null === $2111b2a4c096959e$var$currentlyRenderingFiber$1 && $2111b2a4c096959e$var$prepareToReadContext(consumer);
    return $2111b2a4c096959e$var$readContextForConsumer(consumer, context);
}
function $2111b2a4c096959e$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $2111b2a4c096959e$var$lastContextDependency) {
        if (null === consumer) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(308));
        $2111b2a4c096959e$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $2111b2a4c096959e$var$lastContextDependency = $2111b2a4c096959e$var$lastContextDependency.next = context;
    return value;
}
var $2111b2a4c096959e$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function AbortControllerLocal() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function addEventListener(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $2111b2a4c096959e$var$scheduleCallback$2 = $bv0px.unstable_scheduleCallback, $2111b2a4c096959e$var$NormalPriority = $bv0px.unstable_NormalPriority, $2111b2a4c096959e$var$CacheContext = {
    $$typeof: $2111b2a4c096959e$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $2111b2a4c096959e$var$createCache() {
    return {
        controller: new $2111b2a4c096959e$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $2111b2a4c096959e$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $2111b2a4c096959e$var$scheduleCallback$2($2111b2a4c096959e$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $2111b2a4c096959e$var$currentEntangledListeners = null, $2111b2a4c096959e$var$currentEntangledPendingCount = 0, $2111b2a4c096959e$var$currentEntangledLane = 0, $2111b2a4c096959e$var$currentEntangledActionThenable = null;
function $2111b2a4c096959e$var$entangleAsyncAction(transition, thenable) {
    if (null === $2111b2a4c096959e$var$currentEntangledListeners) {
        var entangledListeners = $2111b2a4c096959e$var$currentEntangledListeners = [];
        $2111b2a4c096959e$var$currentEntangledPendingCount = 0;
        $2111b2a4c096959e$var$currentEntangledLane = $2111b2a4c096959e$var$requestTransitionLane();
        $2111b2a4c096959e$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function then(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $2111b2a4c096959e$var$currentEntangledPendingCount++;
    thenable.then($2111b2a4c096959e$var$pingEngtangledActionScope, $2111b2a4c096959e$var$pingEngtangledActionScope);
    return thenable;
}
function $2111b2a4c096959e$var$pingEngtangledActionScope() {
    if (0 === --$2111b2a4c096959e$var$currentEntangledPendingCount && null !== $2111b2a4c096959e$var$currentEntangledListeners) {
        null !== $2111b2a4c096959e$var$currentEntangledActionThenable && ($2111b2a4c096959e$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $2111b2a4c096959e$var$currentEntangledListeners;
        $2111b2a4c096959e$var$currentEntangledListeners = null;
        $2111b2a4c096959e$var$currentEntangledLane = 0;
        $2111b2a4c096959e$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $2111b2a4c096959e$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function then(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $2111b2a4c096959e$var$prevOnStartTransitionFinish = $2111b2a4c096959e$var$ReactSharedInternals.S;
$2111b2a4c096959e$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $6zqIC._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && $2111b2a4c096959e$var$entangleAsyncAction(transition, returnValue);
    null !== $2111b2a4c096959e$var$prevOnStartTransitionFinish && $2111b2a4c096959e$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $2111b2a4c096959e$var$resumedCache = $2111b2a4c096959e$var$createCursor(null);
function $2111b2a4c096959e$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $2111b2a4c096959e$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $2111b2a4c096959e$var$workInProgressRoot.pooledCache;
}
function $2111b2a4c096959e$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $2111b2a4c096959e$var$push($2111b2a4c096959e$var$resumedCache, $2111b2a4c096959e$var$resumedCache.current) : $2111b2a4c096959e$var$push($2111b2a4c096959e$var$resumedCache, prevCachePool.pool);
}
function $2111b2a4c096959e$var$getSuspendedCache() {
    var cacheFromPool = $2111b2a4c096959e$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $2111b2a4c096959e$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $2111b2a4c096959e$var$SuspenseException = Error($2111b2a4c096959e$var$formatProdErrorMessage(460)), $2111b2a4c096959e$var$SuspenseyCommitException = Error($2111b2a4c096959e$var$formatProdErrorMessage(474)), $2111b2a4c096959e$var$SuspenseActionException = Error($2111b2a4c096959e$var$formatProdErrorMessage(542)), $2111b2a4c096959e$var$noopSuspenseyCommitThenable = {
    then: function then() {}
};
function $2111b2a4c096959e$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $2111b2a4c096959e$var$noop$3() {}
function $2111b2a4c096959e$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($2111b2a4c096959e$var$noop$3, $2111b2a4c096959e$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $2111b2a4c096959e$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($2111b2a4c096959e$var$noop$3, $2111b2a4c096959e$var$noop$3);
            else {
                thenableState = $2111b2a4c096959e$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $2111b2a4c096959e$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $2111b2a4c096959e$var$suspendedThenable = thenable;
            throw $2111b2a4c096959e$var$SuspenseException;
    }
}
var $2111b2a4c096959e$var$suspendedThenable = null;
function $2111b2a4c096959e$var$getSuspendedThenable() {
    if (null === $2111b2a4c096959e$var$suspendedThenable) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(459));
    var thenable = $2111b2a4c096959e$var$suspendedThenable;
    $2111b2a4c096959e$var$suspendedThenable = null;
    return thenable;
}
function $2111b2a4c096959e$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $2111b2a4c096959e$var$SuspenseException || rejectedReason === $2111b2a4c096959e$var$SuspenseActionException) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(483));
}
var $2111b2a4c096959e$var$hasForceUpdate = !1;
function $2111b2a4c096959e$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $2111b2a4c096959e$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $2111b2a4c096959e$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2111b2a4c096959e$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($2111b2a4c096959e$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $2111b2a4c096959e$var$getRootForUpdatedFiber(fiber);
        $2111b2a4c096959e$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $2111b2a4c096959e$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $2111b2a4c096959e$var$getRootForUpdatedFiber(fiber);
}
function $2111b2a4c096959e$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $2111b2a4c096959e$var$markRootEntangled(root, lane);
    }
}
function $2111b2a4c096959e$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $2111b2a4c096959e$var$didReadFromEntangledAsyncAction = !1;
function $2111b2a4c096959e$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($2111b2a4c096959e$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $2111b2a4c096959e$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $2111b2a4c096959e$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $2111b2a4c096959e$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $2111b2a4c096959e$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($2111b2a4c096959e$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $2111b2a4c096959e$var$currentEntangledLane && ($2111b2a4c096959e$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $2111b2a4c096959e$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $2111b2a4c096959e$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $2111b2a4c096959e$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $2111b2a4c096959e$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $2111b2a4c096959e$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$2111b2a4c096959e$var$callCallback(callbacks[updateQueue], context);
}
var $2111b2a4c096959e$var$currentTreeHiddenStackCursor = $2111b2a4c096959e$var$createCursor(null), $2111b2a4c096959e$var$prevEntangledRenderLanesCursor = $2111b2a4c096959e$var$createCursor(0);
function $2111b2a4c096959e$var$pushHiddenContext(fiber, context) {
    fiber = $2111b2a4c096959e$var$entangledRenderLanes;
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$prevEntangledRenderLanesCursor, fiber);
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$currentTreeHiddenStackCursor, context);
    $2111b2a4c096959e$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $2111b2a4c096959e$var$reuseHiddenContextOnStack() {
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$prevEntangledRenderLanesCursor, $2111b2a4c096959e$var$entangledRenderLanes);
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$currentTreeHiddenStackCursor, $2111b2a4c096959e$var$currentTreeHiddenStackCursor.current);
}
function $2111b2a4c096959e$var$popHiddenContext() {
    $2111b2a4c096959e$var$entangledRenderLanes = $2111b2a4c096959e$var$prevEntangledRenderLanesCursor.current;
    $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$currentTreeHiddenStackCursor);
    $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$prevEntangledRenderLanesCursor);
}
var $2111b2a4c096959e$var$renderLanes = 0, $2111b2a4c096959e$var$currentlyRenderingFiber = null, $2111b2a4c096959e$var$currentHook = null, $2111b2a4c096959e$var$workInProgressHook = null, $2111b2a4c096959e$var$didScheduleRenderPhaseUpdate = !1, $2111b2a4c096959e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $2111b2a4c096959e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $2111b2a4c096959e$var$localIdCounter = 0, $2111b2a4c096959e$var$thenableIndexCounter$1 = 0, $2111b2a4c096959e$var$thenableState$1 = null, $2111b2a4c096959e$var$globalClientIdCounter = 0;
function $2111b2a4c096959e$var$throwInvalidHookError() {
    throw Error($2111b2a4c096959e$var$formatProdErrorMessage(321));
}
function $2111b2a4c096959e$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$2111b2a4c096959e$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $2111b2a4c096959e$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $2111b2a4c096959e$var$renderLanes = nextRenderLanes;
    $2111b2a4c096959e$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $2111b2a4c096959e$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $2111b2a4c096959e$var$HooksDispatcherOnMount : $2111b2a4c096959e$var$HooksDispatcherOnUpdate;
    $2111b2a4c096959e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $2111b2a4c096959e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $2111b2a4c096959e$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $2111b2a4c096959e$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $2111b2a4c096959e$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $2111b2a4c096959e$var$finishRenderingHooks(current) {
    $2111b2a4c096959e$var$ReactSharedInternals.H = $2111b2a4c096959e$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $2111b2a4c096959e$var$currentHook && null !== $2111b2a4c096959e$var$currentHook.next;
    $2111b2a4c096959e$var$renderLanes = 0;
    $2111b2a4c096959e$var$workInProgressHook = $2111b2a4c096959e$var$currentHook = $2111b2a4c096959e$var$currentlyRenderingFiber = null;
    $2111b2a4c096959e$var$didScheduleRenderPhaseUpdate = !1;
    $2111b2a4c096959e$var$thenableIndexCounter$1 = 0;
    $2111b2a4c096959e$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(300));
    null === current || $2111b2a4c096959e$var$didReceiveUpdate || (current = current.dependencies, null !== current && $2111b2a4c096959e$var$checkIfContextChanged(current) && ($2111b2a4c096959e$var$didReceiveUpdate = !0));
}
function $2111b2a4c096959e$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $2111b2a4c096959e$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $2111b2a4c096959e$var$didScheduleRenderPhaseUpdateDuringThisPass && ($2111b2a4c096959e$var$thenableState$1 = null);
        $2111b2a4c096959e$var$thenableIndexCounter$1 = 0;
        $2111b2a4c096959e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $2111b2a4c096959e$var$workInProgressHook = $2111b2a4c096959e$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $2111b2a4c096959e$var$ReactSharedInternals.H = $2111b2a4c096959e$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($2111b2a4c096959e$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $2111b2a4c096959e$var$TransitionAwareHostComponent() {
    var dispatcher = $2111b2a4c096959e$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $2111b2a4c096959e$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $2111b2a4c096959e$var$currentHook ? $2111b2a4c096959e$var$currentHook.memoizedState : null) !== dispatcher && ($2111b2a4c096959e$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $2111b2a4c096959e$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $2111b2a4c096959e$var$localIdCounter;
    $2111b2a4c096959e$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $2111b2a4c096959e$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $2111b2a4c096959e$var$resetHooksOnUnwind(workInProgress) {
    if ($2111b2a4c096959e$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $2111b2a4c096959e$var$didScheduleRenderPhaseUpdate = !1;
    }
    $2111b2a4c096959e$var$renderLanes = 0;
    $2111b2a4c096959e$var$workInProgressHook = $2111b2a4c096959e$var$currentHook = $2111b2a4c096959e$var$currentlyRenderingFiber = null;
    $2111b2a4c096959e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $2111b2a4c096959e$var$thenableIndexCounter$1 = $2111b2a4c096959e$var$localIdCounter = 0;
    $2111b2a4c096959e$var$thenableState$1 = null;
}
function $2111b2a4c096959e$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2111b2a4c096959e$var$workInProgressHook ? $2111b2a4c096959e$var$currentlyRenderingFiber.memoizedState = $2111b2a4c096959e$var$workInProgressHook = hook : $2111b2a4c096959e$var$workInProgressHook = $2111b2a4c096959e$var$workInProgressHook.next = hook;
    return $2111b2a4c096959e$var$workInProgressHook;
}
function $2111b2a4c096959e$var$updateWorkInProgressHook() {
    if (null === $2111b2a4c096959e$var$currentHook) {
        var nextCurrentHook = $2111b2a4c096959e$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $2111b2a4c096959e$var$currentHook.next;
    var nextWorkInProgressHook = null === $2111b2a4c096959e$var$workInProgressHook ? $2111b2a4c096959e$var$currentlyRenderingFiber.memoizedState : $2111b2a4c096959e$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $2111b2a4c096959e$var$workInProgressHook = nextWorkInProgressHook, $2111b2a4c096959e$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $2111b2a4c096959e$var$currentlyRenderingFiber.alternate) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(467));
            throw Error($2111b2a4c096959e$var$formatProdErrorMessage(310));
        }
        $2111b2a4c096959e$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $2111b2a4c096959e$var$currentHook.memoizedState,
            baseState: $2111b2a4c096959e$var$currentHook.baseState,
            baseQueue: $2111b2a4c096959e$var$currentHook.baseQueue,
            queue: $2111b2a4c096959e$var$currentHook.queue,
            next: null
        };
        null === $2111b2a4c096959e$var$workInProgressHook ? $2111b2a4c096959e$var$currentlyRenderingFiber.memoizedState = $2111b2a4c096959e$var$workInProgressHook = nextCurrentHook : $2111b2a4c096959e$var$workInProgressHook = $2111b2a4c096959e$var$workInProgressHook.next = nextCurrentHook;
    }
    return $2111b2a4c096959e$var$workInProgressHook;
}
function $2111b2a4c096959e$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $2111b2a4c096959e$var$useThenable(thenable) {
    var index = $2111b2a4c096959e$var$thenableIndexCounter$1;
    $2111b2a4c096959e$var$thenableIndexCounter$1 += 1;
    null === $2111b2a4c096959e$var$thenableState$1 && ($2111b2a4c096959e$var$thenableState$1 = []);
    thenable = $2111b2a4c096959e$var$trackUsedThenable($2111b2a4c096959e$var$thenableState$1, thenable, index);
    index = $2111b2a4c096959e$var$currentlyRenderingFiber;
    null === (null === $2111b2a4c096959e$var$workInProgressHook ? index.memoizedState : $2111b2a4c096959e$var$workInProgressHook.next) && (index = index.alternate, $2111b2a4c096959e$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $2111b2a4c096959e$var$HooksDispatcherOnMount : $2111b2a4c096959e$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $2111b2a4c096959e$var$use(usable) {
    if (null !== usable && "object" === (typeof usable === "undefined" ? "undefined" : (0, $6zqIC._)(usable))) {
        if ("function" === typeof usable.then) return $2111b2a4c096959e$var$useThenable(usable);
        if (usable.$$typeof === $2111b2a4c096959e$var$REACT_CONTEXT_TYPE) return $2111b2a4c096959e$var$readContext(usable);
    }
    throw Error($2111b2a4c096959e$var$formatProdErrorMessage(438, String(usable)));
}
function $2111b2a4c096959e$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $2111b2a4c096959e$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $2111b2a4c096959e$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $2111b2a4c096959e$var$createFunctionComponentUpdateQueue(), $2111b2a4c096959e$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $2111b2a4c096959e$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $2111b2a4c096959e$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $2111b2a4c096959e$var$updateReducer(reducer) {
    var hook = $2111b2a4c096959e$var$updateWorkInProgressHook();
    return $2111b2a4c096959e$var$updateReducerImpl(hook, $2111b2a4c096959e$var$currentHook, reducer);
}
function $2111b2a4c096959e$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($2111b2a4c096959e$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($2111b2a4c096959e$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $2111b2a4c096959e$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($2111b2a4c096959e$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $2111b2a4c096959e$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $2111b2a4c096959e$var$currentlyRenderingFiber.lanes |= revertLane, $2111b2a4c096959e$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $2111b2a4c096959e$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $2111b2a4c096959e$var$currentlyRenderingFiber.lanes |= updateLane, $2111b2a4c096959e$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$2111b2a4c096959e$var$objectIs(pendingQueue, hook.memoizedState) && ($2111b2a4c096959e$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $2111b2a4c096959e$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $2111b2a4c096959e$var$rerenderReducer(reducer) {
    var hook = $2111b2a4c096959e$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $2111b2a4c096959e$var$objectIs(newState, hook.memoizedState) || ($2111b2a4c096959e$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $2111b2a4c096959e$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $2111b2a4c096959e$var$currentlyRenderingFiber, hook = $2111b2a4c096959e$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $2111b2a4c096959e$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$2111b2a4c096959e$var$objectIs(($2111b2a4c096959e$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $2111b2a4c096959e$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $2111b2a4c096959e$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $2111b2a4c096959e$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $2111b2a4c096959e$var$workInProgressHook && $2111b2a4c096959e$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $2111b2a4c096959e$var$pushSimpleEffect(9, $2111b2a4c096959e$var$createEffectInstance(), $2111b2a4c096959e$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $2111b2a4c096959e$var$workInProgressRoot) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($2111b2a4c096959e$var$renderLanes & 124) || $2111b2a4c096959e$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $2111b2a4c096959e$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $2111b2a4c096959e$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $2111b2a4c096959e$var$createFunctionComponentUpdateQueue(), $2111b2a4c096959e$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $2111b2a4c096959e$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $2111b2a4c096959e$var$checkIfSnapshotChanged(inst) && $2111b2a4c096959e$var$forceStoreRerender(fiber);
}
function $2111b2a4c096959e$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $2111b2a4c096959e$var$checkIfSnapshotChanged(inst) && $2111b2a4c096959e$var$forceStoreRerender(fiber);
    });
}
function $2111b2a4c096959e$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$2111b2a4c096959e$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $2111b2a4c096959e$var$forceStoreRerender(fiber) {
    var root = $2111b2a4c096959e$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $2111b2a4c096959e$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $2111b2a4c096959e$var$mountStateImpl(initialState) {
    var hook = $2111b2a4c096959e$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($2111b2a4c096959e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $2111b2a4c096959e$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $2111b2a4c096959e$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2111b2a4c096959e$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $2111b2a4c096959e$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $2111b2a4c096959e$var$updateReducerImpl(hook, $2111b2a4c096959e$var$currentHook, "function" === typeof reducer ? reducer : $2111b2a4c096959e$var$basicStateReducer);
}
function $2111b2a4c096959e$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($2111b2a4c096959e$var$isRenderPhaseUpdate(fiber)) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function then(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $2111b2a4c096959e$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $2111b2a4c096959e$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $2111b2a4c096959e$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $2111b2a4c096959e$var$ReactSharedInternals.T, currentTransition = {};
        $2111b2a4c096959e$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $2111b2a4c096959e$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $2111b2a4c096959e$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $2111b2a4c096959e$var$onActionError(actionQueue, node, error);
        } finally{
            $2111b2a4c096959e$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $2111b2a4c096959e$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $2111b2a4c096959e$var$onActionError(actionQueue, node, error$38);
    }
}
function $2111b2a4c096959e$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $6zqIC._)(returnValue)) && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $2111b2a4c096959e$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $2111b2a4c096959e$var$onActionError(actionQueue, node, error);
    }) : $2111b2a4c096959e$var$onActionSuccess(actionQueue, node, returnValue);
}
function $2111b2a4c096959e$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $2111b2a4c096959e$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $2111b2a4c096959e$var$runActionStateAction(actionQueue, nextState)));
}
function $2111b2a4c096959e$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $2111b2a4c096959e$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $2111b2a4c096959e$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $2111b2a4c096959e$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $2111b2a4c096959e$var$mountActionState(action, initialStateProp) {
    if ($2111b2a4c096959e$var$isHydrating) {
        var ssrFormState = $2111b2a4c096959e$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $2111b2a4c096959e$var$currentlyRenderingFiber;
                if ($2111b2a4c096959e$var$isHydrating) {
                    if ($2111b2a4c096959e$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $2111b2a4c096959e$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $2111b2a4c096959e$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $2111b2a4c096959e$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $2111b2a4c096959e$var$nextHydratableInstance = $2111b2a4c096959e$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $2111b2a4c096959e$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $2111b2a4c096959e$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2111b2a4c096959e$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $2111b2a4c096959e$var$dispatchSetState.bind(null, $2111b2a4c096959e$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $2111b2a4c096959e$var$mountStateImpl(!1);
    inRootOrSingleton = $2111b2a4c096959e$var$dispatchOptimisticSetState.bind(null, $2111b2a4c096959e$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $2111b2a4c096959e$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $2111b2a4c096959e$var$dispatchActionState.bind(null, $2111b2a4c096959e$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $2111b2a4c096959e$var$updateActionState(action) {
    var stateHook = $2111b2a4c096959e$var$updateWorkInProgressHook();
    return $2111b2a4c096959e$var$updateActionStateImpl(stateHook, $2111b2a4c096959e$var$currentHook, action);
}
function $2111b2a4c096959e$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $2111b2a4c096959e$var$updateReducerImpl(stateHook, currentStateHook, $2111b2a4c096959e$var$actionStateReducer)[0];
    stateHook = $2111b2a4c096959e$var$updateReducer($2111b2a4c096959e$var$basicStateReducer)[0];
    if ("object" === (typeof currentStateHook === "undefined" ? "undefined" : (0, $6zqIC._)(currentStateHook)) && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $2111b2a4c096959e$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $2111b2a4c096959e$var$SuspenseException) throw $2111b2a4c096959e$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $2111b2a4c096959e$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($2111b2a4c096959e$var$currentlyRenderingFiber.flags |= 2048, $2111b2a4c096959e$var$pushSimpleEffect(9, $2111b2a4c096959e$var$createEffectInstance(), $2111b2a4c096959e$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $2111b2a4c096959e$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $2111b2a4c096959e$var$rerenderActionState(action) {
    var stateHook = $2111b2a4c096959e$var$updateWorkInProgressHook(), currentStateHook = $2111b2a4c096959e$var$currentHook;
    if (null !== currentStateHook) return $2111b2a4c096959e$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $2111b2a4c096959e$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $2111b2a4c096959e$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $2111b2a4c096959e$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $2111b2a4c096959e$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $2111b2a4c096959e$var$createFunctionComponentUpdateQueue(), $2111b2a4c096959e$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $2111b2a4c096959e$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $2111b2a4c096959e$var$updateRef() {
    return $2111b2a4c096959e$var$updateWorkInProgressHook().memoizedState;
}
function $2111b2a4c096959e$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $2111b2a4c096959e$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $2111b2a4c096959e$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $2111b2a4c096959e$var$pushSimpleEffect(1 | hookFlags, $2111b2a4c096959e$var$createEffectInstance(), create, createDeps);
}
function $2111b2a4c096959e$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $2111b2a4c096959e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $2111b2a4c096959e$var$currentHook && null !== deps && $2111b2a4c096959e$var$areHookInputsEqual(deps, $2111b2a4c096959e$var$currentHook.memoizedState.deps) ? hook.memoizedState = $2111b2a4c096959e$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($2111b2a4c096959e$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $2111b2a4c096959e$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $2111b2a4c096959e$var$mountEffect(create, createDeps) {
    $2111b2a4c096959e$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $2111b2a4c096959e$var$updateEffect(create, createDeps) {
    $2111b2a4c096959e$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $2111b2a4c096959e$var$updateInsertionEffect(create, deps) {
    return $2111b2a4c096959e$var$updateEffectImpl(4, 2, create, deps);
}
function $2111b2a4c096959e$var$updateLayoutEffect(create, deps) {
    return $2111b2a4c096959e$var$updateEffectImpl(4, 4, create, deps);
}
function $2111b2a4c096959e$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $2111b2a4c096959e$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $2111b2a4c096959e$var$updateEffectImpl(4, 4, $2111b2a4c096959e$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $2111b2a4c096959e$var$mountDebugValue() {}
function $2111b2a4c096959e$var$updateCallback(callback, deps) {
    var hook = $2111b2a4c096959e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $2111b2a4c096959e$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $2111b2a4c096959e$var$updateMemo(nextCreate, deps) {
    var hook = $2111b2a4c096959e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $2111b2a4c096959e$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($2111b2a4c096959e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $2111b2a4c096959e$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $2111b2a4c096959e$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $2111b2a4c096959e$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($2111b2a4c096959e$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $2111b2a4c096959e$var$requestDeferredLane();
    $2111b2a4c096959e$var$currentlyRenderingFiber.lanes |= hook;
    $2111b2a4c096959e$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $2111b2a4c096959e$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($2111b2a4c096959e$var$objectIs(value, prevValue)) return value;
    if (null !== $2111b2a4c096959e$var$currentTreeHiddenStackCursor.current) return hook = $2111b2a4c096959e$var$mountDeferredValueImpl(hook, value, initialValue), $2111b2a4c096959e$var$objectIs(hook, prevValue) || ($2111b2a4c096959e$var$didReceiveUpdate = !0), hook;
    if (0 === ($2111b2a4c096959e$var$renderLanes & 42)) return $2111b2a4c096959e$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $2111b2a4c096959e$var$requestDeferredLane();
    $2111b2a4c096959e$var$currentlyRenderingFiber.lanes |= hook;
    $2111b2a4c096959e$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $2111b2a4c096959e$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $2111b2a4c096959e$var$ReactDOMSharedInternals.p;
    $2111b2a4c096959e$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $2111b2a4c096959e$var$ReactSharedInternals.T, currentTransition = {};
    $2111b2a4c096959e$var$ReactSharedInternals.T = currentTransition;
    $2111b2a4c096959e$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $2111b2a4c096959e$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $6zqIC._)(returnValue)) && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $2111b2a4c096959e$var$chainThenableValue(returnValue, finishedState);
            $2111b2a4c096959e$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $2111b2a4c096959e$var$requestUpdateLane(fiber));
        } else $2111b2a4c096959e$var$dispatchSetStateInternal(fiber, queue, finishedState, $2111b2a4c096959e$var$requestUpdateLane(fiber));
    } catch (error) {
        $2111b2a4c096959e$var$dispatchSetStateInternal(fiber, queue, {
            then: function then() {},
            status: "rejected",
            reason: error
        }, $2111b2a4c096959e$var$requestUpdateLane());
    } finally{
        $2111b2a4c096959e$var$ReactDOMSharedInternals.p = previousPriority, $2111b2a4c096959e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2111b2a4c096959e$var$noop$2() {}
function $2111b2a4c096959e$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(476));
    var queue = $2111b2a4c096959e$var$ensureFormComponentIsStateful(formFiber).queue;
    $2111b2a4c096959e$var$startTransition(formFiber, queue, pendingState, $2111b2a4c096959e$var$sharedNotPendingObject, null === action ? $2111b2a4c096959e$var$noop$2 : function() {
        $2111b2a4c096959e$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $2111b2a4c096959e$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $2111b2a4c096959e$var$sharedNotPendingObject,
        baseState: $2111b2a4c096959e$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $2111b2a4c096959e$var$basicStateReducer,
            lastRenderedState: $2111b2a4c096959e$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $2111b2a4c096959e$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $2111b2a4c096959e$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $2111b2a4c096959e$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $2111b2a4c096959e$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $2111b2a4c096959e$var$requestUpdateLane());
}
function $2111b2a4c096959e$var$useHostTransitionStatus() {
    return $2111b2a4c096959e$var$readContext($2111b2a4c096959e$var$HostTransitionContext);
}
function $2111b2a4c096959e$var$updateId() {
    return $2111b2a4c096959e$var$updateWorkInProgressHook().memoizedState;
}
function $2111b2a4c096959e$var$updateRefresh() {
    return $2111b2a4c096959e$var$updateWorkInProgressHook().memoizedState;
}
function $2111b2a4c096959e$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $2111b2a4c096959e$var$requestUpdateLane();
                fiber = $2111b2a4c096959e$var$createUpdate(lane);
                var root$41 = $2111b2a4c096959e$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($2111b2a4c096959e$var$scheduleUpdateOnFiber(root$41, provider, lane), $2111b2a4c096959e$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $2111b2a4c096959e$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $2111b2a4c096959e$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $2111b2a4c096959e$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $2111b2a4c096959e$var$isRenderPhaseUpdate(fiber) ? $2111b2a4c096959e$var$enqueueRenderPhaseUpdate(queue, action) : (action = $2111b2a4c096959e$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($2111b2a4c096959e$var$scheduleUpdateOnFiber(action, fiber, lane), $2111b2a4c096959e$var$entangleTransitionUpdate(action, queue, lane)));
}
function $2111b2a4c096959e$var$dispatchSetState(fiber, queue, action) {
    var lane = $2111b2a4c096959e$var$requestUpdateLane();
    $2111b2a4c096959e$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $2111b2a4c096959e$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2111b2a4c096959e$var$isRenderPhaseUpdate(fiber)) $2111b2a4c096959e$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($2111b2a4c096959e$var$objectIs(eagerState, currentState)) return $2111b2a4c096959e$var$enqueueUpdate$1(fiber, queue, update, 0), null === $2111b2a4c096959e$var$workInProgressRoot && $2111b2a4c096959e$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $2111b2a4c096959e$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $2111b2a4c096959e$var$scheduleUpdateOnFiber(action, fiber, lane), $2111b2a4c096959e$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $2111b2a4c096959e$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $2111b2a4c096959e$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2111b2a4c096959e$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $2111b2a4c096959e$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $2111b2a4c096959e$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $2111b2a4c096959e$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $2111b2a4c096959e$var$currentlyRenderingFiber || null !== alternate && alternate === $2111b2a4c096959e$var$currentlyRenderingFiber;
}
function $2111b2a4c096959e$var$enqueueRenderPhaseUpdate(queue, update) {
    $2111b2a4c096959e$var$didScheduleRenderPhaseUpdateDuringThisPass = $2111b2a4c096959e$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $2111b2a4c096959e$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $2111b2a4c096959e$var$markRootEntangled(root, lane);
    }
}
var $2111b2a4c096959e$var$ContextOnlyDispatcher = {
    readContext: $2111b2a4c096959e$var$readContext,
    use: $2111b2a4c096959e$var$use,
    useCallback: $2111b2a4c096959e$var$throwInvalidHookError,
    useContext: $2111b2a4c096959e$var$throwInvalidHookError,
    useEffect: $2111b2a4c096959e$var$throwInvalidHookError,
    useImperativeHandle: $2111b2a4c096959e$var$throwInvalidHookError,
    useLayoutEffect: $2111b2a4c096959e$var$throwInvalidHookError,
    useInsertionEffect: $2111b2a4c096959e$var$throwInvalidHookError,
    useMemo: $2111b2a4c096959e$var$throwInvalidHookError,
    useReducer: $2111b2a4c096959e$var$throwInvalidHookError,
    useRef: $2111b2a4c096959e$var$throwInvalidHookError,
    useState: $2111b2a4c096959e$var$throwInvalidHookError,
    useDebugValue: $2111b2a4c096959e$var$throwInvalidHookError,
    useDeferredValue: $2111b2a4c096959e$var$throwInvalidHookError,
    useTransition: $2111b2a4c096959e$var$throwInvalidHookError,
    useSyncExternalStore: $2111b2a4c096959e$var$throwInvalidHookError,
    useId: $2111b2a4c096959e$var$throwInvalidHookError,
    useHostTransitionStatus: $2111b2a4c096959e$var$throwInvalidHookError,
    useFormState: $2111b2a4c096959e$var$throwInvalidHookError,
    useActionState: $2111b2a4c096959e$var$throwInvalidHookError,
    useOptimistic: $2111b2a4c096959e$var$throwInvalidHookError,
    useMemoCache: $2111b2a4c096959e$var$throwInvalidHookError,
    useCacheRefresh: $2111b2a4c096959e$var$throwInvalidHookError
}, $2111b2a4c096959e$var$HooksDispatcherOnMount = {
    readContext: $2111b2a4c096959e$var$readContext,
    use: $2111b2a4c096959e$var$use,
    useCallback: function useCallback(callback, deps) {
        $2111b2a4c096959e$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $2111b2a4c096959e$var$readContext,
    useEffect: $2111b2a4c096959e$var$mountEffect,
    useImperativeHandle: function useImperativeHandle(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $2111b2a4c096959e$var$mountEffectImpl(4194308, 4, $2111b2a4c096959e$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function useLayoutEffect(create, deps) {
        return $2111b2a4c096959e$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function useInsertionEffect(create, deps) {
        $2111b2a4c096959e$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function useMemo(nextCreate, deps) {
        var hook = $2111b2a4c096959e$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($2111b2a4c096959e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $2111b2a4c096959e$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $2111b2a4c096959e$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function useReducer(reducer, initialArg, init) {
        var hook = $2111b2a4c096959e$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($2111b2a4c096959e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $2111b2a4c096959e$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $2111b2a4c096959e$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $2111b2a4c096959e$var$dispatchReducerAction.bind(null, $2111b2a4c096959e$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function useRef(initialValue) {
        var hook = $2111b2a4c096959e$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function useState(initialState) {
        initialState = $2111b2a4c096959e$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $2111b2a4c096959e$var$dispatchSetState.bind(null, $2111b2a4c096959e$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $2111b2a4c096959e$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $2111b2a4c096959e$var$mountWorkInProgressHook();
        return $2111b2a4c096959e$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function useTransition() {
        var stateHook = $2111b2a4c096959e$var$mountStateImpl(!1);
        stateHook = $2111b2a4c096959e$var$startTransition.bind(null, $2111b2a4c096959e$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $2111b2a4c096959e$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $2111b2a4c096959e$var$currentlyRenderingFiber, hook = $2111b2a4c096959e$var$mountWorkInProgressHook();
        if ($2111b2a4c096959e$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $2111b2a4c096959e$var$workInProgressRoot) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(349));
            0 !== ($2111b2a4c096959e$var$workInProgressRootRenderLanes & 124) || $2111b2a4c096959e$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $2111b2a4c096959e$var$mountEffect($2111b2a4c096959e$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $2111b2a4c096959e$var$pushSimpleEffect(9, $2111b2a4c096959e$var$createEffectInstance(), $2111b2a4c096959e$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function useId() {
        var hook = $2111b2a4c096959e$var$mountWorkInProgressHook(), identifierPrefix = $2111b2a4c096959e$var$workInProgressRoot.identifierPrefix;
        if ($2111b2a4c096959e$var$isHydrating) {
            var JSCompiler_inline_result = $2111b2a4c096959e$var$treeContextOverflow;
            var idWithLeadingBit = $2111b2a4c096959e$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $2111b2a4c096959e$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $2111b2a4c096959e$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $2111b2a4c096959e$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $2111b2a4c096959e$var$useHostTransitionStatus,
    useFormState: $2111b2a4c096959e$var$mountActionState,
    useActionState: $2111b2a4c096959e$var$mountActionState,
    useOptimistic: function useOptimistic(passthrough) {
        var hook = $2111b2a4c096959e$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $2111b2a4c096959e$var$dispatchOptimisticSetState.bind(null, $2111b2a4c096959e$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $2111b2a4c096959e$var$useMemoCache,
    useCacheRefresh: function useCacheRefresh() {
        return $2111b2a4c096959e$var$mountWorkInProgressHook().memoizedState = $2111b2a4c096959e$var$refreshCache.bind(null, $2111b2a4c096959e$var$currentlyRenderingFiber);
    }
}, $2111b2a4c096959e$var$HooksDispatcherOnUpdate = {
    readContext: $2111b2a4c096959e$var$readContext,
    use: $2111b2a4c096959e$var$use,
    useCallback: $2111b2a4c096959e$var$updateCallback,
    useContext: $2111b2a4c096959e$var$readContext,
    useEffect: $2111b2a4c096959e$var$updateEffect,
    useImperativeHandle: $2111b2a4c096959e$var$updateImperativeHandle,
    useInsertionEffect: $2111b2a4c096959e$var$updateInsertionEffect,
    useLayoutEffect: $2111b2a4c096959e$var$updateLayoutEffect,
    useMemo: $2111b2a4c096959e$var$updateMemo,
    useReducer: $2111b2a4c096959e$var$updateReducer,
    useRef: $2111b2a4c096959e$var$updateRef,
    useState: function useState() {
        return $2111b2a4c096959e$var$updateReducer($2111b2a4c096959e$var$basicStateReducer);
    },
    useDebugValue: $2111b2a4c096959e$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $2111b2a4c096959e$var$updateWorkInProgressHook();
        return $2111b2a4c096959e$var$updateDeferredValueImpl(hook, $2111b2a4c096959e$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $2111b2a4c096959e$var$updateReducer($2111b2a4c096959e$var$basicStateReducer)[0], start = $2111b2a4c096959e$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $2111b2a4c096959e$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $2111b2a4c096959e$var$updateSyncExternalStore,
    useId: $2111b2a4c096959e$var$updateId,
    useHostTransitionStatus: $2111b2a4c096959e$var$useHostTransitionStatus,
    useFormState: $2111b2a4c096959e$var$updateActionState,
    useActionState: $2111b2a4c096959e$var$updateActionState,
    useOptimistic: function useOptimistic(passthrough, reducer) {
        var hook = $2111b2a4c096959e$var$updateWorkInProgressHook();
        return $2111b2a4c096959e$var$updateOptimisticImpl(hook, $2111b2a4c096959e$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $2111b2a4c096959e$var$useMemoCache,
    useCacheRefresh: $2111b2a4c096959e$var$updateRefresh
}, $2111b2a4c096959e$var$HooksDispatcherOnRerender = {
    readContext: $2111b2a4c096959e$var$readContext,
    use: $2111b2a4c096959e$var$use,
    useCallback: $2111b2a4c096959e$var$updateCallback,
    useContext: $2111b2a4c096959e$var$readContext,
    useEffect: $2111b2a4c096959e$var$updateEffect,
    useImperativeHandle: $2111b2a4c096959e$var$updateImperativeHandle,
    useInsertionEffect: $2111b2a4c096959e$var$updateInsertionEffect,
    useLayoutEffect: $2111b2a4c096959e$var$updateLayoutEffect,
    useMemo: $2111b2a4c096959e$var$updateMemo,
    useReducer: $2111b2a4c096959e$var$rerenderReducer,
    useRef: $2111b2a4c096959e$var$updateRef,
    useState: function useState() {
        return $2111b2a4c096959e$var$rerenderReducer($2111b2a4c096959e$var$basicStateReducer);
    },
    useDebugValue: $2111b2a4c096959e$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $2111b2a4c096959e$var$updateWorkInProgressHook();
        return null === $2111b2a4c096959e$var$currentHook ? $2111b2a4c096959e$var$mountDeferredValueImpl(hook, value, initialValue) : $2111b2a4c096959e$var$updateDeferredValueImpl(hook, $2111b2a4c096959e$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $2111b2a4c096959e$var$rerenderReducer($2111b2a4c096959e$var$basicStateReducer)[0], start = $2111b2a4c096959e$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $2111b2a4c096959e$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $2111b2a4c096959e$var$updateSyncExternalStore,
    useId: $2111b2a4c096959e$var$updateId,
    useHostTransitionStatus: $2111b2a4c096959e$var$useHostTransitionStatus,
    useFormState: $2111b2a4c096959e$var$rerenderActionState,
    useActionState: $2111b2a4c096959e$var$rerenderActionState,
    useOptimistic: function useOptimistic(passthrough, reducer) {
        var hook = $2111b2a4c096959e$var$updateWorkInProgressHook();
        if (null !== $2111b2a4c096959e$var$currentHook) return $2111b2a4c096959e$var$updateOptimisticImpl(hook, $2111b2a4c096959e$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $2111b2a4c096959e$var$useMemoCache,
    useCacheRefresh: $2111b2a4c096959e$var$updateRefresh
}, $2111b2a4c096959e$var$thenableState = null, $2111b2a4c096959e$var$thenableIndexCounter = 0;
function $2111b2a4c096959e$var$unwrapThenable(thenable) {
    var index = $2111b2a4c096959e$var$thenableIndexCounter;
    $2111b2a4c096959e$var$thenableIndexCounter += 1;
    null === $2111b2a4c096959e$var$thenableState && ($2111b2a4c096959e$var$thenableState = []);
    return $2111b2a4c096959e$var$trackUsedThenable($2111b2a4c096959e$var$thenableState, thenable, index);
}
function $2111b2a4c096959e$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $2111b2a4c096959e$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $2111b2a4c096959e$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($2111b2a4c096959e$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $2111b2a4c096959e$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $2111b2a4c096959e$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $2111b2a4c096959e$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $2111b2a4c096959e$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $2111b2a4c096959e$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === (typeof elementType === "undefined" ? "undefined" : (0, $6zqIC._)(elementType)) && null !== elementType && elementType.$$typeof === $2111b2a4c096959e$var$REACT_LAZY_TYPE && $2111b2a4c096959e$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $2111b2a4c096959e$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $2111b2a4c096959e$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $2111b2a4c096959e$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $2111b2a4c096959e$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $2111b2a4c096959e$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $6zqIC._)(newChild))) return newChild = $2111b2a4c096959e$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $6zqIC._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $2111b2a4c096959e$var$REACT_ELEMENT_TYPE:
                    return lanes = $2111b2a4c096959e$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $2111b2a4c096959e$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $2111b2a4c096959e$var$REACT_PORTAL_TYPE:
                    return newChild = $2111b2a4c096959e$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $2111b2a4c096959e$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($2111b2a4c096959e$var$isArrayImpl(newChild) || $2111b2a4c096959e$var$getIteratorFn(newChild)) return newChild = $2111b2a4c096959e$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $2111b2a4c096959e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2111b2a4c096959e$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $2111b2a4c096959e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2111b2a4c096959e$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $6zqIC._)(newChild))) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $6zqIC._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $2111b2a4c096959e$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $2111b2a4c096959e$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $2111b2a4c096959e$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($2111b2a4c096959e$var$isArrayImpl(newChild) || $2111b2a4c096959e$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $2111b2a4c096959e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2111b2a4c096959e$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $2111b2a4c096959e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2111b2a4c096959e$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $6zqIC._)(newChild))) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $6zqIC._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $2111b2a4c096959e$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $2111b2a4c096959e$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $2111b2a4c096959e$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($2111b2a4c096959e$var$isArrayImpl(newChild) || $2111b2a4c096959e$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $2111b2a4c096959e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2111b2a4c096959e$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $2111b2a4c096959e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2111b2a4c096959e$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $2111b2a4c096959e$var$isHydrating && $2111b2a4c096959e$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $2111b2a4c096959e$var$isHydrating && $2111b2a4c096959e$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $2111b2a4c096959e$var$isHydrating && $2111b2a4c096959e$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $2111b2a4c096959e$var$isHydrating && $2111b2a4c096959e$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $2111b2a4c096959e$var$isHydrating && $2111b2a4c096959e$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $2111b2a4c096959e$var$isHydrating && $2111b2a4c096959e$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === (typeof newChild === "undefined" ? "undefined" : (0, $6zqIC._)(newChild)) && null !== newChild && newChild.type === $2111b2a4c096959e$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $6zqIC._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $2111b2a4c096959e$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $2111b2a4c096959e$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === (typeof key === "undefined" ? "undefined" : (0, $6zqIC._)(key)) && null !== key && key.$$typeof === $2111b2a4c096959e$var$REACT_LAZY_TYPE && $2111b2a4c096959e$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $2111b2a4c096959e$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $2111b2a4c096959e$var$REACT_FRAGMENT_TYPE ? (lanes = $2111b2a4c096959e$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $2111b2a4c096959e$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $2111b2a4c096959e$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $2111b2a4c096959e$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $2111b2a4c096959e$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $2111b2a4c096959e$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($2111b2a4c096959e$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($2111b2a4c096959e$var$getIteratorFn(newChild)) {
                key = $2111b2a4c096959e$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $2111b2a4c096959e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2111b2a4c096959e$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $2111b2a4c096959e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2111b2a4c096959e$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $6zqIC._)(newChild)) ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $2111b2a4c096959e$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $2111b2a4c096959e$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $2111b2a4c096959e$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $2111b2a4c096959e$var$SuspenseException || x === $2111b2a4c096959e$var$SuspenseActionException) throw x;
            var fiber = $2111b2a4c096959e$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $2111b2a4c096959e$var$reconcileChildFibers = $2111b2a4c096959e$var$createChildReconciler(!0), $2111b2a4c096959e$var$mountChildFibers = $2111b2a4c096959e$var$createChildReconciler(!1), $2111b2a4c096959e$var$suspenseHandlerStackCursor = $2111b2a4c096959e$var$createCursor(null), $2111b2a4c096959e$var$shellBoundary = null;
function $2111b2a4c096959e$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$suspenseStackCursor, $2111b2a4c096959e$var$suspenseStackCursor.current & 1);
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$suspenseHandlerStackCursor, handler);
    null === $2111b2a4c096959e$var$shellBoundary && (null === current || null !== $2111b2a4c096959e$var$currentTreeHiddenStackCursor.current ? $2111b2a4c096959e$var$shellBoundary = handler : null !== current.memoizedState && ($2111b2a4c096959e$var$shellBoundary = handler));
}
function $2111b2a4c096959e$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($2111b2a4c096959e$var$push($2111b2a4c096959e$var$suspenseStackCursor, $2111b2a4c096959e$var$suspenseStackCursor.current), $2111b2a4c096959e$var$push($2111b2a4c096959e$var$suspenseHandlerStackCursor, fiber), null === $2111b2a4c096959e$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($2111b2a4c096959e$var$shellBoundary = fiber);
        }
    } else $2111b2a4c096959e$var$reuseSuspenseHandlerOnStack(fiber);
}
function $2111b2a4c096959e$var$reuseSuspenseHandlerOnStack() {
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$suspenseStackCursor, $2111b2a4c096959e$var$suspenseStackCursor.current);
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$suspenseHandlerStackCursor, $2111b2a4c096959e$var$suspenseHandlerStackCursor.current);
}
function $2111b2a4c096959e$var$popSuspenseHandler(fiber) {
    $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$suspenseHandlerStackCursor);
    $2111b2a4c096959e$var$shellBoundary === fiber && ($2111b2a4c096959e$var$shellBoundary = null);
    $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$suspenseStackCursor);
}
var $2111b2a4c096959e$var$suspenseStackCursor = $2111b2a4c096959e$var$createCursor(0);
function $2111b2a4c096959e$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $2111b2a4c096959e$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $2111b2a4c096959e$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $2111b2a4c096959e$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $2111b2a4c096959e$var$classComponentUpdater = {
    enqueueSetState: function enqueueSetState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $2111b2a4c096959e$var$requestUpdateLane(), update = $2111b2a4c096959e$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $2111b2a4c096959e$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($2111b2a4c096959e$var$scheduleUpdateOnFiber(payload, inst, lane), $2111b2a4c096959e$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $2111b2a4c096959e$var$requestUpdateLane(), update = $2111b2a4c096959e$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $2111b2a4c096959e$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($2111b2a4c096959e$var$scheduleUpdateOnFiber(payload, inst, lane), $2111b2a4c096959e$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
        inst = inst._reactInternals;
        var lane = $2111b2a4c096959e$var$requestUpdateLane(), update = $2111b2a4c096959e$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $2111b2a4c096959e$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($2111b2a4c096959e$var$scheduleUpdateOnFiber(callback, inst, lane), $2111b2a4c096959e$var$entangleTransitions(callback, inst, lane));
    }
};
function $2111b2a4c096959e$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$2111b2a4c096959e$var$shallowEqual(oldProps, newProps) || !$2111b2a4c096959e$var$shallowEqual(oldState, newState) : !0;
}
function $2111b2a4c096959e$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $2111b2a4c096959e$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $2111b2a4c096959e$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $2111b2a4c096959e$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $2111b2a4c096959e$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $6zqIC._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $6zqIC._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $2111b2a4c096959e$var$defaultOnUncaughtError(error) {
    $2111b2a4c096959e$var$reportGlobalError(error);
}
function $2111b2a4c096959e$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $2111b2a4c096959e$var$defaultOnRecoverableError(error) {
    $2111b2a4c096959e$var$reportGlobalError(error);
}
function $2111b2a4c096959e$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $2111b2a4c096959e$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $2111b2a4c096959e$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $2111b2a4c096959e$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $2111b2a4c096959e$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $2111b2a4c096959e$var$createClassErrorUpdate(lane) {
    lane = $2111b2a4c096959e$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $2111b2a4c096959e$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $2111b2a4c096959e$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $2111b2a4c096959e$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $2111b2a4c096959e$var$legacyErrorBoundariesThatAlreadyFailed ? $2111b2a4c096959e$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $2111b2a4c096959e$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $2111b2a4c096959e$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $2111b2a4c096959e$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $2111b2a4c096959e$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $2111b2a4c096959e$var$shellBoundary ? $2111b2a4c096959e$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $2111b2a4c096959e$var$workInProgressRootExitStatus && ($2111b2a4c096959e$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $2111b2a4c096959e$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $2111b2a4c096959e$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $2111b2a4c096959e$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $2111b2a4c096959e$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($2111b2a4c096959e$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $2111b2a4c096959e$var$attachPingListener(root, value, rootRenderLanes);
        $2111b2a4c096959e$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($2111b2a4c096959e$var$isHydrating) return returnFiber = $2111b2a4c096959e$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $2111b2a4c096959e$var$HydrationMismatchException && (root = Error($2111b2a4c096959e$var$formatProdErrorMessage(422), {
        cause: value
    }), $2111b2a4c096959e$var$queueHydrationError($2111b2a4c096959e$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $2111b2a4c096959e$var$HydrationMismatchException && (returnFiber = Error($2111b2a4c096959e$var$formatProdErrorMessage(423), {
        cause: value
    }), $2111b2a4c096959e$var$queueHydrationError($2111b2a4c096959e$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $2111b2a4c096959e$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $2111b2a4c096959e$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $2111b2a4c096959e$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $2111b2a4c096959e$var$workInProgressRootExitStatus && ($2111b2a4c096959e$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($2111b2a4c096959e$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $2111b2a4c096959e$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $2111b2a4c096959e$var$workInProgressRootConcurrentErrors ? $2111b2a4c096959e$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $2111b2a4c096959e$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $2111b2a4c096959e$var$workInProgressRootExitStatus && ($2111b2a4c096959e$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $2111b2a4c096959e$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $2111b2a4c096959e$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $2111b2a4c096959e$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $2111b2a4c096959e$var$legacyErrorBoundariesThatAlreadyFailed || !$2111b2a4c096959e$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $2111b2a4c096959e$var$createClassErrorUpdate(rootRenderLanes), $2111b2a4c096959e$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $2111b2a4c096959e$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $2111b2a4c096959e$var$SelectiveHydrationException = Error($2111b2a4c096959e$var$formatProdErrorMessage(461)), $2111b2a4c096959e$var$didReceiveUpdate = !1;
function $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $2111b2a4c096959e$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $2111b2a4c096959e$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $2111b2a4c096959e$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $2111b2a4c096959e$var$prepareToReadContext(workInProgress);
    nextProps = $2111b2a4c096959e$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $2111b2a4c096959e$var$checkDidRenderIdHook();
    if (null !== current && !$2111b2a4c096959e$var$didReceiveUpdate) return $2111b2a4c096959e$var$bailoutHooks(current, workInProgress, renderLanes), $2111b2a4c096959e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2111b2a4c096959e$var$isHydrating && key && $2111b2a4c096959e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $2111b2a4c096959e$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$2111b2a4c096959e$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $2111b2a4c096959e$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $2111b2a4c096959e$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$2111b2a4c096959e$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $2111b2a4c096959e$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $2111b2a4c096959e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $2111b2a4c096959e$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $2111b2a4c096959e$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($2111b2a4c096959e$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($2111b2a4c096959e$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $2111b2a4c096959e$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($2111b2a4c096959e$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $2111b2a4c096959e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $2111b2a4c096959e$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $2111b2a4c096959e$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $2111b2a4c096959e$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $2111b2a4c096959e$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $2111b2a4c096959e$var$pushHiddenContext(workInProgress, prevState) : $2111b2a4c096959e$var$reuseHiddenContextOnStack(), $2111b2a4c096959e$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $2111b2a4c096959e$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($2111b2a4c096959e$var$pushTransition(workInProgress, prevState.cachePool), $2111b2a4c096959e$var$pushHiddenContext(workInProgress, prevState), $2111b2a4c096959e$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $2111b2a4c096959e$var$pushTransition(workInProgress, null), $2111b2a4c096959e$var$reuseHiddenContextOnStack(), $2111b2a4c096959e$var$reuseSuspenseHandlerOnStack(workInProgress));
    $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $2111b2a4c096959e$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $2111b2a4c096959e$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $2111b2a4c096959e$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $2111b2a4c096959e$var$pushTransition(workInProgress, null);
    $2111b2a4c096959e$var$reuseHiddenContextOnStack();
    $2111b2a4c096959e$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $2111b2a4c096959e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $2111b2a4c096959e$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== (typeof ref === "undefined" ? "undefined" : (0, $6zqIC._)(ref))) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $2111b2a4c096959e$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $2111b2a4c096959e$var$prepareToReadContext(workInProgress);
    Component = $2111b2a4c096959e$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $2111b2a4c096959e$var$checkDidRenderIdHook();
    if (null !== current && !$2111b2a4c096959e$var$didReceiveUpdate) return $2111b2a4c096959e$var$bailoutHooks(current, workInProgress, renderLanes), $2111b2a4c096959e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2111b2a4c096959e$var$isHydrating && nextProps && $2111b2a4c096959e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $2111b2a4c096959e$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $2111b2a4c096959e$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $2111b2a4c096959e$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $2111b2a4c096959e$var$finishRenderingHooks(current);
    Component = $2111b2a4c096959e$var$checkDidRenderIdHook();
    if (null !== current && !$2111b2a4c096959e$var$didReceiveUpdate) return $2111b2a4c096959e$var$bailoutHooks(current, workInProgress, renderLanes), $2111b2a4c096959e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2111b2a4c096959e$var$isHydrating && Component && $2111b2a4c096959e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $2111b2a4c096959e$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $2111b2a4c096959e$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $2111b2a4c096959e$var$emptyContextObject, contextType = Component.contextType;
        "object" === (typeof contextType === "undefined" ? "undefined" : (0, $6zqIC._)(contextType)) && null !== contextType && (context = $2111b2a4c096959e$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $2111b2a4c096959e$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $2111b2a4c096959e$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === (typeof contextType === "undefined" ? "undefined" : (0, $6zqIC._)(contextType)) && null !== contextType ? $2111b2a4c096959e$var$readContext(contextType) : $2111b2a4c096959e$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($2111b2a4c096959e$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $2111b2a4c096959e$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $2111b2a4c096959e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $2111b2a4c096959e$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $2111b2a4c096959e$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $2111b2a4c096959e$var$emptyContextObject;
        "object" === (typeof contextType$jscomp$0 === "undefined" ? "undefined" : (0, $6zqIC._)(contextType$jscomp$0)) && null !== contextType$jscomp$0 && (contextType = $2111b2a4c096959e$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $2111b2a4c096959e$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $2111b2a4c096959e$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $2111b2a4c096959e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $2111b2a4c096959e$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $2111b2a4c096959e$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($2111b2a4c096959e$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $2111b2a4c096959e$var$hasForceUpdate || $2111b2a4c096959e$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $2111b2a4c096959e$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $2111b2a4c096959e$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $2111b2a4c096959e$var$emptyContextObject;
        "object" === (typeof oldContext === "undefined" ? "undefined" : (0, $6zqIC._)(oldContext)) && null !== oldContext && (oldProps = $2111b2a4c096959e$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $2111b2a4c096959e$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $2111b2a4c096959e$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $2111b2a4c096959e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $2111b2a4c096959e$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $2111b2a4c096959e$var$hasForceUpdate || null !== current && null !== current.dependencies && $2111b2a4c096959e$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($2111b2a4c096959e$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $2111b2a4c096959e$var$hasForceUpdate || $2111b2a4c096959e$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $2111b2a4c096959e$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $2111b2a4c096959e$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $2111b2a4c096959e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $2111b2a4c096959e$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $2111b2a4c096959e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $2111b2a4c096959e$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $2111b2a4c096959e$var$resetHydrationState();
    workInProgress.flags |= 256;
    $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $2111b2a4c096959e$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $2111b2a4c096959e$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $2111b2a4c096959e$var$getSuspendedCache()
    };
}
function $2111b2a4c096959e$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $2111b2a4c096959e$var$workInProgressDeferredLane);
    return current;
}
function $2111b2a4c096959e$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($2111b2a4c096959e$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($2111b2a4c096959e$var$isHydrating) {
            showFallback ? $2111b2a4c096959e$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $2111b2a4c096959e$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($2111b2a4c096959e$var$isHydrating) {
                var nextInstance = $2111b2a4c096959e$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $2111b2a4c096959e$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $2111b2a4c096959e$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $2111b2a4c096959e$var$treeContextProvider ? {
                            id: $2111b2a4c096959e$var$treeContextId,
                            overflow: $2111b2a4c096959e$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $2111b2a4c096959e$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $2111b2a4c096959e$var$hydrationParentFiber = workInProgress, $2111b2a4c096959e$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $2111b2a4c096959e$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $2111b2a4c096959e$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $2111b2a4c096959e$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $2111b2a4c096959e$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $2111b2a4c096959e$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $2111b2a4c096959e$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $2111b2a4c096959e$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $2111b2a4c096959e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2111b2a4c096959e$var$SUSPENDED_MARKER, nextProps;
        $2111b2a4c096959e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $2111b2a4c096959e$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($2111b2a4c096959e$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $2111b2a4c096959e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($2111b2a4c096959e$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($2111b2a4c096959e$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $2111b2a4c096959e$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $2111b2a4c096959e$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $2111b2a4c096959e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $2111b2a4c096959e$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $2111b2a4c096959e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2111b2a4c096959e$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($2111b2a4c096959e$var$pushPrimaryTreeSuspenseHandler(workInProgress), $2111b2a4c096959e$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($2111b2a4c096959e$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $2111b2a4c096959e$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $2111b2a4c096959e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($2111b2a4c096959e$var$didReceiveUpdate || $2111b2a4c096959e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $2111b2a4c096959e$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $2111b2a4c096959e$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $2111b2a4c096959e$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $2111b2a4c096959e$var$enqueueConcurrentRenderForLane(current, nextProps), $2111b2a4c096959e$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $2111b2a4c096959e$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $2111b2a4c096959e$var$renderDidSuspendDelayIfPossible();
            workInProgress = $2111b2a4c096959e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $2111b2a4c096959e$var$nextHydratableInstance = $2111b2a4c096959e$var$getNextHydratable(nextInstance.nextSibling), $2111b2a4c096959e$var$hydrationParentFiber = workInProgress, $2111b2a4c096959e$var$isHydrating = !0, $2111b2a4c096959e$var$hydrationErrors = null, $2111b2a4c096959e$var$rootOrSingletonContext = !1, null !== current && ($2111b2a4c096959e$var$idStack[$2111b2a4c096959e$var$idStackIndex++] = $2111b2a4c096959e$var$treeContextId, $2111b2a4c096959e$var$idStack[$2111b2a4c096959e$var$idStackIndex++] = $2111b2a4c096959e$var$treeContextOverflow, $2111b2a4c096959e$var$idStack[$2111b2a4c096959e$var$idStackIndex++] = $2111b2a4c096959e$var$treeContextProvider, $2111b2a4c096959e$var$treeContextId = current.id, $2111b2a4c096959e$var$treeContextOverflow = current.overflow, $2111b2a4c096959e$var$treeContextProvider = workInProgress), workInProgress = $2111b2a4c096959e$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $2111b2a4c096959e$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $2111b2a4c096959e$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $2111b2a4c096959e$var$createWorkInProgress(digest, showFallback) : (showFallback = $2111b2a4c096959e$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $2111b2a4c096959e$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $2111b2a4c096959e$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $2111b2a4c096959e$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $2111b2a4c096959e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2111b2a4c096959e$var$SUSPENDED_MARKER, nextProps;
    $2111b2a4c096959e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $2111b2a4c096959e$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $2111b2a4c096959e$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $2111b2a4c096959e$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $2111b2a4c096959e$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $2111b2a4c096959e$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $2111b2a4c096959e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $2111b2a4c096959e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $2111b2a4c096959e$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $2111b2a4c096959e$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $2111b2a4c096959e$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $2111b2a4c096959e$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $2111b2a4c096959e$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $2111b2a4c096959e$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $2111b2a4c096959e$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $2111b2a4c096959e$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $2111b2a4c096959e$var$push($2111b2a4c096959e$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $2111b2a4c096959e$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $2111b2a4c096959e$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $2111b2a4c096959e$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $2111b2a4c096959e$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $2111b2a4c096959e$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $2111b2a4c096959e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $2111b2a4c096959e$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($2111b2a4c096959e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $2111b2a4c096959e$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $2111b2a4c096959e$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $2111b2a4c096959e$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $2111b2a4c096959e$var$checkIfContextChanged(current) ? !0 : !1;
}
function $2111b2a4c096959e$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $2111b2a4c096959e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $2111b2a4c096959e$var$pushProvider(workInProgress, $2111b2a4c096959e$var$CacheContext, current.memoizedState.cache);
            $2111b2a4c096959e$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $2111b2a4c096959e$var$pushHostContext(workInProgress);
            break;
        case 4:
            $2111b2a4c096959e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $2111b2a4c096959e$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $2111b2a4c096959e$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $2111b2a4c096959e$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $2111b2a4c096959e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $2111b2a4c096959e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $2111b2a4c096959e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($2111b2a4c096959e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $2111b2a4c096959e$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $2111b2a4c096959e$var$push($2111b2a4c096959e$var$suspenseStackCursor, $2111b2a4c096959e$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $2111b2a4c096959e$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $2111b2a4c096959e$var$pushProvider(workInProgress, $2111b2a4c096959e$var$CacheContext, current.memoizedState.cache);
    }
    return $2111b2a4c096959e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $2111b2a4c096959e$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $2111b2a4c096959e$var$didReceiveUpdate = !0;
        else {
            if (!$2111b2a4c096959e$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $2111b2a4c096959e$var$didReceiveUpdate = !1, $2111b2a4c096959e$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $2111b2a4c096959e$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $2111b2a4c096959e$var$didReceiveUpdate = !1, $2111b2a4c096959e$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $2111b2a4c096959e$var$pushTreeId(workInProgress, $2111b2a4c096959e$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $2111b2a4c096959e$var$shouldConstruct(lazyComponent) ? (current = $2111b2a4c096959e$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $2111b2a4c096959e$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $2111b2a4c096959e$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $2111b2a4c096959e$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $2111b2a4c096959e$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $2111b2a4c096959e$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $2111b2a4c096959e$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $2111b2a4c096959e$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($2111b2a4c096959e$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $2111b2a4c096959e$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $2111b2a4c096959e$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $2111b2a4c096959e$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $2111b2a4c096959e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $2111b2a4c096959e$var$cloneUpdateQueue(current, workInProgress);
                $2111b2a4c096959e$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $2111b2a4c096959e$var$pushProvider(workInProgress, $2111b2a4c096959e$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $2111b2a4c096959e$var$propagateContextChanges(workInProgress, [
                    $2111b2a4c096959e$var$CacheContext
                ], renderLanes, !0);
                $2111b2a4c096959e$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $2111b2a4c096959e$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $2111b2a4c096959e$var$createCapturedValueAtFiber(Error($2111b2a4c096959e$var$formatProdErrorMessage(424)), workInProgress);
                        $2111b2a4c096959e$var$queueHydrationError(init);
                        workInProgress = $2111b2a4c096959e$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $2111b2a4c096959e$var$nextHydratableInstance = $2111b2a4c096959e$var$getNextHydratable(current.firstChild);
                        $2111b2a4c096959e$var$hydrationParentFiber = workInProgress;
                        $2111b2a4c096959e$var$isHydrating = !0;
                        $2111b2a4c096959e$var$hydrationErrors = null;
                        $2111b2a4c096959e$var$rootOrSingletonContext = !0;
                        renderLanes = $2111b2a4c096959e$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $2111b2a4c096959e$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $2111b2a4c096959e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $2111b2a4c096959e$var$markRef(current, workInProgress), null === current ? (renderLanes = $2111b2a4c096959e$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $2111b2a4c096959e$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $2111b2a4c096959e$var$getOwnerDocumentFromRootContainer($2111b2a4c096959e$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$2111b2a4c096959e$var$internalInstanceKey] = workInProgress, lazyComponent[$2111b2a4c096959e$var$internalPropsKey] = current, $2111b2a4c096959e$var$setInitialProperties(lazyComponent, renderLanes, current), $2111b2a4c096959e$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $2111b2a4c096959e$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $2111b2a4c096959e$var$pushHostContext(workInProgress), null === current && $2111b2a4c096959e$var$isHydrating && (lazyComponent = workInProgress.stateNode = $2111b2a4c096959e$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $2111b2a4c096959e$var$rootInstanceStackCursor.current), $2111b2a4c096959e$var$hydrationParentFiber = workInProgress, $2111b2a4c096959e$var$rootOrSingletonContext = !0, init = $2111b2a4c096959e$var$nextHydratableInstance, $2111b2a4c096959e$var$isSingletonScope(workInProgress.type) ? ($2111b2a4c096959e$var$previousHydratableOnEnteringScopedSingleton = init, $2111b2a4c096959e$var$nextHydratableInstance = $2111b2a4c096959e$var$getNextHydratable(lazyComponent.firstChild)) : $2111b2a4c096959e$var$nextHydratableInstance = init), $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $2111b2a4c096959e$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $2111b2a4c096959e$var$isHydrating) {
                if (init = lazyComponent = $2111b2a4c096959e$var$nextHydratableInstance) lazyComponent = $2111b2a4c096959e$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $2111b2a4c096959e$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $2111b2a4c096959e$var$hydrationParentFiber = workInProgress, $2111b2a4c096959e$var$nextHydratableInstance = $2111b2a4c096959e$var$getNextHydratable(lazyComponent.firstChild), $2111b2a4c096959e$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $2111b2a4c096959e$var$throwOnHydrationMismatch(workInProgress);
            }
            $2111b2a4c096959e$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $2111b2a4c096959e$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $2111b2a4c096959e$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $2111b2a4c096959e$var$renderWithHooks(current, workInProgress, $2111b2a4c096959e$var$TransitionAwareHostComponent, null, null, renderLanes), $2111b2a4c096959e$var$HostTransitionContext._currentValue = init);
            $2111b2a4c096959e$var$markRef(current, workInProgress);
            $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $2111b2a4c096959e$var$isHydrating) {
                if (current = renderLanes = $2111b2a4c096959e$var$nextHydratableInstance) renderLanes = $2111b2a4c096959e$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $2111b2a4c096959e$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $2111b2a4c096959e$var$hydrationParentFiber = workInProgress, $2111b2a4c096959e$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $2111b2a4c096959e$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $2111b2a4c096959e$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $2111b2a4c096959e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $2111b2a4c096959e$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $2111b2a4c096959e$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $2111b2a4c096959e$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $2111b2a4c096959e$var$prepareToReadContext(workInProgress), init = $2111b2a4c096959e$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $2111b2a4c096959e$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $2111b2a4c096959e$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $2111b2a4c096959e$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $2111b2a4c096959e$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $2111b2a4c096959e$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $2111b2a4c096959e$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $2111b2a4c096959e$var$prepareToReadContext(workInProgress), lazyComponent = $2111b2a4c096959e$var$readContext($2111b2a4c096959e$var$CacheContext), null === current ? (init = $2111b2a4c096959e$var$peekCacheFromPool(), null === init && (init = $2111b2a4c096959e$var$workInProgressRoot, prevState = $2111b2a4c096959e$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $2111b2a4c096959e$var$initializeUpdateQueue(workInProgress), $2111b2a4c096959e$var$pushProvider(workInProgress, $2111b2a4c096959e$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($2111b2a4c096959e$var$cloneUpdateQueue(current, workInProgress), $2111b2a4c096959e$var$processUpdateQueue(workInProgress, null, null, renderLanes), $2111b2a4c096959e$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $2111b2a4c096959e$var$pushProvider(workInProgress, $2111b2a4c096959e$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $2111b2a4c096959e$var$pushProvider(workInProgress, $2111b2a4c096959e$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $2111b2a4c096959e$var$propagateContextChanges(workInProgress, [
                $2111b2a4c096959e$var$CacheContext
            ], renderLanes, !0))), $2111b2a4c096959e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($2111b2a4c096959e$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $2111b2a4c096959e$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $2111b2a4c096959e$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$2111b2a4c096959e$var$preloadResource(resource)) {
        resource = $2111b2a4c096959e$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($2111b2a4c096959e$var$workInProgressRootRenderLanes & 4194048) === $2111b2a4c096959e$var$workInProgressRootRenderLanes ? null !== $2111b2a4c096959e$var$shellBoundary : ($2111b2a4c096959e$var$workInProgressRootRenderLanes & 62914560) !== $2111b2a4c096959e$var$workInProgressRootRenderLanes && 0 === ($2111b2a4c096959e$var$workInProgressRootRenderLanes & 536870912) || resource !== $2111b2a4c096959e$var$shellBoundary)) throw $2111b2a4c096959e$var$suspendedThenable = $2111b2a4c096959e$var$noopSuspenseyCommitThenable, $2111b2a4c096959e$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $2111b2a4c096959e$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $2111b2a4c096959e$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $2111b2a4c096959e$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $2111b2a4c096959e$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$2111b2a4c096959e$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $2111b2a4c096959e$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $2111b2a4c096959e$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $2111b2a4c096959e$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2111b2a4c096959e$var$bubbleProperties(workInProgress), null;
        case 1:
            return $2111b2a4c096959e$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $2111b2a4c096959e$var$popProvider($2111b2a4c096959e$var$CacheContext);
            $2111b2a4c096959e$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $2111b2a4c096959e$var$popHydrationState(workInProgress) ? $2111b2a4c096959e$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $2111b2a4c096959e$var$upgradeHydrationErrorsToRecoverable());
            $2111b2a4c096959e$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($2111b2a4c096959e$var$markUpdate(workInProgress), null !== renderLanes ? ($2111b2a4c096959e$var$bubbleProperties(workInProgress), $2111b2a4c096959e$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($2111b2a4c096959e$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($2111b2a4c096959e$var$markUpdate(workInProgress), $2111b2a4c096959e$var$bubbleProperties(workInProgress), $2111b2a4c096959e$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($2111b2a4c096959e$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $2111b2a4c096959e$var$markUpdate(workInProgress), $2111b2a4c096959e$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $2111b2a4c096959e$var$popHostContext(workInProgress);
            renderLanes = $2111b2a4c096959e$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2111b2a4c096959e$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(166));
                    $2111b2a4c096959e$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $2111b2a4c096959e$var$contextStackCursor.current;
                $2111b2a4c096959e$var$popHydrationState(workInProgress) ? $2111b2a4c096959e$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $2111b2a4c096959e$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $2111b2a4c096959e$var$markUpdate(workInProgress));
            }
            $2111b2a4c096959e$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $2111b2a4c096959e$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2111b2a4c096959e$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(166));
                    $2111b2a4c096959e$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $2111b2a4c096959e$var$contextStackCursor.current;
                if ($2111b2a4c096959e$var$popHydrationState(workInProgress)) $2111b2a4c096959e$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $2111b2a4c096959e$var$getOwnerDocumentFromRootContainer($2111b2a4c096959e$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$2111b2a4c096959e$var$internalInstanceKey] = workInProgress;
                    current[$2111b2a4c096959e$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($2111b2a4c096959e$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $2111b2a4c096959e$var$markUpdate(workInProgress);
                }
            }
            $2111b2a4c096959e$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2111b2a4c096959e$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(166));
                current = $2111b2a4c096959e$var$rootInstanceStackCursor.current;
                if ($2111b2a4c096959e$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $2111b2a4c096959e$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$2111b2a4c096959e$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $2111b2a4c096959e$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $2111b2a4c096959e$var$throwOnHydrationMismatch(workInProgress);
                } else current = $2111b2a4c096959e$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$2111b2a4c096959e$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $2111b2a4c096959e$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $2111b2a4c096959e$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(317));
                        type[$2111b2a4c096959e$var$internalInstanceKey] = workInProgress;
                    } else $2111b2a4c096959e$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $2111b2a4c096959e$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $2111b2a4c096959e$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $2111b2a4c096959e$var$popSuspenseHandler(workInProgress), workInProgress;
                    $2111b2a4c096959e$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $2111b2a4c096959e$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $2111b2a4c096959e$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $2111b2a4c096959e$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $2111b2a4c096959e$var$popHostContainer(), null === current && $2111b2a4c096959e$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $2111b2a4c096959e$var$bubbleProperties(workInProgress), null;
        case 10:
            return $2111b2a4c096959e$var$popProvider(workInProgress.type), $2111b2a4c096959e$var$bubbleProperties(workInProgress), null;
        case 19:
            $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $2111b2a4c096959e$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $2111b2a4c096959e$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $2111b2a4c096959e$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $2111b2a4c096959e$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $2111b2a4c096959e$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $2111b2a4c096959e$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$2111b2a4c096959e$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $2111b2a4c096959e$var$push($2111b2a4c096959e$var$suspenseStackCursor, $2111b2a4c096959e$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $2111b2a4c096959e$var$now() > $2111b2a4c096959e$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $2111b2a4c096959e$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $2111b2a4c096959e$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $2111b2a4c096959e$var$scheduleRetryEffect(workInProgress, current), $2111b2a4c096959e$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$2111b2a4c096959e$var$isHydrating) return $2111b2a4c096959e$var$bubbleProperties(workInProgress), null;
                    } else 2 * $2111b2a4c096959e$var$now() - type.renderingStartTime > $2111b2a4c096959e$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $2111b2a4c096959e$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $2111b2a4c096959e$var$now(), workInProgress.sibling = null, current = $2111b2a4c096959e$var$suspenseStackCursor.current, $2111b2a4c096959e$var$push($2111b2a4c096959e$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $2111b2a4c096959e$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $2111b2a4c096959e$var$popSuspenseHandler(workInProgress), $2111b2a4c096959e$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($2111b2a4c096959e$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $2111b2a4c096959e$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $2111b2a4c096959e$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $2111b2a4c096959e$var$popProvider($2111b2a4c096959e$var$CacheContext), $2111b2a4c096959e$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($2111b2a4c096959e$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $2111b2a4c096959e$var$unwindWork(current, workInProgress) {
    $2111b2a4c096959e$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $2111b2a4c096959e$var$popProvider($2111b2a4c096959e$var$CacheContext), $2111b2a4c096959e$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $2111b2a4c096959e$var$popHostContext(workInProgress), null;
        case 13:
            $2111b2a4c096959e$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(340));
                $2111b2a4c096959e$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$suspenseStackCursor), null;
        case 4:
            return $2111b2a4c096959e$var$popHostContainer(), null;
        case 10:
            return $2111b2a4c096959e$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $2111b2a4c096959e$var$popSuspenseHandler(workInProgress), $2111b2a4c096959e$var$popHiddenContext(), null !== current && $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $2111b2a4c096959e$var$popProvider($2111b2a4c096959e$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $2111b2a4c096959e$var$unwindInterruptedWork(current, interruptedWork) {
    $2111b2a4c096959e$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $2111b2a4c096959e$var$popProvider($2111b2a4c096959e$var$CacheContext);
            $2111b2a4c096959e$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $2111b2a4c096959e$var$popHostContext(interruptedWork);
            break;
        case 4:
            $2111b2a4c096959e$var$popHostContainer();
            break;
        case 13:
            $2111b2a4c096959e$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$suspenseStackCursor);
            break;
        case 10:
            $2111b2a4c096959e$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $2111b2a4c096959e$var$popSuspenseHandler(interruptedWork);
            $2111b2a4c096959e$var$popHiddenContext();
            null !== current && $2111b2a4c096959e$var$pop($2111b2a4c096959e$var$resumedCache);
            break;
        case 24:
            $2111b2a4c096959e$var$popProvider($2111b2a4c096959e$var$CacheContext);
    }
}
function $2111b2a4c096959e$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2111b2a4c096959e$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $2111b2a4c096959e$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2111b2a4c096959e$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $2111b2a4c096959e$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $2111b2a4c096959e$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $2111b2a4c096959e$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $2111b2a4c096959e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $2111b2a4c096959e$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $2111b2a4c096959e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $2111b2a4c096959e$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $2111b2a4c096959e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $2111b2a4c096959e$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $2111b2a4c096959e$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2111b2a4c096959e$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $2111b2a4c096959e$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$2111b2a4c096959e$var$internalPropsKey] = newProps;
    } catch (error) {
        $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2111b2a4c096959e$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $2111b2a4c096959e$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $2111b2a4c096959e$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $2111b2a4c096959e$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $2111b2a4c096959e$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $2111b2a4c096959e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $2111b2a4c096959e$var$noop$1));
    else if (4 !== tag && (27 === tag && $2111b2a4c096959e$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($2111b2a4c096959e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$2111b2a4c096959e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $2111b2a4c096959e$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $2111b2a4c096959e$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($2111b2a4c096959e$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$2111b2a4c096959e$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $2111b2a4c096959e$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $2111b2a4c096959e$var$setInitialProperties(singleton, type, props);
        singleton[$2111b2a4c096959e$var$internalInstanceKey] = finishedWork;
        singleton[$2111b2a4c096959e$var$internalPropsKey] = props;
    } catch (error) {
        $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $2111b2a4c096959e$var$offscreenSubtreeIsHidden = !1, $2111b2a4c096959e$var$offscreenSubtreeWasHidden = !1, $2111b2a4c096959e$var$needsFormReset = !1, $2111b2a4c096959e$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $2111b2a4c096959e$var$nextEffect = null;
function $2111b2a4c096959e$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $2111b2a4c096959e$var$eventsEnabled = $2111b2a4c096959e$var$_enabled;
    root = $2111b2a4c096959e$var$getActiveElementDeep(root);
    if ($2111b2a4c096959e$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $2111b2a4c096959e$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $2111b2a4c096959e$var$_enabled = !1;
    for($2111b2a4c096959e$var$nextEffect = firstChild; null !== $2111b2a4c096959e$var$nextEffect;)if (firstChild = $2111b2a4c096959e$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $2111b2a4c096959e$var$nextEffect = root;
    else for(; null !== $2111b2a4c096959e$var$nextEffect;){
        firstChild = $2111b2a4c096959e$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $2111b2a4c096959e$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $2111b2a4c096959e$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $2111b2a4c096959e$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $2111b2a4c096959e$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $2111b2a4c096959e$var$nextEffect = root;
            break;
        }
        $2111b2a4c096959e$var$nextEffect = firstChild.return;
    }
}
function $2111b2a4c096959e$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2111b2a4c096959e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2111b2a4c096959e$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $2111b2a4c096959e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $2111b2a4c096959e$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $2111b2a4c096959e$var$commitClassCallbacks(finishedWork);
            flags & 512 && $2111b2a4c096959e$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $2111b2a4c096959e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $2111b2a4c096959e$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $2111b2a4c096959e$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $2111b2a4c096959e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $2111b2a4c096959e$var$commitHostMount(finishedWork);
            flags & 512 && $2111b2a4c096959e$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $2111b2a4c096959e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $2111b2a4c096959e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2111b2a4c096959e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $2111b2a4c096959e$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $2111b2a4c096959e$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $2111b2a4c096959e$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $2111b2a4c096959e$var$offscreenSubtreeWasHidden;
                prevProps = $2111b2a4c096959e$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $2111b2a4c096959e$var$offscreenSubtreeWasHidden;
                $2111b2a4c096959e$var$offscreenSubtreeIsHidden = flags;
                ($2111b2a4c096959e$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $2111b2a4c096959e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $2111b2a4c096959e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $2111b2a4c096959e$var$offscreenSubtreeIsHidden = prevProps;
                $2111b2a4c096959e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $2111b2a4c096959e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $2111b2a4c096959e$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $2111b2a4c096959e$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $2111b2a4c096959e$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $2111b2a4c096959e$var$hostParent = null, $2111b2a4c096959e$var$hostParentIsContainer = !1;
function $2111b2a4c096959e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$2111b2a4c096959e$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $2111b2a4c096959e$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($2111b2a4c096959e$var$injectedHook && "function" === typeof $2111b2a4c096959e$var$injectedHook.onCommitFiberUnmount) try {
        $2111b2a4c096959e$var$injectedHook.onCommitFiberUnmount($2111b2a4c096959e$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $2111b2a4c096959e$var$offscreenSubtreeWasHidden || $2111b2a4c096959e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $2111b2a4c096959e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $2111b2a4c096959e$var$offscreenSubtreeWasHidden || $2111b2a4c096959e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $2111b2a4c096959e$var$hostParent, prevHostParentIsContainer = $2111b2a4c096959e$var$hostParentIsContainer;
            $2111b2a4c096959e$var$isSingletonScope(deletedFiber.type) && ($2111b2a4c096959e$var$hostParent = deletedFiber.stateNode, $2111b2a4c096959e$var$hostParentIsContainer = !1);
            $2111b2a4c096959e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2111b2a4c096959e$var$releaseSingletonInstance(deletedFiber.stateNode);
            $2111b2a4c096959e$var$hostParent = prevHostParent;
            $2111b2a4c096959e$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $2111b2a4c096959e$var$offscreenSubtreeWasHidden || $2111b2a4c096959e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $2111b2a4c096959e$var$hostParent;
            prevHostParentIsContainer = $2111b2a4c096959e$var$hostParentIsContainer;
            $2111b2a4c096959e$var$hostParent = null;
            $2111b2a4c096959e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2111b2a4c096959e$var$hostParent = prevHostParent;
            $2111b2a4c096959e$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $2111b2a4c096959e$var$hostParent) {
                if ($2111b2a4c096959e$var$hostParentIsContainer) try {
                    (9 === $2111b2a4c096959e$var$hostParent.nodeType ? $2111b2a4c096959e$var$hostParent.body : "HTML" === $2111b2a4c096959e$var$hostParent.nodeName ? $2111b2a4c096959e$var$hostParent.ownerDocument.body : $2111b2a4c096959e$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $2111b2a4c096959e$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $2111b2a4c096959e$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $2111b2a4c096959e$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $2111b2a4c096959e$var$hostParent && ($2111b2a4c096959e$var$hostParentIsContainer ? (finishedRoot = $2111b2a4c096959e$var$hostParent, $2111b2a4c096959e$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $2111b2a4c096959e$var$retryIfBlockedOn(finishedRoot)) : $2111b2a4c096959e$var$clearSuspenseBoundary($2111b2a4c096959e$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $2111b2a4c096959e$var$hostParent;
            prevHostParentIsContainer = $2111b2a4c096959e$var$hostParentIsContainer;
            $2111b2a4c096959e$var$hostParent = deletedFiber.stateNode.containerInfo;
            $2111b2a4c096959e$var$hostParentIsContainer = !0;
            $2111b2a4c096959e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2111b2a4c096959e$var$hostParent = prevHostParent;
            $2111b2a4c096959e$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $2111b2a4c096959e$var$offscreenSubtreeWasHidden || $2111b2a4c096959e$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $2111b2a4c096959e$var$offscreenSubtreeWasHidden || $2111b2a4c096959e$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $2111b2a4c096959e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $2111b2a4c096959e$var$offscreenSubtreeWasHidden || ($2111b2a4c096959e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $2111b2a4c096959e$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $2111b2a4c096959e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $2111b2a4c096959e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $2111b2a4c096959e$var$offscreenSubtreeWasHidden = (prevHostParent = $2111b2a4c096959e$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $2111b2a4c096959e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2111b2a4c096959e$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $2111b2a4c096959e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $2111b2a4c096959e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $2111b2a4c096959e$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2111b2a4c096959e$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $2111b2a4c096959e$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $2111b2a4c096959e$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($2111b2a4c096959e$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $2111b2a4c096959e$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $2111b2a4c096959e$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $2111b2a4c096959e$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($2111b2a4c096959e$var$isSingletonScope(parent.type)) {
                        $2111b2a4c096959e$var$hostParent = parent.stateNode;
                        $2111b2a4c096959e$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $2111b2a4c096959e$var$hostParent = parent.stateNode;
                    $2111b2a4c096959e$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $2111b2a4c096959e$var$hostParent = parent.stateNode.containerInfo;
                    $2111b2a4c096959e$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $2111b2a4c096959e$var$hostParent) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(160));
        $2111b2a4c096959e$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $2111b2a4c096959e$var$hostParent = null;
        $2111b2a4c096959e$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$2111b2a4c096959e$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $2111b2a4c096959e$var$currentHoistableRoot = null;
function $2111b2a4c096959e$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($2111b2a4c096959e$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $2111b2a4c096959e$var$commitHookEffectListMount(3, finishedWork), $2111b2a4c096959e$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2111b2a4c096959e$var$offscreenSubtreeWasHidden || null === current || $2111b2a4c096959e$var$safelyDetachRef(current, current.return));
            flags & 64 && $2111b2a4c096959e$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $2111b2a4c096959e$var$currentHoistableRoot;
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2111b2a4c096959e$var$offscreenSubtreeWasHidden || null === current || $2111b2a4c096959e$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$2111b2a4c096959e$var$internalHoistableMarker] || currentResource[$2111b2a4c096959e$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $2111b2a4c096959e$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$2111b2a4c096959e$var$internalInstanceKey] = finishedWork;
                                        $2111b2a4c096959e$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $2111b2a4c096959e$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $2111b2a4c096959e$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $2111b2a4c096959e$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $2111b2a4c096959e$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($2111b2a4c096959e$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$2111b2a4c096959e$var$internalInstanceKey] = finishedWork;
                                $2111b2a4c096959e$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $2111b2a4c096959e$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $2111b2a4c096959e$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $2111b2a4c096959e$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $2111b2a4c096959e$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $2111b2a4c096959e$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2111b2a4c096959e$var$offscreenSubtreeWasHidden || null === current || $2111b2a4c096959e$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $2111b2a4c096959e$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2111b2a4c096959e$var$offscreenSubtreeWasHidden || null === current || $2111b2a4c096959e$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $2111b2a4c096959e$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $2111b2a4c096959e$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($2111b2a4c096959e$var$needsFormReset = !0);
            break;
        case 6:
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $2111b2a4c096959e$var$tagCaches = null;
            hoistableRoot = $2111b2a4c096959e$var$currentHoistableRoot;
            $2111b2a4c096959e$var$currentHoistableRoot = $2111b2a4c096959e$var$getHoistableRoot(root.containerInfo);
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$currentHoistableRoot = hoistableRoot;
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $2111b2a4c096959e$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $2111b2a4c096959e$var$needsFormReset && ($2111b2a4c096959e$var$needsFormReset = !1, $2111b2a4c096959e$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $2111b2a4c096959e$var$currentHoistableRoot;
            $2111b2a4c096959e$var$currentHoistableRoot = $2111b2a4c096959e$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            $2111b2a4c096959e$var$currentHoistableRoot = flags;
            break;
        case 12:
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($2111b2a4c096959e$var$globalMostRecentFallbackTime = $2111b2a4c096959e$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2111b2a4c096959e$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $2111b2a4c096959e$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $2111b2a4c096959e$var$offscreenSubtreeWasHidden;
            $2111b2a4c096959e$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $2111b2a4c096959e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $2111b2a4c096959e$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $2111b2a4c096959e$var$offscreenSubtreeIsHidden || $2111b2a4c096959e$var$offscreenSubtreeWasHidden || $2111b2a4c096959e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $2111b2a4c096959e$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $2111b2a4c096959e$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $2111b2a4c096959e$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2111b2a4c096959e$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $2111b2a4c096959e$var$recursivelyTraverseMutationEffects(root, finishedWork), $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork);
    }
}
function $2111b2a4c096959e$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($2111b2a4c096959e$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $2111b2a4c096959e$var$getHostSibling(finishedWork);
                    $2111b2a4c096959e$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($2111b2a4c096959e$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $2111b2a4c096959e$var$getHostSibling(finishedWork);
                    $2111b2a4c096959e$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $2111b2a4c096959e$var$getHostSibling(finishedWork);
                    $2111b2a4c096959e$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($2111b2a4c096959e$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $2111b2a4c096959e$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $2111b2a4c096959e$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $2111b2a4c096959e$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$2111b2a4c096959e$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $2111b2a4c096959e$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $2111b2a4c096959e$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $2111b2a4c096959e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $2111b2a4c096959e$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $2111b2a4c096959e$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $2111b2a4c096959e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $2111b2a4c096959e$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $2111b2a4c096959e$var$safelyDetachRef(finishedWork, finishedWork.return);
                $2111b2a4c096959e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $2111b2a4c096959e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $2111b2a4c096959e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $2111b2a4c096959e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2111b2a4c096959e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $2111b2a4c096959e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $2111b2a4c096959e$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $2111b2a4c096959e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $2111b2a4c096959e$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$2111b2a4c096959e$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $2111b2a4c096959e$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $2111b2a4c096959e$var$commitClassCallbacks(finishedWork);
                $2111b2a4c096959e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $2111b2a4c096959e$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $2111b2a4c096959e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $2111b2a4c096959e$var$commitHostMount(finishedWork);
                $2111b2a4c096959e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $2111b2a4c096959e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $2111b2a4c096959e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $2111b2a4c096959e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $2111b2a4c096959e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $2111b2a4c096959e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $2111b2a4c096959e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2111b2a4c096959e$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $2111b2a4c096959e$var$releaseCache(previousCache));
}
function $2111b2a4c096959e$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $2111b2a4c096959e$var$releaseCache(current));
}
function $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$2111b2a4c096959e$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $2111b2a4c096959e$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $2111b2a4c096959e$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $2111b2a4c096959e$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $2111b2a4c096959e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $2111b2a4c096959e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $2111b2a4c096959e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $2111b2a4c096959e$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $2111b2a4c096959e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $2111b2a4c096959e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $2111b2a4c096959e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $2111b2a4c096959e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $2111b2a4c096959e$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $2111b2a4c096959e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $2111b2a4c096959e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $2111b2a4c096959e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $2111b2a4c096959e$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $2111b2a4c096959e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $2111b2a4c096959e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $2111b2a4c096959e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2111b2a4c096959e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $2111b2a4c096959e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $2111b2a4c096959e$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $2111b2a4c096959e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $2111b2a4c096959e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $2111b2a4c096959e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $2111b2a4c096959e$var$suspenseyCommitFlag = 8192;
function $2111b2a4c096959e$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $2111b2a4c096959e$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$2111b2a4c096959e$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $2111b2a4c096959e$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $2111b2a4c096959e$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $2111b2a4c096959e$var$suspenseyCommitFlag && null !== fiber.memoizedState && $2111b2a4c096959e$var$suspendResource($2111b2a4c096959e$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $2111b2a4c096959e$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $2111b2a4c096959e$var$currentHoistableRoot;
            $2111b2a4c096959e$var$currentHoistableRoot = $2111b2a4c096959e$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $2111b2a4c096959e$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $2111b2a4c096959e$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $2111b2a4c096959e$var$suspenseyCommitFlag, $2111b2a4c096959e$var$suspenseyCommitFlag = 16777216, $2111b2a4c096959e$var$recursivelyAccumulateSuspenseyCommit(fiber), $2111b2a4c096959e$var$suspenseyCommitFlag = previousHoistableRoot) : $2111b2a4c096959e$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $2111b2a4c096959e$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $2111b2a4c096959e$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $2111b2a4c096959e$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $2111b2a4c096959e$var$nextEffect = childToDelete;
            $2111b2a4c096959e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $2111b2a4c096959e$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$2111b2a4c096959e$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $2111b2a4c096959e$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2111b2a4c096959e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $2111b2a4c096959e$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $2111b2a4c096959e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $2111b2a4c096959e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $2111b2a4c096959e$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $2111b2a4c096959e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $2111b2a4c096959e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $2111b2a4c096959e$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $2111b2a4c096959e$var$nextEffect = childToDelete;
            $2111b2a4c096959e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $2111b2a4c096959e$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $2111b2a4c096959e$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $2111b2a4c096959e$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $2111b2a4c096959e$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $2111b2a4c096959e$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2111b2a4c096959e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $2111b2a4c096959e$var$nextEffect;){
        var fiber = $2111b2a4c096959e$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $2111b2a4c096959e$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $2111b2a4c096959e$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $2111b2a4c096959e$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $2111b2a4c096959e$var$nextEffect;){
            cache = $2111b2a4c096959e$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $2111b2a4c096959e$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $2111b2a4c096959e$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $2111b2a4c096959e$var$nextEffect = sibling;
                break a;
            }
            $2111b2a4c096959e$var$nextEffect = returnFiber;
        }
    }
}
var $2111b2a4c096959e$var$DefaultAsyncDispatcher = {
    getCacheForType: function getCacheForType(resourceType) {
        var cache = $2111b2a4c096959e$var$readContext($2111b2a4c096959e$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $2111b2a4c096959e$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $2111b2a4c096959e$var$executionContext = 0, $2111b2a4c096959e$var$workInProgressRoot = null, $2111b2a4c096959e$var$workInProgress = null, $2111b2a4c096959e$var$workInProgressRootRenderLanes = 0, $2111b2a4c096959e$var$workInProgressSuspendedReason = 0, $2111b2a4c096959e$var$workInProgressThrownValue = null, $2111b2a4c096959e$var$workInProgressRootDidSkipSuspendedSiblings = !1, $2111b2a4c096959e$var$workInProgressRootIsPrerendering = !1, $2111b2a4c096959e$var$workInProgressRootDidAttachPingListener = !1, $2111b2a4c096959e$var$entangledRenderLanes = 0, $2111b2a4c096959e$var$workInProgressRootExitStatus = 0, $2111b2a4c096959e$var$workInProgressRootSkippedLanes = 0, $2111b2a4c096959e$var$workInProgressRootInterleavedUpdatedLanes = 0, $2111b2a4c096959e$var$workInProgressRootPingedLanes = 0, $2111b2a4c096959e$var$workInProgressDeferredLane = 0, $2111b2a4c096959e$var$workInProgressSuspendedRetryLanes = 0, $2111b2a4c096959e$var$workInProgressRootConcurrentErrors = null, $2111b2a4c096959e$var$workInProgressRootRecoverableErrors = null, $2111b2a4c096959e$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $2111b2a4c096959e$var$globalMostRecentFallbackTime = 0, $2111b2a4c096959e$var$workInProgressRootRenderTargetTime = Infinity, $2111b2a4c096959e$var$workInProgressTransitions = null, $2111b2a4c096959e$var$legacyErrorBoundariesThatAlreadyFailed = null, $2111b2a4c096959e$var$pendingEffectsStatus = 0, $2111b2a4c096959e$var$pendingEffectsRoot = null, $2111b2a4c096959e$var$pendingFinishedWork = null, $2111b2a4c096959e$var$pendingEffectsLanes = 0, $2111b2a4c096959e$var$pendingEffectsRemainingLanes = 0, $2111b2a4c096959e$var$pendingPassiveTransitions = null, $2111b2a4c096959e$var$pendingRecoverableErrors = null, $2111b2a4c096959e$var$nestedUpdateCount = 0, $2111b2a4c096959e$var$rootWithNestedUpdates = null;
function $2111b2a4c096959e$var$requestUpdateLane() {
    if (0 !== ($2111b2a4c096959e$var$executionContext & 2) && 0 !== $2111b2a4c096959e$var$workInProgressRootRenderLanes) return $2111b2a4c096959e$var$workInProgressRootRenderLanes & -$2111b2a4c096959e$var$workInProgressRootRenderLanes;
    if (null !== $2111b2a4c096959e$var$ReactSharedInternals.T) {
        var actionScopeLane = $2111b2a4c096959e$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $2111b2a4c096959e$var$requestTransitionLane();
    }
    return $2111b2a4c096959e$var$resolveUpdatePriority();
}
function $2111b2a4c096959e$var$requestDeferredLane() {
    0 === $2111b2a4c096959e$var$workInProgressDeferredLane && ($2111b2a4c096959e$var$workInProgressDeferredLane = 0 === ($2111b2a4c096959e$var$workInProgressRootRenderLanes & 536870912) || $2111b2a4c096959e$var$isHydrating ? $2111b2a4c096959e$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $2111b2a4c096959e$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $2111b2a4c096959e$var$workInProgressDeferredLane;
}
function $2111b2a4c096959e$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $2111b2a4c096959e$var$workInProgressRoot && (2 === $2111b2a4c096959e$var$workInProgressSuspendedReason || 9 === $2111b2a4c096959e$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $2111b2a4c096959e$var$prepareFreshStack(root, 0), $2111b2a4c096959e$var$markRootSuspended(root, $2111b2a4c096959e$var$workInProgressRootRenderLanes, $2111b2a4c096959e$var$workInProgressDeferredLane, !1);
    $2111b2a4c096959e$var$markRootUpdated$1(root, lane);
    if (0 === ($2111b2a4c096959e$var$executionContext & 2) || root !== $2111b2a4c096959e$var$workInProgressRoot) root === $2111b2a4c096959e$var$workInProgressRoot && (0 === ($2111b2a4c096959e$var$executionContext & 2) && ($2111b2a4c096959e$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $2111b2a4c096959e$var$workInProgressRootExitStatus && $2111b2a4c096959e$var$markRootSuspended(root, $2111b2a4c096959e$var$workInProgressRootRenderLanes, $2111b2a4c096959e$var$workInProgressDeferredLane, !1)), $2111b2a4c096959e$var$ensureRootIsScheduled(root);
}
function $2111b2a4c096959e$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($2111b2a4c096959e$var$executionContext & 6)) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $2111b2a4c096959e$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $2111b2a4c096959e$var$renderRootConcurrent(root$jscomp$0, lanes) : $2111b2a4c096959e$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $2111b2a4c096959e$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $2111b2a4c096959e$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$2111b2a4c096959e$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $2111b2a4c096959e$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $2111b2a4c096959e$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($2111b2a4c096959e$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $2111b2a4c096959e$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($2111b2a4c096959e$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $2111b2a4c096959e$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $2111b2a4c096959e$var$workInProgressRootRecoverableErrors;
                            $2111b2a4c096959e$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $2111b2a4c096959e$var$workInProgressRootRecoverableErrors ? $2111b2a4c096959e$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $2111b2a4c096959e$var$workInProgressRootRecoverableErrors.push.apply($2111b2a4c096959e$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $2111b2a4c096959e$var$prepareFreshStack(root$jscomp$0, 0);
                $2111b2a4c096959e$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($2111b2a4c096959e$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $2111b2a4c096959e$var$markRootSuspended(shouldTimeSlice, lanes, $2111b2a4c096959e$var$workInProgressDeferredLane, !$2111b2a4c096959e$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $2111b2a4c096959e$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($2111b2a4c096959e$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $2111b2a4c096959e$var$globalMostRecentFallbackTime + 300 - $2111b2a4c096959e$var$now(), 10 < exitStatus)) {
                    $2111b2a4c096959e$var$markRootSuspended(shouldTimeSlice, lanes, $2111b2a4c096959e$var$workInProgressDeferredLane, !$2111b2a4c096959e$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $2111b2a4c096959e$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $2111b2a4c096959e$var$scheduleTimeout($2111b2a4c096959e$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $2111b2a4c096959e$var$workInProgressRootRecoverableErrors, $2111b2a4c096959e$var$workInProgressTransitions, $2111b2a4c096959e$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $2111b2a4c096959e$var$workInProgressDeferredLane, $2111b2a4c096959e$var$workInProgressRootInterleavedUpdatedLanes, $2111b2a4c096959e$var$workInProgressSuspendedRetryLanes, $2111b2a4c096959e$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $2111b2a4c096959e$var$commitRootWhenReady(shouldTimeSlice, forceSync, $2111b2a4c096959e$var$workInProgressRootRecoverableErrors, $2111b2a4c096959e$var$workInProgressTransitions, $2111b2a4c096959e$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $2111b2a4c096959e$var$workInProgressDeferredLane, $2111b2a4c096959e$var$workInProgressRootInterleavedUpdatedLanes, $2111b2a4c096959e$var$workInProgressSuspendedRetryLanes, $2111b2a4c096959e$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $2111b2a4c096959e$var$ensureRootIsScheduled(root$jscomp$0);
}
function $2111b2a4c096959e$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($2111b2a4c096959e$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $2111b2a4c096959e$var$noop
        }, $2111b2a4c096959e$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $2111b2a4c096959e$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($2111b2a4c096959e$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $2111b2a4c096959e$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $2111b2a4c096959e$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $2111b2a4c096959e$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$2111b2a4c096959e$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $2111b2a4c096959e$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$2111b2a4c096959e$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$2111b2a4c096959e$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $2111b2a4c096959e$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $2111b2a4c096959e$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $2111b2a4c096959e$var$flushSyncWork$1() {
    return 0 === ($2111b2a4c096959e$var$executionContext & 6) ? ($2111b2a4c096959e$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $2111b2a4c096959e$var$resetWorkInProgressStack() {
    if (null !== $2111b2a4c096959e$var$workInProgress) {
        if (0 === $2111b2a4c096959e$var$workInProgressSuspendedReason) var interruptedWork = $2111b2a4c096959e$var$workInProgress.return;
        else interruptedWork = $2111b2a4c096959e$var$workInProgress, $2111b2a4c096959e$var$lastContextDependency = $2111b2a4c096959e$var$currentlyRenderingFiber$1 = null, $2111b2a4c096959e$var$resetHooksOnUnwind(interruptedWork), $2111b2a4c096959e$var$thenableState = null, $2111b2a4c096959e$var$thenableIndexCounter = 0, interruptedWork = $2111b2a4c096959e$var$workInProgress;
        for(; null !== interruptedWork;)$2111b2a4c096959e$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $2111b2a4c096959e$var$workInProgress = null;
    }
}
function $2111b2a4c096959e$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $2111b2a4c096959e$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $2111b2a4c096959e$var$resetWorkInProgressStack();
    $2111b2a4c096959e$var$workInProgressRoot = root;
    $2111b2a4c096959e$var$workInProgress = timeoutHandle = $2111b2a4c096959e$var$createWorkInProgress(root.current, null);
    $2111b2a4c096959e$var$workInProgressRootRenderLanes = lanes;
    $2111b2a4c096959e$var$workInProgressSuspendedReason = 0;
    $2111b2a4c096959e$var$workInProgressThrownValue = null;
    $2111b2a4c096959e$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $2111b2a4c096959e$var$workInProgressRootIsPrerendering = $2111b2a4c096959e$var$checkIfRootIsPrerendering(root, lanes);
    $2111b2a4c096959e$var$workInProgressRootDidAttachPingListener = !1;
    $2111b2a4c096959e$var$workInProgressSuspendedRetryLanes = $2111b2a4c096959e$var$workInProgressDeferredLane = $2111b2a4c096959e$var$workInProgressRootPingedLanes = $2111b2a4c096959e$var$workInProgressRootInterleavedUpdatedLanes = $2111b2a4c096959e$var$workInProgressRootSkippedLanes = $2111b2a4c096959e$var$workInProgressRootExitStatus = 0;
    $2111b2a4c096959e$var$workInProgressRootRecoverableErrors = $2111b2a4c096959e$var$workInProgressRootConcurrentErrors = null;
    $2111b2a4c096959e$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $2111b2a4c096959e$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $2111b2a4c096959e$var$entangledRenderLanes = lanes;
    $2111b2a4c096959e$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $2111b2a4c096959e$var$handleThrow(root, thrownValue) {
    $2111b2a4c096959e$var$currentlyRenderingFiber = null;
    $2111b2a4c096959e$var$ReactSharedInternals.H = $2111b2a4c096959e$var$ContextOnlyDispatcher;
    thrownValue === $2111b2a4c096959e$var$SuspenseException || thrownValue === $2111b2a4c096959e$var$SuspenseActionException ? (thrownValue = $2111b2a4c096959e$var$getSuspendedThenable(), $2111b2a4c096959e$var$workInProgressSuspendedReason = 3) : thrownValue === $2111b2a4c096959e$var$SuspenseyCommitException ? (thrownValue = $2111b2a4c096959e$var$getSuspendedThenable(), $2111b2a4c096959e$var$workInProgressSuspendedReason = 4) : $2111b2a4c096959e$var$workInProgressSuspendedReason = thrownValue === $2111b2a4c096959e$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === (typeof thrownValue === "undefined" ? "undefined" : (0, $6zqIC._)(thrownValue)) && "function" === typeof thrownValue.then ? 6 : 1;
    $2111b2a4c096959e$var$workInProgressThrownValue = thrownValue;
    null === $2111b2a4c096959e$var$workInProgress && ($2111b2a4c096959e$var$workInProgressRootExitStatus = 1, $2111b2a4c096959e$var$logUncaughtError(root, $2111b2a4c096959e$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $2111b2a4c096959e$var$pushDispatcher() {
    var prevDispatcher = $2111b2a4c096959e$var$ReactSharedInternals.H;
    $2111b2a4c096959e$var$ReactSharedInternals.H = $2111b2a4c096959e$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $2111b2a4c096959e$var$ContextOnlyDispatcher : prevDispatcher;
}
function $2111b2a4c096959e$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $2111b2a4c096959e$var$ReactSharedInternals.A;
    $2111b2a4c096959e$var$ReactSharedInternals.A = $2111b2a4c096959e$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $2111b2a4c096959e$var$renderDidSuspendDelayIfPossible() {
    $2111b2a4c096959e$var$workInProgressRootExitStatus = 4;
    $2111b2a4c096959e$var$workInProgressRootDidSkipSuspendedSiblings || ($2111b2a4c096959e$var$workInProgressRootRenderLanes & 4194048) !== $2111b2a4c096959e$var$workInProgressRootRenderLanes && null !== $2111b2a4c096959e$var$suspenseHandlerStackCursor.current || ($2111b2a4c096959e$var$workInProgressRootIsPrerendering = !0);
    0 === ($2111b2a4c096959e$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($2111b2a4c096959e$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $2111b2a4c096959e$var$workInProgressRoot || $2111b2a4c096959e$var$markRootSuspended($2111b2a4c096959e$var$workInProgressRoot, $2111b2a4c096959e$var$workInProgressRootRenderLanes, $2111b2a4c096959e$var$workInProgressDeferredLane, !1);
}
function $2111b2a4c096959e$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $2111b2a4c096959e$var$executionContext;
    $2111b2a4c096959e$var$executionContext |= 2;
    var prevDispatcher = $2111b2a4c096959e$var$pushDispatcher(), prevAsyncDispatcher = $2111b2a4c096959e$var$pushAsyncDispatcher();
    if ($2111b2a4c096959e$var$workInProgressRoot !== root || $2111b2a4c096959e$var$workInProgressRootRenderLanes !== lanes) $2111b2a4c096959e$var$workInProgressTransitions = null, $2111b2a4c096959e$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $2111b2a4c096959e$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $2111b2a4c096959e$var$workInProgressSuspendedReason && null !== $2111b2a4c096959e$var$workInProgress) {
            var unitOfWork = $2111b2a4c096959e$var$workInProgress, thrownValue = $2111b2a4c096959e$var$workInProgressThrownValue;
            switch($2111b2a4c096959e$var$workInProgressSuspendedReason){
                case 8:
                    $2111b2a4c096959e$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $2111b2a4c096959e$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $2111b2a4c096959e$var$workInProgressSuspendedReason;
                    $2111b2a4c096959e$var$workInProgressSuspendedReason = 0;
                    $2111b2a4c096959e$var$workInProgressThrownValue = null;
                    $2111b2a4c096959e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $2111b2a4c096959e$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $2111b2a4c096959e$var$workInProgressSuspendedReason, $2111b2a4c096959e$var$workInProgressSuspendedReason = 0, $2111b2a4c096959e$var$workInProgressThrownValue = null, $2111b2a4c096959e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $2111b2a4c096959e$var$workLoopSync();
        exitStatus = $2111b2a4c096959e$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $2111b2a4c096959e$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $2111b2a4c096959e$var$lastContextDependency = $2111b2a4c096959e$var$currentlyRenderingFiber$1 = null;
    $2111b2a4c096959e$var$executionContext = prevExecutionContext;
    $2111b2a4c096959e$var$ReactSharedInternals.H = prevDispatcher;
    $2111b2a4c096959e$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $2111b2a4c096959e$var$workInProgress && ($2111b2a4c096959e$var$workInProgressRoot = null, $2111b2a4c096959e$var$workInProgressRootRenderLanes = 0, $2111b2a4c096959e$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $2111b2a4c096959e$var$workLoopSync() {
    for(; null !== $2111b2a4c096959e$var$workInProgress;)$2111b2a4c096959e$var$performUnitOfWork($2111b2a4c096959e$var$workInProgress);
}
function $2111b2a4c096959e$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $2111b2a4c096959e$var$executionContext;
    $2111b2a4c096959e$var$executionContext |= 2;
    var prevDispatcher = $2111b2a4c096959e$var$pushDispatcher(), prevAsyncDispatcher = $2111b2a4c096959e$var$pushAsyncDispatcher();
    $2111b2a4c096959e$var$workInProgressRoot !== root || $2111b2a4c096959e$var$workInProgressRootRenderLanes !== lanes ? ($2111b2a4c096959e$var$workInProgressTransitions = null, $2111b2a4c096959e$var$workInProgressRootRenderTargetTime = $2111b2a4c096959e$var$now() + 500, $2111b2a4c096959e$var$prepareFreshStack(root, lanes)) : $2111b2a4c096959e$var$workInProgressRootIsPrerendering = $2111b2a4c096959e$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $2111b2a4c096959e$var$workInProgressSuspendedReason && null !== $2111b2a4c096959e$var$workInProgress) {
            lanes = $2111b2a4c096959e$var$workInProgress;
            var thrownValue = $2111b2a4c096959e$var$workInProgressThrownValue;
            b: switch($2111b2a4c096959e$var$workInProgressSuspendedReason){
                case 1:
                    $2111b2a4c096959e$var$workInProgressSuspendedReason = 0;
                    $2111b2a4c096959e$var$workInProgressThrownValue = null;
                    $2111b2a4c096959e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($2111b2a4c096959e$var$isThenableResolved(thrownValue)) {
                        $2111b2a4c096959e$var$workInProgressSuspendedReason = 0;
                        $2111b2a4c096959e$var$workInProgressThrownValue = null;
                        $2111b2a4c096959e$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function lanes() {
                        2 !== $2111b2a4c096959e$var$workInProgressSuspendedReason && 9 !== $2111b2a4c096959e$var$workInProgressSuspendedReason || $2111b2a4c096959e$var$workInProgressRoot !== root || ($2111b2a4c096959e$var$workInProgressSuspendedReason = 7);
                        $2111b2a4c096959e$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $2111b2a4c096959e$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $2111b2a4c096959e$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $2111b2a4c096959e$var$isThenableResolved(thrownValue) ? ($2111b2a4c096959e$var$workInProgressSuspendedReason = 0, $2111b2a4c096959e$var$workInProgressThrownValue = null, $2111b2a4c096959e$var$replaySuspendedUnitOfWork(lanes)) : ($2111b2a4c096959e$var$workInProgressSuspendedReason = 0, $2111b2a4c096959e$var$workInProgressThrownValue = null, $2111b2a4c096959e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($2111b2a4c096959e$var$workInProgress.tag){
                        case 26:
                            resource = $2111b2a4c096959e$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $2111b2a4c096959e$var$workInProgress;
                            if (resource ? $2111b2a4c096959e$var$preloadResource(resource) : 1) {
                                $2111b2a4c096959e$var$workInProgressSuspendedReason = 0;
                                $2111b2a4c096959e$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $2111b2a4c096959e$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($2111b2a4c096959e$var$workInProgress = returnFiber, $2111b2a4c096959e$var$completeUnitOfWork(returnFiber)) : $2111b2a4c096959e$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $2111b2a4c096959e$var$workInProgressSuspendedReason = 0;
                    $2111b2a4c096959e$var$workInProgressThrownValue = null;
                    $2111b2a4c096959e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $2111b2a4c096959e$var$workInProgressSuspendedReason = 0;
                    $2111b2a4c096959e$var$workInProgressThrownValue = null;
                    $2111b2a4c096959e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $2111b2a4c096959e$var$resetWorkInProgressStack();
                    $2111b2a4c096959e$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($2111b2a4c096959e$var$formatProdErrorMessage(462));
            }
        }
        $2111b2a4c096959e$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $2111b2a4c096959e$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $2111b2a4c096959e$var$lastContextDependency = $2111b2a4c096959e$var$currentlyRenderingFiber$1 = null;
    $2111b2a4c096959e$var$ReactSharedInternals.H = prevDispatcher;
    $2111b2a4c096959e$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $2111b2a4c096959e$var$executionContext = prevExecutionContext;
    if (null !== $2111b2a4c096959e$var$workInProgress) return 0;
    $2111b2a4c096959e$var$workInProgressRoot = null;
    $2111b2a4c096959e$var$workInProgressRootRenderLanes = 0;
    $2111b2a4c096959e$var$finishQueueingConcurrentUpdates();
    return $2111b2a4c096959e$var$workInProgressRootExitStatus;
}
function $2111b2a4c096959e$var$workLoopConcurrentByScheduler() {
    for(; null !== $2111b2a4c096959e$var$workInProgress && !$2111b2a4c096959e$var$shouldYield();)$2111b2a4c096959e$var$performUnitOfWork($2111b2a4c096959e$var$workInProgress);
}
function $2111b2a4c096959e$var$performUnitOfWork(unitOfWork) {
    var next = $2111b2a4c096959e$var$beginWork(unitOfWork.alternate, unitOfWork, $2111b2a4c096959e$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $2111b2a4c096959e$var$completeUnitOfWork(unitOfWork) : $2111b2a4c096959e$var$workInProgress = next;
}
function $2111b2a4c096959e$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $2111b2a4c096959e$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $2111b2a4c096959e$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $2111b2a4c096959e$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $2111b2a4c096959e$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $2111b2a4c096959e$var$resetHooksOnUnwind(next);
        default:
            $2111b2a4c096959e$var$unwindInterruptedWork(current, next), next = $2111b2a4c096959e$var$workInProgress = $2111b2a4c096959e$var$resetWorkInProgress(next, $2111b2a4c096959e$var$entangledRenderLanes), next = $2111b2a4c096959e$var$beginWork(current, next, $2111b2a4c096959e$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $2111b2a4c096959e$var$completeUnitOfWork(unitOfWork) : $2111b2a4c096959e$var$workInProgress = next;
}
function $2111b2a4c096959e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $2111b2a4c096959e$var$lastContextDependency = $2111b2a4c096959e$var$currentlyRenderingFiber$1 = null;
    $2111b2a4c096959e$var$resetHooksOnUnwind(unitOfWork);
    $2111b2a4c096959e$var$thenableState = null;
    $2111b2a4c096959e$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($2111b2a4c096959e$var$throwException(root, returnFiber, unitOfWork, thrownValue, $2111b2a4c096959e$var$workInProgressRootRenderLanes)) {
            $2111b2a4c096959e$var$workInProgressRootExitStatus = 1;
            $2111b2a4c096959e$var$logUncaughtError(root, $2111b2a4c096959e$var$createCapturedValueAtFiber(thrownValue, root.current));
            $2111b2a4c096959e$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $2111b2a4c096959e$var$workInProgress = returnFiber, error;
        $2111b2a4c096959e$var$workInProgressRootExitStatus = 1;
        $2111b2a4c096959e$var$logUncaughtError(root, $2111b2a4c096959e$var$createCapturedValueAtFiber(thrownValue, root.current));
        $2111b2a4c096959e$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($2111b2a4c096959e$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($2111b2a4c096959e$var$workInProgressRootIsPrerendering || 0 !== ($2111b2a4c096959e$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($2111b2a4c096959e$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $2111b2a4c096959e$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $2111b2a4c096959e$var$unwindUnitOfWork(unitOfWork, root);
    } else $2111b2a4c096959e$var$completeUnitOfWork(unitOfWork);
}
function $2111b2a4c096959e$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $2111b2a4c096959e$var$unwindUnitOfWork(completedWork, $2111b2a4c096959e$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $2111b2a4c096959e$var$completeWork(completedWork.alternate, completedWork, $2111b2a4c096959e$var$entangledRenderLanes);
        if (null !== next) {
            $2111b2a4c096959e$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $2111b2a4c096959e$var$workInProgress = completedWork;
            return;
        }
        $2111b2a4c096959e$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $2111b2a4c096959e$var$workInProgressRootExitStatus && ($2111b2a4c096959e$var$workInProgressRootExitStatus = 5);
}
function $2111b2a4c096959e$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $2111b2a4c096959e$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $2111b2a4c096959e$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $2111b2a4c096959e$var$workInProgress = unitOfWork;
            return;
        }
        $2111b2a4c096959e$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $2111b2a4c096959e$var$workInProgressRootExitStatus = 6;
    $2111b2a4c096959e$var$workInProgress = null;
}
function $2111b2a4c096959e$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $2111b2a4c096959e$var$flushPendingEffects();
    while (0 !== $2111b2a4c096959e$var$pendingEffectsStatus);
    if (0 !== ($2111b2a4c096959e$var$executionContext & 6)) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $2111b2a4c096959e$var$concurrentlyUpdatedLanes;
        $2111b2a4c096959e$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $2111b2a4c096959e$var$workInProgressRoot && ($2111b2a4c096959e$var$workInProgress = $2111b2a4c096959e$var$workInProgressRoot = null, $2111b2a4c096959e$var$workInProgressRootRenderLanes = 0);
        $2111b2a4c096959e$var$pendingFinishedWork = finishedWork;
        $2111b2a4c096959e$var$pendingEffectsRoot = root;
        $2111b2a4c096959e$var$pendingEffectsLanes = lanes;
        $2111b2a4c096959e$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $2111b2a4c096959e$var$pendingPassiveTransitions = transitions;
        $2111b2a4c096959e$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $2111b2a4c096959e$var$scheduleCallback$1($2111b2a4c096959e$var$NormalPriority$1, function() {
            $2111b2a4c096959e$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $2111b2a4c096959e$var$ReactSharedInternals.T;
            $2111b2a4c096959e$var$ReactSharedInternals.T = null;
            transitions = $2111b2a4c096959e$var$ReactDOMSharedInternals.p;
            $2111b2a4c096959e$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $2111b2a4c096959e$var$executionContext;
            $2111b2a4c096959e$var$executionContext |= 4;
            try {
                $2111b2a4c096959e$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $2111b2a4c096959e$var$executionContext = spawnedLane, $2111b2a4c096959e$var$ReactDOMSharedInternals.p = transitions, $2111b2a4c096959e$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $2111b2a4c096959e$var$pendingEffectsStatus = 1;
        $2111b2a4c096959e$var$flushMutationEffects();
        $2111b2a4c096959e$var$flushLayoutEffects();
        $2111b2a4c096959e$var$flushSpawnedWork();
    }
}
function $2111b2a4c096959e$var$flushMutationEffects() {
    if (1 === $2111b2a4c096959e$var$pendingEffectsStatus) {
        $2111b2a4c096959e$var$pendingEffectsStatus = 0;
        var root = $2111b2a4c096959e$var$pendingEffectsRoot, finishedWork = $2111b2a4c096959e$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $2111b2a4c096959e$var$ReactSharedInternals.T;
            $2111b2a4c096959e$var$ReactSharedInternals.T = null;
            var previousPriority = $2111b2a4c096959e$var$ReactDOMSharedInternals.p;
            $2111b2a4c096959e$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $2111b2a4c096959e$var$executionContext;
            $2111b2a4c096959e$var$executionContext |= 4;
            try {
                $2111b2a4c096959e$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $2111b2a4c096959e$var$selectionInformation, curFocusedElem = $2111b2a4c096959e$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $2111b2a4c096959e$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $2111b2a4c096959e$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $2111b2a4c096959e$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $2111b2a4c096959e$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $2111b2a4c096959e$var$_enabled = !!$2111b2a4c096959e$var$eventsEnabled;
                $2111b2a4c096959e$var$selectionInformation = $2111b2a4c096959e$var$eventsEnabled = null;
            } finally{
                $2111b2a4c096959e$var$executionContext = prevExecutionContext, $2111b2a4c096959e$var$ReactDOMSharedInternals.p = previousPriority, $2111b2a4c096959e$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $2111b2a4c096959e$var$pendingEffectsStatus = 2;
    }
}
function $2111b2a4c096959e$var$flushLayoutEffects() {
    if (2 === $2111b2a4c096959e$var$pendingEffectsStatus) {
        $2111b2a4c096959e$var$pendingEffectsStatus = 0;
        var root = $2111b2a4c096959e$var$pendingEffectsRoot, finishedWork = $2111b2a4c096959e$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $2111b2a4c096959e$var$ReactSharedInternals.T;
            $2111b2a4c096959e$var$ReactSharedInternals.T = null;
            var previousPriority = $2111b2a4c096959e$var$ReactDOMSharedInternals.p;
            $2111b2a4c096959e$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $2111b2a4c096959e$var$executionContext;
            $2111b2a4c096959e$var$executionContext |= 4;
            try {
                $2111b2a4c096959e$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $2111b2a4c096959e$var$executionContext = prevExecutionContext, $2111b2a4c096959e$var$ReactDOMSharedInternals.p = previousPriority, $2111b2a4c096959e$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $2111b2a4c096959e$var$pendingEffectsStatus = 3;
    }
}
function $2111b2a4c096959e$var$flushSpawnedWork() {
    if (4 === $2111b2a4c096959e$var$pendingEffectsStatus || 3 === $2111b2a4c096959e$var$pendingEffectsStatus) {
        $2111b2a4c096959e$var$pendingEffectsStatus = 0;
        $2111b2a4c096959e$var$requestPaint();
        var root = $2111b2a4c096959e$var$pendingEffectsRoot, finishedWork = $2111b2a4c096959e$var$pendingFinishedWork, lanes = $2111b2a4c096959e$var$pendingEffectsLanes, recoverableErrors = $2111b2a4c096959e$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $2111b2a4c096959e$var$pendingEffectsStatus = 5 : ($2111b2a4c096959e$var$pendingEffectsStatus = 0, $2111b2a4c096959e$var$pendingFinishedWork = $2111b2a4c096959e$var$pendingEffectsRoot = null, $2111b2a4c096959e$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($2111b2a4c096959e$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $2111b2a4c096959e$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($2111b2a4c096959e$var$injectedHook && "function" === typeof $2111b2a4c096959e$var$injectedHook.onCommitFiberRoot) try {
            $2111b2a4c096959e$var$injectedHook.onCommitFiberRoot($2111b2a4c096959e$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $2111b2a4c096959e$var$ReactSharedInternals.T;
            remainingLanes = $2111b2a4c096959e$var$ReactDOMSharedInternals.p;
            $2111b2a4c096959e$var$ReactDOMSharedInternals.p = 2;
            $2111b2a4c096959e$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $2111b2a4c096959e$var$ReactSharedInternals.T = finishedWork, $2111b2a4c096959e$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($2111b2a4c096959e$var$pendingEffectsLanes & 3) && $2111b2a4c096959e$var$flushPendingEffects();
        $2111b2a4c096959e$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $2111b2a4c096959e$var$rootWithNestedUpdates ? $2111b2a4c096959e$var$nestedUpdateCount++ : ($2111b2a4c096959e$var$nestedUpdateCount = 0, $2111b2a4c096959e$var$rootWithNestedUpdates = root) : $2111b2a4c096959e$var$nestedUpdateCount = 0;
        $2111b2a4c096959e$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $2111b2a4c096959e$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $2111b2a4c096959e$var$releaseCache(remainingLanes)));
}
function $2111b2a4c096959e$var$flushPendingEffects(wasDelayedCommit) {
    $2111b2a4c096959e$var$flushMutationEffects();
    $2111b2a4c096959e$var$flushLayoutEffects();
    $2111b2a4c096959e$var$flushSpawnedWork();
    return $2111b2a4c096959e$var$flushPassiveEffects(wasDelayedCommit);
}
function $2111b2a4c096959e$var$flushPassiveEffects() {
    if (5 !== $2111b2a4c096959e$var$pendingEffectsStatus) return !1;
    var root = $2111b2a4c096959e$var$pendingEffectsRoot, remainingLanes = $2111b2a4c096959e$var$pendingEffectsRemainingLanes;
    $2111b2a4c096959e$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $2111b2a4c096959e$var$lanesToEventPriority($2111b2a4c096959e$var$pendingEffectsLanes), prevTransition = $2111b2a4c096959e$var$ReactSharedInternals.T, previousPriority = $2111b2a4c096959e$var$ReactDOMSharedInternals.p;
    try {
        $2111b2a4c096959e$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $2111b2a4c096959e$var$ReactSharedInternals.T = null;
        renderPriority = $2111b2a4c096959e$var$pendingPassiveTransitions;
        $2111b2a4c096959e$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $2111b2a4c096959e$var$pendingEffectsRoot, lanes = $2111b2a4c096959e$var$pendingEffectsLanes;
        $2111b2a4c096959e$var$pendingEffectsStatus = 0;
        $2111b2a4c096959e$var$pendingFinishedWork = $2111b2a4c096959e$var$pendingEffectsRoot = null;
        $2111b2a4c096959e$var$pendingEffectsLanes = 0;
        if (0 !== ($2111b2a4c096959e$var$executionContext & 6)) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(331));
        var prevExecutionContext = $2111b2a4c096959e$var$executionContext;
        $2111b2a4c096959e$var$executionContext |= 4;
        $2111b2a4c096959e$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $2111b2a4c096959e$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $2111b2a4c096959e$var$executionContext = prevExecutionContext;
        $2111b2a4c096959e$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($2111b2a4c096959e$var$injectedHook && "function" === typeof $2111b2a4c096959e$var$injectedHook.onPostCommitFiberRoot) try {
            $2111b2a4c096959e$var$injectedHook.onPostCommitFiberRoot($2111b2a4c096959e$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $2111b2a4c096959e$var$ReactDOMSharedInternals.p = previousPriority, $2111b2a4c096959e$var$ReactSharedInternals.T = prevTransition, $2111b2a4c096959e$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $2111b2a4c096959e$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $2111b2a4c096959e$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $2111b2a4c096959e$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $2111b2a4c096959e$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($2111b2a4c096959e$var$markRootUpdated$1(rootFiber, 2), $2111b2a4c096959e$var$ensureRootIsScheduled(rootFiber));
}
function $2111b2a4c096959e$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $2111b2a4c096959e$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $2111b2a4c096959e$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $2111b2a4c096959e$var$legacyErrorBoundariesThatAlreadyFailed || !$2111b2a4c096959e$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $2111b2a4c096959e$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $2111b2a4c096959e$var$createClassErrorUpdate(2);
                instance = $2111b2a4c096959e$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($2111b2a4c096959e$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $2111b2a4c096959e$var$markRootUpdated$1(instance, 2), $2111b2a4c096959e$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $2111b2a4c096959e$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $2111b2a4c096959e$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($2111b2a4c096959e$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $2111b2a4c096959e$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $2111b2a4c096959e$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $2111b2a4c096959e$var$workInProgressRoot === root && ($2111b2a4c096959e$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $2111b2a4c096959e$var$workInProgressRootExitStatus || 3 === $2111b2a4c096959e$var$workInProgressRootExitStatus && ($2111b2a4c096959e$var$workInProgressRootRenderLanes & 62914560) === $2111b2a4c096959e$var$workInProgressRootRenderLanes && 300 > $2111b2a4c096959e$var$now() - $2111b2a4c096959e$var$globalMostRecentFallbackTime ? 0 === ($2111b2a4c096959e$var$executionContext & 2) && $2111b2a4c096959e$var$prepareFreshStack(root, 0) : $2111b2a4c096959e$var$workInProgressRootPingedLanes |= pingedLanes, $2111b2a4c096959e$var$workInProgressSuspendedRetryLanes === $2111b2a4c096959e$var$workInProgressRootRenderLanes && ($2111b2a4c096959e$var$workInProgressSuspendedRetryLanes = 0));
    $2111b2a4c096959e$var$ensureRootIsScheduled(root);
}
function $2111b2a4c096959e$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $2111b2a4c096959e$var$claimNextRetryLane());
    boundaryFiber = $2111b2a4c096959e$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($2111b2a4c096959e$var$markRootUpdated$1(boundaryFiber, retryLane), $2111b2a4c096959e$var$ensureRootIsScheduled(boundaryFiber));
}
function $2111b2a4c096959e$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $2111b2a4c096959e$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $2111b2a4c096959e$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($2111b2a4c096959e$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $2111b2a4c096959e$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $2111b2a4c096959e$var$scheduleCallback$1(priorityLevel, callback) {
    return $2111b2a4c096959e$var$scheduleCallback$3(priorityLevel, callback);
}
var $2111b2a4c096959e$var$firstScheduledRoot = null, $2111b2a4c096959e$var$lastScheduledRoot = null, $2111b2a4c096959e$var$didScheduleMicrotask = !1, $2111b2a4c096959e$var$mightHavePendingSyncWork = !1, $2111b2a4c096959e$var$isFlushingWork = !1, $2111b2a4c096959e$var$currentEventTransitionLane = 0;
function $2111b2a4c096959e$var$ensureRootIsScheduled(root) {
    root !== $2111b2a4c096959e$var$lastScheduledRoot && null === root.next && (null === $2111b2a4c096959e$var$lastScheduledRoot ? $2111b2a4c096959e$var$firstScheduledRoot = $2111b2a4c096959e$var$lastScheduledRoot = root : $2111b2a4c096959e$var$lastScheduledRoot = $2111b2a4c096959e$var$lastScheduledRoot.next = root);
    $2111b2a4c096959e$var$mightHavePendingSyncWork = !0;
    $2111b2a4c096959e$var$didScheduleMicrotask || ($2111b2a4c096959e$var$didScheduleMicrotask = !0, $2111b2a4c096959e$var$scheduleImmediateRootScheduleTask());
}
function $2111b2a4c096959e$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$2111b2a4c096959e$var$isFlushingWork && $2111b2a4c096959e$var$mightHavePendingSyncWork) {
        $2111b2a4c096959e$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $2111b2a4c096959e$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $2111b2a4c096959e$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $2111b2a4c096959e$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $2111b2a4c096959e$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $2111b2a4c096959e$var$getNextLanes(root$174, root$174 === $2111b2a4c096959e$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $2111b2a4c096959e$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $2111b2a4c096959e$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $2111b2a4c096959e$var$isFlushingWork = !1;
    }
}
function $2111b2a4c096959e$var$processRootScheduleInImmediateTask() {
    $2111b2a4c096959e$var$processRootScheduleInMicrotask();
}
function $2111b2a4c096959e$var$processRootScheduleInMicrotask() {
    $2111b2a4c096959e$var$mightHavePendingSyncWork = $2111b2a4c096959e$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $2111b2a4c096959e$var$currentEventTransitionLane && ($2111b2a4c096959e$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $2111b2a4c096959e$var$currentEventTransitionLane), $2111b2a4c096959e$var$currentEventTransitionLane = 0);
    for(var currentTime = $2111b2a4c096959e$var$now(), prev = null, root = $2111b2a4c096959e$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $2111b2a4c096959e$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $2111b2a4c096959e$var$firstScheduledRoot = next : prev.next = next, null === next && ($2111b2a4c096959e$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $2111b2a4c096959e$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $2111b2a4c096959e$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $2111b2a4c096959e$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $2111b2a4c096959e$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $2111b2a4c096959e$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $2111b2a4c096959e$var$workInProgressRoot;
    suspendedLanes = $2111b2a4c096959e$var$workInProgressRootRenderLanes;
    suspendedLanes = $2111b2a4c096959e$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $2111b2a4c096959e$var$workInProgressSuspendedReason || 9 === $2111b2a4c096959e$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $2111b2a4c096959e$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $2111b2a4c096959e$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $2111b2a4c096959e$var$cancelCallback$1(pingedLanes);
        switch($2111b2a4c096959e$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $2111b2a4c096959e$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $2111b2a4c096959e$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $2111b2a4c096959e$var$IdlePriority;
                break;
            default:
                suspendedLanes = $2111b2a4c096959e$var$NormalPriority$1;
        }
        pingedLanes = $2111b2a4c096959e$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $2111b2a4c096959e$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $2111b2a4c096959e$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $2111b2a4c096959e$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $2111b2a4c096959e$var$pendingEffectsStatus && 5 !== $2111b2a4c096959e$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($2111b2a4c096959e$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $2111b2a4c096959e$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $2111b2a4c096959e$var$getNextLanes(root, root === $2111b2a4c096959e$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $2111b2a4c096959e$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $2111b2a4c096959e$var$scheduleTaskForRootDuringMicrotask(root, $2111b2a4c096959e$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $2111b2a4c096959e$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $2111b2a4c096959e$var$performSyncWorkOnRoot(root, lanes) {
    if ($2111b2a4c096959e$var$flushPendingEffects()) return null;
    $2111b2a4c096959e$var$performWorkOnRoot(root, lanes, !0);
}
function $2111b2a4c096959e$var$scheduleImmediateRootScheduleTask() {
    $2111b2a4c096959e$var$scheduleMicrotask(function() {
        0 !== ($2111b2a4c096959e$var$executionContext & 6) ? $2111b2a4c096959e$var$scheduleCallback$3($2111b2a4c096959e$var$ImmediatePriority, $2111b2a4c096959e$var$processRootScheduleInImmediateTask) : $2111b2a4c096959e$var$processRootScheduleInMicrotask();
    });
}
function $2111b2a4c096959e$var$requestTransitionLane() {
    0 === $2111b2a4c096959e$var$currentEventTransitionLane && ($2111b2a4c096959e$var$currentEventTransitionLane = $2111b2a4c096959e$var$claimNextTransitionLane());
    return $2111b2a4c096959e$var$currentEventTransitionLane;
}
function $2111b2a4c096959e$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === (typeof actionProp === "undefined" ? "undefined" : (0, $6zqIC._)(actionProp)) || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $2111b2a4c096959e$var$sanitizeURL("" + actionProp);
}
function $2111b2a4c096959e$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $2111b2a4c096959e$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $2111b2a4c096959e$var$coerceFormActionProp((nativeEventTarget[$2111b2a4c096959e$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$2111b2a4c096959e$var$internalPropsKey] || null) ? $2111b2a4c096959e$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $2111b2a4c096959e$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function listener() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $2111b2a4c096959e$var$currentEventTransitionLane) {
                                var formData = submitter ? $2111b2a4c096959e$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $2111b2a4c096959e$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $2111b2a4c096959e$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $2111b2a4c096959e$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $2111b2a4c096959e$var$i$jscomp$inline_1528 = 0; $2111b2a4c096959e$var$i$jscomp$inline_1528 < $2111b2a4c096959e$var$simpleEventPluginEvents.length; $2111b2a4c096959e$var$i$jscomp$inline_1528++){
    var $2111b2a4c096959e$var$eventName$jscomp$inline_1529 = $2111b2a4c096959e$var$simpleEventPluginEvents[$2111b2a4c096959e$var$i$jscomp$inline_1528], $2111b2a4c096959e$var$domEventName$jscomp$inline_1530 = $2111b2a4c096959e$var$eventName$jscomp$inline_1529.toLowerCase(), $2111b2a4c096959e$var$capitalizedEvent$jscomp$inline_1531 = $2111b2a4c096959e$var$eventName$jscomp$inline_1529[0].toUpperCase() + $2111b2a4c096959e$var$eventName$jscomp$inline_1529.slice(1);
    $2111b2a4c096959e$var$registerSimpleEvent($2111b2a4c096959e$var$domEventName$jscomp$inline_1530, "on" + $2111b2a4c096959e$var$capitalizedEvent$jscomp$inline_1531);
}
$2111b2a4c096959e$var$registerSimpleEvent($2111b2a4c096959e$var$ANIMATION_END, "onAnimationEnd");
$2111b2a4c096959e$var$registerSimpleEvent($2111b2a4c096959e$var$ANIMATION_ITERATION, "onAnimationIteration");
$2111b2a4c096959e$var$registerSimpleEvent($2111b2a4c096959e$var$ANIMATION_START, "onAnimationStart");
$2111b2a4c096959e$var$registerSimpleEvent("dblclick", "onDoubleClick");
$2111b2a4c096959e$var$registerSimpleEvent("focusin", "onFocus");
$2111b2a4c096959e$var$registerSimpleEvent("focusout", "onBlur");
$2111b2a4c096959e$var$registerSimpleEvent($2111b2a4c096959e$var$TRANSITION_RUN, "onTransitionRun");
$2111b2a4c096959e$var$registerSimpleEvent($2111b2a4c096959e$var$TRANSITION_START, "onTransitionStart");
$2111b2a4c096959e$var$registerSimpleEvent($2111b2a4c096959e$var$TRANSITION_CANCEL, "onTransitionCancel");
$2111b2a4c096959e$var$registerSimpleEvent($2111b2a4c096959e$var$TRANSITION_END, "onTransitionEnd");
$2111b2a4c096959e$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2111b2a4c096959e$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2111b2a4c096959e$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2111b2a4c096959e$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2111b2a4c096959e$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2111b2a4c096959e$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2111b2a4c096959e$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2111b2a4c096959e$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2111b2a4c096959e$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2111b2a4c096959e$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2111b2a4c096959e$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2111b2a4c096959e$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($2111b2a4c096959e$var$mediaEventTypes));
function $2111b2a4c096959e$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $2111b2a4c096959e$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $2111b2a4c096959e$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $2111b2a4c096959e$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$2111b2a4c096959e$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$2111b2a4c096959e$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($2111b2a4c096959e$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $2111b2a4c096959e$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $2111b2a4c096959e$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $2111b2a4c096959e$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $2111b2a4c096959e$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$2111b2a4c096959e$var$listeningMarker]) {
        rootContainerElement[$2111b2a4c096959e$var$listeningMarker] = !0;
        $2111b2a4c096959e$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($2111b2a4c096959e$var$nonDelegatedEvents.has(domEventName) || $2111b2a4c096959e$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $2111b2a4c096959e$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$2111b2a4c096959e$var$listeningMarker] || (ownerDocument[$2111b2a4c096959e$var$listeningMarker] = !0, $2111b2a4c096959e$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $2111b2a4c096959e$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($2111b2a4c096959e$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $2111b2a4c096959e$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $2111b2a4c096959e$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $2111b2a4c096959e$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$2111b2a4c096959e$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $2111b2a4c096959e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $2111b2a4c096959e$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $2111b2a4c096959e$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $2111b2a4c096959e$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $2111b2a4c096959e$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $2111b2a4c096959e$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticTouchEvent;
                        break;
                    case $2111b2a4c096959e$var$ANIMATION_END:
                    case $2111b2a4c096959e$var$ANIMATION_ITERATION:
                    case $2111b2a4c096959e$var$ANIMATION_START:
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticAnimationEvent;
                        break;
                    case $2111b2a4c096959e$var$TRANSITION_END:
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $2111b2a4c096959e$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $2111b2a4c096959e$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($2111b2a4c096959e$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $2111b2a4c096959e$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($2111b2a4c096959e$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$2111b2a4c096959e$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $2111b2a4c096959e$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $2111b2a4c096959e$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $2111b2a4c096959e$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $2111b2a4c096959e$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $2111b2a4c096959e$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $2111b2a4c096959e$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $2111b2a4c096959e$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $2111b2a4c096959e$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $2111b2a4c096959e$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $2111b2a4c096959e$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $2111b2a4c096959e$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $2111b2a4c096959e$var$getParent(inCapturePhase);
                                reactEventName = $2111b2a4c096959e$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $2111b2a4c096959e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $2111b2a4c096959e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $2111b2a4c096959e$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $2111b2a4c096959e$var$getTargetInstForChangeEvent;
                else if ($2111b2a4c096959e$var$isTextInputElement(reactName)) {
                    if ($2111b2a4c096959e$var$isInputEventSupported) getTargetInstFunc = $2111b2a4c096959e$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $2111b2a4c096959e$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $2111b2a4c096959e$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $2111b2a4c096959e$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $2111b2a4c096959e$var$getTargetInstForChangeEvent) : getTargetInstFunc = $2111b2a4c096959e$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $2111b2a4c096959e$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $2111b2a4c096959e$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $2111b2a4c096959e$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($2111b2a4c096959e$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $2111b2a4c096959e$var$activeElement = handleEventFunc, $2111b2a4c096959e$var$activeElementInst = targetInst, $2111b2a4c096959e$var$lastSelection = null;
                    break;
                case "focusout":
                    $2111b2a4c096959e$var$lastSelection = $2111b2a4c096959e$var$activeElementInst = $2111b2a4c096959e$var$activeElement = null;
                    break;
                case "mousedown":
                    $2111b2a4c096959e$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2111b2a4c096959e$var$mouseDown = !1;
                    $2111b2a4c096959e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($2111b2a4c096959e$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $2111b2a4c096959e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($2111b2a4c096959e$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $2111b2a4c096959e$var$isComposing ? $2111b2a4c096959e$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($2111b2a4c096959e$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($2111b2a4c096959e$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $2111b2a4c096959e$var$isComposing && (fallbackData = $2111b2a4c096959e$var$getData()) : ($2111b2a4c096959e$var$root = nativeEventTarget, $2111b2a4c096959e$var$startText = "value" in $2111b2a4c096959e$var$root ? $2111b2a4c096959e$var$root.value : $2111b2a4c096959e$var$root.textContent, $2111b2a4c096959e$var$isComposing = !0)), handleEventFunc = $2111b2a4c096959e$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $2111b2a4c096959e$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $2111b2a4c096959e$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $2111b2a4c096959e$var$canUseTextInputEvent ? $2111b2a4c096959e$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $2111b2a4c096959e$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $2111b2a4c096959e$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $2111b2a4c096959e$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $2111b2a4c096959e$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $2111b2a4c096959e$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $2111b2a4c096959e$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $2111b2a4c096959e$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $2111b2a4c096959e$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($2111b2a4c096959e$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $2111b2a4c096959e$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($2111b2a4c096959e$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $2111b2a4c096959e$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $2111b2a4c096959e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $2111b2a4c096959e$var$getListener(target, registrationName), null != stateNode && listeners.unshift($2111b2a4c096959e$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $2111b2a4c096959e$var$getListener(target, registrationName), null != stateNode && listeners.push($2111b2a4c096959e$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $2111b2a4c096959e$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $2111b2a4c096959e$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $2111b2a4c096959e$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($2111b2a4c096959e$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($2111b2a4c096959e$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $2111b2a4c096959e$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $2111b2a4c096959e$var$normalizeMarkupForTextOrAttribute(clientText);
    return $2111b2a4c096959e$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $2111b2a4c096959e$var$noop$1() {}
function $2111b2a4c096959e$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $2111b2a4c096959e$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value))) && "body" !== tag && $2111b2a4c096959e$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $2111b2a4c096959e$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $2111b2a4c096959e$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $2111b2a4c096959e$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $2111b2a4c096959e$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $2111b2a4c096959e$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $2111b2a4c096959e$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $2111b2a4c096959e$var$setProp(domElement, tag, "name", props.name, props, null), $2111b2a4c096959e$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $2111b2a4c096959e$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $2111b2a4c096959e$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($2111b2a4c096959e$var$setProp(domElement, tag, "encType", props.encType, props, null), $2111b2a4c096959e$var$setProp(domElement, tag, "method", props.method, props, null), $2111b2a4c096959e$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $2111b2a4c096959e$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $2111b2a4c096959e$var$noop$1);
            break;
        case "onScroll":
            null != value && $2111b2a4c096959e$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $2111b2a4c096959e$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) || !("__html" in value)) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value));
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value));
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value))) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $2111b2a4c096959e$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("toggle", domElement);
            $2111b2a4c096959e$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $2111b2a4c096959e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $2111b2a4c096959e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $2111b2a4c096959e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $2111b2a4c096959e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $2111b2a4c096959e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $2111b2a4c096959e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $2111b2a4c096959e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $2111b2a4c096959e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $2111b2a4c096959e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $2111b2a4c096959e$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $2111b2a4c096959e$var$aliases.get(key) || key, $2111b2a4c096959e$var$setValueForAttribute(domElement, key, value);
    }
}
function $2111b2a4c096959e$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $2111b2a4c096959e$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) || !("__html" in value)) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $2111b2a4c096959e$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value))) && $2111b2a4c096959e$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $2111b2a4c096959e$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $2111b2a4c096959e$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $2111b2a4c096959e$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$2111b2a4c096959e$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$2111b2a4c096959e$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $2111b2a4c096959e$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $2111b2a4c096959e$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("error", domElement);
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($2111b2a4c096959e$var$formatProdErrorMessage(137, tag));
                    default:
                        $2111b2a4c096959e$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $2111b2a4c096959e$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $2111b2a4c096959e$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $2111b2a4c096959e$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $2111b2a4c096959e$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $2111b2a4c096959e$var$track(domElement);
            return;
        case "select":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $2111b2a4c096959e$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $2111b2a4c096959e$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $2111b2a4c096959e$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(91));
                    break;
                default:
                    $2111b2a4c096959e$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $2111b2a4c096959e$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $2111b2a4c096959e$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== (typeof hasSrc === "undefined" ? "undefined" : (0, $6zqIC._)(hasSrc));
                    break;
                default:
                    $2111b2a4c096959e$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("toggle", domElement);
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("cancel", domElement);
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $2111b2a4c096959e$var$mediaEventTypes.length; hasSrc++)$2111b2a4c096959e$var$listenToNonDelegatedEvent($2111b2a4c096959e$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("error", domElement);
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $2111b2a4c096959e$var$listenToNonDelegatedEvent("error", domElement), $2111b2a4c096959e$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2111b2a4c096959e$var$formatProdErrorMessage(137, tag));
                default:
                    $2111b2a4c096959e$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($2111b2a4c096959e$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $2111b2a4c096959e$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $2111b2a4c096959e$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $2111b2a4c096959e$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $2111b2a4c096959e$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $2111b2a4c096959e$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $2111b2a4c096959e$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $2111b2a4c096959e$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $2111b2a4c096959e$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $2111b2a4c096959e$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $2111b2a4c096959e$var$updateOptions(domElement, !!lastProps, tag, !0) : $2111b2a4c096959e$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $2111b2a4c096959e$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $2111b2a4c096959e$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $2111b2a4c096959e$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $2111b2a4c096959e$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== (typeof propKey$205 === "undefined" ? "undefined" : (0, $6zqIC._)(propKey$205));
                    break;
                default:
                    $2111b2a4c096959e$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $2111b2a4c096959e$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $2111b2a4c096959e$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($2111b2a4c096959e$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $2111b2a4c096959e$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $2111b2a4c096959e$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $2111b2a4c096959e$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $2111b2a4c096959e$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $2111b2a4c096959e$var$eventsEnabled = null, $2111b2a4c096959e$var$selectionInformation = null;
function $2111b2a4c096959e$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $2111b2a4c096959e$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $2111b2a4c096959e$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $2111b2a4c096959e$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === (0, $6zqIC._)(props.children) || "object" === (0, $6zqIC._)(props.dangerouslySetInnerHTML) && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $2111b2a4c096959e$var$currentPopstateTransitionEvent = null;
function $2111b2a4c096959e$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $2111b2a4c096959e$var$currentPopstateTransitionEvent) return !1;
        $2111b2a4c096959e$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $2111b2a4c096959e$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $2111b2a4c096959e$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $2111b2a4c096959e$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $2111b2a4c096959e$var$localPromise = "function" === typeof Promise ? Promise : void 0, $2111b2a4c096959e$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2111b2a4c096959e$var$localPromise ? function scheduleMicrotask(callback) {
    return $2111b2a4c096959e$var$localPromise.resolve(null).then(callback).catch($2111b2a4c096959e$var$handleErrorInNextTick);
} : $2111b2a4c096959e$var$scheduleTimeout;
function $2111b2a4c096959e$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $2111b2a4c096959e$var$isSingletonScope(type) {
    return "head" === type;
}
function $2111b2a4c096959e$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $2111b2a4c096959e$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $2111b2a4c096959e$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $2111b2a4c096959e$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$2111b2a4c096959e$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $2111b2a4c096959e$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $2111b2a4c096959e$var$retryIfBlockedOn(suspenseInstance);
}
function $2111b2a4c096959e$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $2111b2a4c096959e$var$clearContainerSparingly(node);
                $2111b2a4c096959e$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $2111b2a4c096959e$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$2111b2a4c096959e$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $2111b2a4c096959e$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $2111b2a4c096959e$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $2111b2a4c096959e$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $2111b2a4c096959e$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $2111b2a4c096959e$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function listener1() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $2111b2a4c096959e$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $2111b2a4c096959e$var$previousHydratableOnEnteringScopedSingleton = null;
function $2111b2a4c096959e$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $2111b2a4c096959e$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $2111b2a4c096959e$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($2111b2a4c096959e$var$formatProdErrorMessage(451));
    }
}
function $2111b2a4c096959e$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $2111b2a4c096959e$var$detachDeletedInstance(instance);
}
var $2111b2a4c096959e$var$preloadPropsMap = new Map(), $2111b2a4c096959e$var$preconnectsSet = new Set();
function $2111b2a4c096959e$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $2111b2a4c096959e$var$previousDispatcher = $2111b2a4c096959e$var$ReactDOMSharedInternals.d;
$2111b2a4c096959e$var$ReactDOMSharedInternals.d = {
    f: $2111b2a4c096959e$var$flushSyncWork,
    r: $2111b2a4c096959e$var$requestFormReset,
    D: $2111b2a4c096959e$var$prefetchDNS,
    C: $2111b2a4c096959e$var$preconnect,
    L: $2111b2a4c096959e$var$preload,
    m: $2111b2a4c096959e$var$preloadModule,
    X: $2111b2a4c096959e$var$preinitScript,
    S: $2111b2a4c096959e$var$preinitStyle,
    M: $2111b2a4c096959e$var$preinitModuleScript
};
function $2111b2a4c096959e$var$flushSyncWork() {
    var previousWasRendering = $2111b2a4c096959e$var$previousDispatcher.f(), wasRendering = $2111b2a4c096959e$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $2111b2a4c096959e$var$requestFormReset(form) {
    var formInst = $2111b2a4c096959e$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $2111b2a4c096959e$var$requestFormReset$1(formInst) : $2111b2a4c096959e$var$previousDispatcher.r(form);
}
var $2111b2a4c096959e$var$globalDocument = "undefined" === typeof document ? null : document;
function $2111b2a4c096959e$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $2111b2a4c096959e$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $2111b2a4c096959e$var$preconnectsSet.has(limitedEscapedHref) || ($2111b2a4c096959e$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $2111b2a4c096959e$var$setInitialProperties(href, "link", rel), $2111b2a4c096959e$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $2111b2a4c096959e$var$prefetchDNS(href) {
    $2111b2a4c096959e$var$previousDispatcher.D(href);
    $2111b2a4c096959e$var$preconnectAs("dns-prefetch", href, null);
}
function $2111b2a4c096959e$var$preconnect(href, crossOrigin) {
    $2111b2a4c096959e$var$previousDispatcher.C(href, crossOrigin);
    $2111b2a4c096959e$var$preconnectAs("preconnect", href, crossOrigin);
}
function $2111b2a4c096959e$var$preload(href, as, options) {
    $2111b2a4c096959e$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $2111b2a4c096959e$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $2111b2a4c096959e$var$getStyleKey(href);
                break;
            case "script":
                key = $2111b2a4c096959e$var$getScriptKey(href);
        }
        $2111b2a4c096959e$var$preloadPropsMap.has(key) || (href = $2111b2a4c096959e$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $2111b2a4c096959e$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($2111b2a4c096959e$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($2111b2a4c096959e$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $2111b2a4c096959e$var$setInitialProperties(as, "link", href), $2111b2a4c096959e$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $2111b2a4c096959e$var$preloadModule(href, options) {
    $2111b2a4c096959e$var$previousDispatcher.m(href, options);
    var ownerDocument = $2111b2a4c096959e$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $2111b2a4c096959e$var$getScriptKey(href);
        }
        if (!$2111b2a4c096959e$var$preloadPropsMap.has(key) && (href = $2111b2a4c096959e$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $2111b2a4c096959e$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($2111b2a4c096959e$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $2111b2a4c096959e$var$setInitialProperties(as, "link", href);
            $2111b2a4c096959e$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $2111b2a4c096959e$var$preinitStyle(href, precedence, options) {
    $2111b2a4c096959e$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $2111b2a4c096959e$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $2111b2a4c096959e$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $2111b2a4c096959e$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($2111b2a4c096959e$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $2111b2a4c096959e$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $2111b2a4c096959e$var$preloadPropsMap.get(key)) && $2111b2a4c096959e$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $2111b2a4c096959e$var$markNodeAsHoistable(link);
                $2111b2a4c096959e$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $2111b2a4c096959e$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $2111b2a4c096959e$var$preinitScript(src, options) {
    $2111b2a4c096959e$var$previousDispatcher.X(src, options);
    var ownerDocument = $2111b2a4c096959e$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $2111b2a4c096959e$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $2111b2a4c096959e$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($2111b2a4c096959e$var$getScriptSelectorFromKey(key)), resource || (src = $2111b2a4c096959e$var$assign({
            src: src,
            async: !0
        }, options), (options = $2111b2a4c096959e$var$preloadPropsMap.get(key)) && $2111b2a4c096959e$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $2111b2a4c096959e$var$markNodeAsHoistable(resource), $2111b2a4c096959e$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $2111b2a4c096959e$var$preinitModuleScript(src, options) {
    $2111b2a4c096959e$var$previousDispatcher.M(src, options);
    var ownerDocument = $2111b2a4c096959e$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $2111b2a4c096959e$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $2111b2a4c096959e$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($2111b2a4c096959e$var$getScriptSelectorFromKey(key)), resource || (src = $2111b2a4c096959e$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $2111b2a4c096959e$var$preloadPropsMap.get(key)) && $2111b2a4c096959e$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $2111b2a4c096959e$var$markNodeAsHoistable(resource), $2111b2a4c096959e$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $2111b2a4c096959e$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $2111b2a4c096959e$var$rootInstanceStackCursor.current) ? $2111b2a4c096959e$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $2111b2a4c096959e$var$getStyleKey(pendingProps.href), pendingProps = $2111b2a4c096959e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $2111b2a4c096959e$var$getStyleKey(pendingProps.href);
                var styles$244 = $2111b2a4c096959e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($2111b2a4c096959e$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $2111b2a4c096959e$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $2111b2a4c096959e$var$preloadPropsMap.set(type, pendingProps), styles$244 || $2111b2a4c096959e$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== (typeof currentProps === "undefined" ? "undefined" : (0, $6zqIC._)(currentProps)) ? (currentProps = $2111b2a4c096959e$var$getScriptKey(pendingProps), pendingProps = $2111b2a4c096959e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($2111b2a4c096959e$var$formatProdErrorMessage(444, type));
    }
}
function $2111b2a4c096959e$var$getStyleKey(href) {
    return 'href="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $2111b2a4c096959e$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $2111b2a4c096959e$var$stylesheetPropsFromRawProps(rawProps) {
    return $2111b2a4c096959e$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $2111b2a4c096959e$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $2111b2a4c096959e$var$setInitialProperties(key, "link", preloadProps), $2111b2a4c096959e$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $2111b2a4c096959e$var$getScriptKey(src) {
    return '[src="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $2111b2a4c096959e$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $2111b2a4c096959e$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $2111b2a4c096959e$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $2111b2a4c096959e$var$markNodeAsHoistable(instance), instance;
            var styleProps = $2111b2a4c096959e$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $2111b2a4c096959e$var$markNodeAsHoistable(instance);
            $2111b2a4c096959e$var$setInitialProperties(instance, "style", styleProps);
            $2111b2a4c096959e$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $2111b2a4c096959e$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($2111b2a4c096959e$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $2111b2a4c096959e$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $2111b2a4c096959e$var$stylesheetPropsFromRawProps(props);
            (styleProps = $2111b2a4c096959e$var$preloadPropsMap.get(styleProps)) && $2111b2a4c096959e$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $2111b2a4c096959e$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $2111b2a4c096959e$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $2111b2a4c096959e$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $2111b2a4c096959e$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($2111b2a4c096959e$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $2111b2a4c096959e$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $2111b2a4c096959e$var$preloadPropsMap.get(instance$250)) instance = $2111b2a4c096959e$var$assign({}, props), $2111b2a4c096959e$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $2111b2a4c096959e$var$markNodeAsHoistable(styleProps);
            $2111b2a4c096959e$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($2111b2a4c096959e$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $2111b2a4c096959e$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $2111b2a4c096959e$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $2111b2a4c096959e$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $2111b2a4c096959e$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $2111b2a4c096959e$var$tagCaches = null;
function $2111b2a4c096959e$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $2111b2a4c096959e$var$tagCaches) {
        var cache = new Map();
        var caches = $2111b2a4c096959e$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $2111b2a4c096959e$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$2111b2a4c096959e$var$internalHoistableMarker] || node[$2111b2a4c096959e$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $2111b2a4c096959e$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $2111b2a4c096959e$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== (0, $6zqIC._)(props.async) && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $2111b2a4c096959e$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $2111b2a4c096959e$var$suspendedState = null;
function $2111b2a4c096959e$var$noop() {}
function $2111b2a4c096959e$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $2111b2a4c096959e$var$suspendedState) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(475));
    var state = $2111b2a4c096959e$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $2111b2a4c096959e$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($2111b2a4c096959e$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === (typeof hoistableRoot === "undefined" ? "undefined" : (0, $6zqIC._)(hoistableRoot)) && "function" === typeof hoistableRoot.then && (state.count++, state = $2111b2a4c096959e$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $2111b2a4c096959e$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $2111b2a4c096959e$var$stylesheetPropsFromRawProps(props);
            (key = $2111b2a4c096959e$var$preloadPropsMap.get(key)) && $2111b2a4c096959e$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $2111b2a4c096959e$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $2111b2a4c096959e$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $2111b2a4c096959e$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $2111b2a4c096959e$var$waitForCommitToBeReady() {
    if (null === $2111b2a4c096959e$var$suspendedState) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(475));
    var state = $2111b2a4c096959e$var$suspendedState;
    state.stylesheets && 0 === state.count && $2111b2a4c096959e$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $2111b2a4c096959e$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $2111b2a4c096959e$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $2111b2a4c096959e$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $2111b2a4c096959e$var$precedencesByRoot = null;
function $2111b2a4c096959e$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $2111b2a4c096959e$var$precedencesByRoot = new Map(), resources.forEach($2111b2a4c096959e$var$insertStylesheetIntoRoot, state), $2111b2a4c096959e$var$precedencesByRoot = null, $2111b2a4c096959e$var$onUnsuspend.call(state));
}
function $2111b2a4c096959e$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $2111b2a4c096959e$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $2111b2a4c096959e$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $2111b2a4c096959e$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $2111b2a4c096959e$var$HostTransitionContext = {
    $$typeof: $2111b2a4c096959e$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $2111b2a4c096959e$var$sharedNotPendingObject,
    _currentValue2: $2111b2a4c096959e$var$sharedNotPendingObject,
    _threadCount: 0
};
function $2111b2a4c096959e$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $2111b2a4c096959e$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2111b2a4c096959e$var$createLaneMap(0);
    this.hiddenUpdates = $2111b2a4c096959e$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $2111b2a4c096959e$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $2111b2a4c096959e$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $2111b2a4c096959e$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $2111b2a4c096959e$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $2111b2a4c096959e$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $2111b2a4c096959e$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $2111b2a4c096959e$var$emptyContextObject;
    parentComponent = $2111b2a4c096959e$var$emptyContextObject;
    return parentComponent;
}
function $2111b2a4c096959e$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $2111b2a4c096959e$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $2111b2a4c096959e$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $2111b2a4c096959e$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($2111b2a4c096959e$var$scheduleUpdateOnFiber(element, rootFiber, lane), $2111b2a4c096959e$var$entangleTransitions(element, rootFiber, lane));
}
function $2111b2a4c096959e$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $2111b2a4c096959e$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $2111b2a4c096959e$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $2111b2a4c096959e$var$markRetryLaneImpl(fiber, retryLane);
}
function $2111b2a4c096959e$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $2111b2a4c096959e$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $2111b2a4c096959e$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $2111b2a4c096959e$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $2111b2a4c096959e$var$_enabled = !0;
function $2111b2a4c096959e$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $2111b2a4c096959e$var$ReactSharedInternals.T;
    $2111b2a4c096959e$var$ReactSharedInternals.T = null;
    var previousPriority = $2111b2a4c096959e$var$ReactDOMSharedInternals.p;
    try {
        $2111b2a4c096959e$var$ReactDOMSharedInternals.p = 2, $2111b2a4c096959e$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $2111b2a4c096959e$var$ReactDOMSharedInternals.p = previousPriority, $2111b2a4c096959e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2111b2a4c096959e$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $2111b2a4c096959e$var$ReactSharedInternals.T;
    $2111b2a4c096959e$var$ReactSharedInternals.T = null;
    var previousPriority = $2111b2a4c096959e$var$ReactDOMSharedInternals.p;
    try {
        $2111b2a4c096959e$var$ReactDOMSharedInternals.p = 8, $2111b2a4c096959e$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $2111b2a4c096959e$var$ReactDOMSharedInternals.p = previousPriority, $2111b2a4c096959e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2111b2a4c096959e$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($2111b2a4c096959e$var$_enabled) {
        var blockedOn = $2111b2a4c096959e$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $2111b2a4c096959e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $2111b2a4c096959e$var$return_targetInst, targetContainer), $2111b2a4c096959e$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($2111b2a4c096959e$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($2111b2a4c096959e$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $2111b2a4c096959e$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $2111b2a4c096959e$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $2111b2a4c096959e$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $2111b2a4c096959e$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $2111b2a4c096959e$var$ensureRootIsScheduled(fiber);
                                0 === ($2111b2a4c096959e$var$executionContext & 6) && ($2111b2a4c096959e$var$workInProgressRootRenderTargetTime = $2111b2a4c096959e$var$now() + 500, $2111b2a4c096959e$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $2111b2a4c096959e$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $2111b2a4c096959e$var$scheduleUpdateOnFiber(root, fiber, 2), $2111b2a4c096959e$var$flushSyncWork$1(), $2111b2a4c096959e$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $2111b2a4c096959e$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $2111b2a4c096959e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $2111b2a4c096959e$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $2111b2a4c096959e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $2111b2a4c096959e$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $2111b2a4c096959e$var$getEventTarget(nativeEvent);
    return $2111b2a4c096959e$var$findInstanceBlockingTarget(nativeEvent);
}
var $2111b2a4c096959e$var$return_targetInst = null;
function $2111b2a4c096959e$var$findInstanceBlockingTarget(targetNode) {
    $2111b2a4c096959e$var$return_targetInst = null;
    targetNode = $2111b2a4c096959e$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $2111b2a4c096959e$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $2111b2a4c096959e$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $2111b2a4c096959e$var$return_targetInst = targetNode;
    return null;
}
function $2111b2a4c096959e$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($2111b2a4c096959e$var$getCurrentPriorityLevel()){
                case $2111b2a4c096959e$var$ImmediatePriority:
                    return 2;
                case $2111b2a4c096959e$var$UserBlockingPriority:
                    return 8;
                case $2111b2a4c096959e$var$NormalPriority$1:
                case $2111b2a4c096959e$var$LowPriority:
                    return 32;
                case $2111b2a4c096959e$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $2111b2a4c096959e$var$hasScheduledReplayAttempt = !1, $2111b2a4c096959e$var$queuedFocus = null, $2111b2a4c096959e$var$queuedDrag = null, $2111b2a4c096959e$var$queuedMouse = null, $2111b2a4c096959e$var$queuedPointers = new Map(), $2111b2a4c096959e$var$queuedPointerCaptures = new Map(), $2111b2a4c096959e$var$queuedExplicitHydrationTargets = [], $2111b2a4c096959e$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $2111b2a4c096959e$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $2111b2a4c096959e$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $2111b2a4c096959e$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $2111b2a4c096959e$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $2111b2a4c096959e$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2111b2a4c096959e$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $2111b2a4c096959e$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $2111b2a4c096959e$var$getInstanceFromNode(blockedOn), null !== blockedOn && $2111b2a4c096959e$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $2111b2a4c096959e$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $2111b2a4c096959e$var$queuedFocus = $2111b2a4c096959e$var$accumulateOrCreateContinuousQueuedReplayableEvent($2111b2a4c096959e$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $2111b2a4c096959e$var$queuedDrag = $2111b2a4c096959e$var$accumulateOrCreateContinuousQueuedReplayableEvent($2111b2a4c096959e$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $2111b2a4c096959e$var$queuedMouse = $2111b2a4c096959e$var$accumulateOrCreateContinuousQueuedReplayableEvent($2111b2a4c096959e$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $2111b2a4c096959e$var$queuedPointers.set(pointerId, $2111b2a4c096959e$var$accumulateOrCreateContinuousQueuedReplayableEvent($2111b2a4c096959e$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $2111b2a4c096959e$var$queuedPointerCaptures.set(pointerId, $2111b2a4c096959e$var$accumulateOrCreateContinuousQueuedReplayableEvent($2111b2a4c096959e$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $2111b2a4c096959e$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $2111b2a4c096959e$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $2111b2a4c096959e$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $2111b2a4c096959e$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $2111b2a4c096959e$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $2111b2a4c096959e$var$requestUpdateLane();
                            lane = $2111b2a4c096959e$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $2111b2a4c096959e$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $2111b2a4c096959e$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $2111b2a4c096959e$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $2111b2a4c096959e$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $2111b2a4c096959e$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $2111b2a4c096959e$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $2111b2a4c096959e$var$currentReplayingEvent = null;
        } else return targetContainers = $2111b2a4c096959e$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $2111b2a4c096959e$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $2111b2a4c096959e$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $2111b2a4c096959e$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $2111b2a4c096959e$var$replayUnblockedEvents() {
    $2111b2a4c096959e$var$hasScheduledReplayAttempt = !1;
    null !== $2111b2a4c096959e$var$queuedFocus && $2111b2a4c096959e$var$attemptReplayContinuousQueuedEvent($2111b2a4c096959e$var$queuedFocus) && ($2111b2a4c096959e$var$queuedFocus = null);
    null !== $2111b2a4c096959e$var$queuedDrag && $2111b2a4c096959e$var$attemptReplayContinuousQueuedEvent($2111b2a4c096959e$var$queuedDrag) && ($2111b2a4c096959e$var$queuedDrag = null);
    null !== $2111b2a4c096959e$var$queuedMouse && $2111b2a4c096959e$var$attemptReplayContinuousQueuedEvent($2111b2a4c096959e$var$queuedMouse) && ($2111b2a4c096959e$var$queuedMouse = null);
    $2111b2a4c096959e$var$queuedPointers.forEach($2111b2a4c096959e$var$attemptReplayContinuousQueuedEventInMap);
    $2111b2a4c096959e$var$queuedPointerCaptures.forEach($2111b2a4c096959e$var$attemptReplayContinuousQueuedEventInMap);
}
function $2111b2a4c096959e$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $2111b2a4c096959e$var$hasScheduledReplayAttempt || ($2111b2a4c096959e$var$hasScheduledReplayAttempt = !0, $bv0px.unstable_scheduleCallback($bv0px.unstable_NormalPriority, $2111b2a4c096959e$var$replayUnblockedEvents)));
}
var $2111b2a4c096959e$var$lastScheduledReplayQueue = null;
function $2111b2a4c096959e$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $2111b2a4c096959e$var$lastScheduledReplayQueue !== formReplayingQueue && ($2111b2a4c096959e$var$lastScheduledReplayQueue = formReplayingQueue, $bv0px.unstable_scheduleCallback($bv0px.unstable_NormalPriority, function() {
        $2111b2a4c096959e$var$lastScheduledReplayQueue === formReplayingQueue && ($2111b2a4c096959e$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $2111b2a4c096959e$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $2111b2a4c096959e$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $2111b2a4c096959e$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $2111b2a4c096959e$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $2111b2a4c096959e$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $2111b2a4c096959e$var$queuedFocus && $2111b2a4c096959e$var$scheduleCallbackIfUnblocked($2111b2a4c096959e$var$queuedFocus, unblocked);
    null !== $2111b2a4c096959e$var$queuedDrag && $2111b2a4c096959e$var$scheduleCallbackIfUnblocked($2111b2a4c096959e$var$queuedDrag, unblocked);
    null !== $2111b2a4c096959e$var$queuedMouse && $2111b2a4c096959e$var$scheduleCallbackIfUnblocked($2111b2a4c096959e$var$queuedMouse, unblocked);
    $2111b2a4c096959e$var$queuedPointers.forEach(unblock);
    $2111b2a4c096959e$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $2111b2a4c096959e$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $2111b2a4c096959e$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $2111b2a4c096959e$var$queuedExplicitHydrationTargets.length && (i = $2111b2a4c096959e$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$2111b2a4c096959e$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $2111b2a4c096959e$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$2111b2a4c096959e$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $2111b2a4c096959e$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$2111b2a4c096959e$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $2111b2a4c096959e$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $2111b2a4c096959e$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $2111b2a4c096959e$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$2111b2a4c096959e$var$ReactDOMHydrationRoot.prototype.render = $2111b2a4c096959e$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(409));
    var current = root.current, lane = $2111b2a4c096959e$var$requestUpdateLane();
    $2111b2a4c096959e$var$updateContainerImpl(current, lane, children, root, null, null);
};
$2111b2a4c096959e$var$ReactDOMHydrationRoot.prototype.unmount = $2111b2a4c096959e$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $2111b2a4c096959e$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $2111b2a4c096959e$var$flushSyncWork$1();
        container[$2111b2a4c096959e$var$internalContainerInstanceKey] = null;
    }
};
function $2111b2a4c096959e$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$2111b2a4c096959e$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $2111b2a4c096959e$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $2111b2a4c096959e$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $2111b2a4c096959e$var$queuedExplicitHydrationTargets[i].priority; i++);
        $2111b2a4c096959e$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $2111b2a4c096959e$var$attemptExplicitHydrationTarget(target);
    }
};
var $2111b2a4c096959e$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $4Bt61.version;
if ("19.1.0" !== $2111b2a4c096959e$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(527, $2111b2a4c096959e$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$2111b2a4c096959e$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($2111b2a4c096959e$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $2111b2a4c096959e$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $2111b2a4c096959e$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $2111b2a4c096959e$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $2111b2a4c096959e$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $2111b2a4c096959e$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$2111b2a4c096959e$var$hook$jscomp$inline_2257.isDisabled && $2111b2a4c096959e$var$hook$jscomp$inline_2257.supportsFiber) try {
        $2111b2a4c096959e$var$rendererID = $2111b2a4c096959e$var$hook$jscomp$inline_2257.inject($2111b2a4c096959e$var$internals$jscomp$inline_2256), $2111b2a4c096959e$var$injectedHook = $2111b2a4c096959e$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$2111b2a4c096959e$export$882461b6382ed46c = function(container, options) {
    if (!$2111b2a4c096959e$var$isValidContainer(container)) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $2111b2a4c096959e$var$defaultOnUncaughtError, onCaughtError = $2111b2a4c096959e$var$defaultOnCaughtError, onRecoverableError = $2111b2a4c096959e$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $2111b2a4c096959e$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$2111b2a4c096959e$var$internalContainerInstanceKey] = options.current;
    $2111b2a4c096959e$var$listenToAllSupportedEvents(container);
    return new $2111b2a4c096959e$var$ReactDOMRoot(options);
};
$2111b2a4c096959e$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$2111b2a4c096959e$var$isValidContainer(container)) throw Error($2111b2a4c096959e$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $2111b2a4c096959e$var$defaultOnUncaughtError, onCaughtError = $2111b2a4c096959e$var$defaultOnCaughtError, onRecoverableError = $2111b2a4c096959e$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $2111b2a4c096959e$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $2111b2a4c096959e$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $2111b2a4c096959e$var$requestUpdateLane();
    isStrictMode = $2111b2a4c096959e$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $2111b2a4c096959e$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $2111b2a4c096959e$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $2111b2a4c096959e$var$markRootUpdated$1(initialChildren, options);
    $2111b2a4c096959e$var$ensureRootIsScheduled(initialChildren);
    container[$2111b2a4c096959e$var$internalContainerInstanceKey] = initialChildren.current;
    $2111b2a4c096959e$var$listenToAllSupportedEvents(container);
    return new $2111b2a4c096959e$var$ReactDOMHydrationRoot(initialChildren);
};
$2111b2a4c096959e$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("bv0px", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5wCbe"));

});
parcelRegister("5wCbe", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $405d8eb50e97c264$export$c4744153514ff05d; }, function (v) { return $405d8eb50e97c264$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $405d8eb50e97c264$export$3e506c1ccc9cc1a7; }, function (v) { return $405d8eb50e97c264$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $405d8eb50e97c264$export$e26fe2ed2fa76875; }, function (v) { return $405d8eb50e97c264$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $405d8eb50e97c264$export$502329bbf4b505b1; }, function (v) { return $405d8eb50e97c264$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $405d8eb50e97c264$export$6e3807111c4874c4; }, function (v) { return $405d8eb50e97c264$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $405d8eb50e97c264$export$c27134553091fb3a; }, function (v) { return $405d8eb50e97c264$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $405d8eb50e97c264$export$33ee1acdc04fd2a2; }, function (v) { return $405d8eb50e97c264$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $405d8eb50e97c264$export$b00a404bbd5edef2; }, function (v) { return $405d8eb50e97c264$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $405d8eb50e97c264$export$d66a1c1c77bd778b; }, function (v) { return $405d8eb50e97c264$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $405d8eb50e97c264$export$d3dfb8e4810cb555; }, function (v) { return $405d8eb50e97c264$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $405d8eb50e97c264$export$72fdf0e06517287b; }, function (v) { return $405d8eb50e97c264$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $405d8eb50e97c264$export$816d2913ae6b83b1; }, function (v) { return $405d8eb50e97c264$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $405d8eb50e97c264$export$61bcfe829111a1d0; }, function (v) { return $405d8eb50e97c264$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $405d8eb50e97c264$export$7ee8c9beb337bc3f; }, function (v) { return $405d8eb50e97c264$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $405d8eb50e97c264$export$b5836b71941fa3ed; }, function (v) { return $405d8eb50e97c264$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $405d8eb50e97c264$export$cf845f2c119da08a; }, function (v) { return $405d8eb50e97c264$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $6zqIC = parcelRequire("6zqIC");
var $405d8eb50e97c264$export$c4744153514ff05d;
var $405d8eb50e97c264$export$3e506c1ccc9cc1a7;
var $405d8eb50e97c264$export$e26fe2ed2fa76875;
var $405d8eb50e97c264$export$502329bbf4b505b1;
var $405d8eb50e97c264$export$6e3807111c4874c4;
var $405d8eb50e97c264$export$c27134553091fb3a;
var $405d8eb50e97c264$export$33ee1acdc04fd2a2;
var $405d8eb50e97c264$export$b00a404bbd5edef2;
var $405d8eb50e97c264$export$d66a1c1c77bd778b;
var $405d8eb50e97c264$export$d3dfb8e4810cb555;
var $405d8eb50e97c264$export$72fdf0e06517287b;
var $405d8eb50e97c264$export$816d2913ae6b83b1;
var $405d8eb50e97c264$export$61bcfe829111a1d0;
var $405d8eb50e97c264$export$7ee8c9beb337bc3f;
var $405d8eb50e97c264$export$b5836b71941fa3ed;
var $405d8eb50e97c264$export$cf845f2c119da08a;
"use strict";
function $405d8eb50e97c264$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $405d8eb50e97c264$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $405d8eb50e97c264$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $405d8eb50e97c264$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $405d8eb50e97c264$var$compare(left, last)) rightIndex < length && 0 > $405d8eb50e97c264$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $405d8eb50e97c264$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $405d8eb50e97c264$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$405d8eb50e97c264$export$c4744153514ff05d = void 0;
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $6zqIC._)(performance)) && "function" === typeof performance.now) {
    var $405d8eb50e97c264$var$localPerformance = performance;
    $405d8eb50e97c264$export$c4744153514ff05d = function() {
        return $405d8eb50e97c264$var$localPerformance.now();
    };
} else {
    var $405d8eb50e97c264$var$localDate = Date, $405d8eb50e97c264$var$initialTime = $405d8eb50e97c264$var$localDate.now();
    $405d8eb50e97c264$export$c4744153514ff05d = function() {
        return $405d8eb50e97c264$var$localDate.now() - $405d8eb50e97c264$var$initialTime;
    };
}
var $405d8eb50e97c264$var$taskQueue = [], $405d8eb50e97c264$var$timerQueue = [], $405d8eb50e97c264$var$taskIdCounter = 1, $405d8eb50e97c264$var$currentTask = null, $405d8eb50e97c264$var$currentPriorityLevel = 3, $405d8eb50e97c264$var$isPerformingWork = !1, $405d8eb50e97c264$var$isHostCallbackScheduled = !1, $405d8eb50e97c264$var$isHostTimeoutScheduled = !1, $405d8eb50e97c264$var$needsPaint = !1, $405d8eb50e97c264$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $405d8eb50e97c264$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $405d8eb50e97c264$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $405d8eb50e97c264$var$advanceTimers(currentTime) {
    for(var timer = $405d8eb50e97c264$var$peek($405d8eb50e97c264$var$timerQueue); null !== timer;){
        if (null === timer.callback) $405d8eb50e97c264$var$pop($405d8eb50e97c264$var$timerQueue);
        else if (timer.startTime <= currentTime) $405d8eb50e97c264$var$pop($405d8eb50e97c264$var$timerQueue), timer.sortIndex = timer.expirationTime, $405d8eb50e97c264$var$push($405d8eb50e97c264$var$taskQueue, timer);
        else break;
        timer = $405d8eb50e97c264$var$peek($405d8eb50e97c264$var$timerQueue);
    }
}
function $405d8eb50e97c264$var$handleTimeout(currentTime) {
    $405d8eb50e97c264$var$isHostTimeoutScheduled = !1;
    $405d8eb50e97c264$var$advanceTimers(currentTime);
    if (!$405d8eb50e97c264$var$isHostCallbackScheduled) {
        if (null !== $405d8eb50e97c264$var$peek($405d8eb50e97c264$var$taskQueue)) $405d8eb50e97c264$var$isHostCallbackScheduled = !0, $405d8eb50e97c264$var$isMessageLoopRunning || ($405d8eb50e97c264$var$isMessageLoopRunning = !0, $405d8eb50e97c264$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $405d8eb50e97c264$var$peek($405d8eb50e97c264$var$timerQueue);
            null !== firstTimer && $405d8eb50e97c264$var$requestHostTimeout($405d8eb50e97c264$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $405d8eb50e97c264$var$isMessageLoopRunning = !1, $405d8eb50e97c264$var$taskTimeoutID = -1, $405d8eb50e97c264$var$frameInterval = 5, $405d8eb50e97c264$var$startTime = -1;
function $405d8eb50e97c264$var$shouldYieldToHost() {
    return $405d8eb50e97c264$var$needsPaint ? !0 : $405d8eb50e97c264$export$c4744153514ff05d() - $405d8eb50e97c264$var$startTime < $405d8eb50e97c264$var$frameInterval ? !1 : !0;
}
function $405d8eb50e97c264$var$performWorkUntilDeadline() {
    $405d8eb50e97c264$var$needsPaint = !1;
    if ($405d8eb50e97c264$var$isMessageLoopRunning) {
        var currentTime = $405d8eb50e97c264$export$c4744153514ff05d();
        $405d8eb50e97c264$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $405d8eb50e97c264$var$isHostCallbackScheduled = !1;
                $405d8eb50e97c264$var$isHostTimeoutScheduled && ($405d8eb50e97c264$var$isHostTimeoutScheduled = !1, $405d8eb50e97c264$var$localClearTimeout($405d8eb50e97c264$var$taskTimeoutID), $405d8eb50e97c264$var$taskTimeoutID = -1);
                $405d8eb50e97c264$var$isPerformingWork = !0;
                var previousPriorityLevel = $405d8eb50e97c264$var$currentPriorityLevel;
                try {
                    b: {
                        $405d8eb50e97c264$var$advanceTimers(currentTime);
                        for($405d8eb50e97c264$var$currentTask = $405d8eb50e97c264$var$peek($405d8eb50e97c264$var$taskQueue); null !== $405d8eb50e97c264$var$currentTask && !($405d8eb50e97c264$var$currentTask.expirationTime > currentTime && $405d8eb50e97c264$var$shouldYieldToHost());){
                            var callback = $405d8eb50e97c264$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $405d8eb50e97c264$var$currentTask.callback = null;
                                $405d8eb50e97c264$var$currentPriorityLevel = $405d8eb50e97c264$var$currentTask.priorityLevel;
                                var continuationCallback = callback($405d8eb50e97c264$var$currentTask.expirationTime <= currentTime);
                                currentTime = $405d8eb50e97c264$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $405d8eb50e97c264$var$currentTask.callback = continuationCallback;
                                    $405d8eb50e97c264$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $405d8eb50e97c264$var$currentTask === $405d8eb50e97c264$var$peek($405d8eb50e97c264$var$taskQueue) && $405d8eb50e97c264$var$pop($405d8eb50e97c264$var$taskQueue);
                                $405d8eb50e97c264$var$advanceTimers(currentTime);
                            } else $405d8eb50e97c264$var$pop($405d8eb50e97c264$var$taskQueue);
                            $405d8eb50e97c264$var$currentTask = $405d8eb50e97c264$var$peek($405d8eb50e97c264$var$taskQueue);
                        }
                        if (null !== $405d8eb50e97c264$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $405d8eb50e97c264$var$peek($405d8eb50e97c264$var$timerQueue);
                            null !== firstTimer && $405d8eb50e97c264$var$requestHostTimeout($405d8eb50e97c264$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $405d8eb50e97c264$var$currentTask = null, $405d8eb50e97c264$var$currentPriorityLevel = previousPriorityLevel, $405d8eb50e97c264$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $405d8eb50e97c264$var$schedulePerformWorkUntilDeadline() : $405d8eb50e97c264$var$isMessageLoopRunning = !1;
        }
    }
}
var $405d8eb50e97c264$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $405d8eb50e97c264$var$localSetImmediate) $405d8eb50e97c264$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $405d8eb50e97c264$var$localSetImmediate($405d8eb50e97c264$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $405d8eb50e97c264$var$channel = new MessageChannel(), $405d8eb50e97c264$var$port = $405d8eb50e97c264$var$channel.port2;
    $405d8eb50e97c264$var$channel.port1.onmessage = $405d8eb50e97c264$var$performWorkUntilDeadline;
    $405d8eb50e97c264$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
        $405d8eb50e97c264$var$port.postMessage(null);
    };
} else $405d8eb50e97c264$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $405d8eb50e97c264$var$localSetTimeout($405d8eb50e97c264$var$performWorkUntilDeadline, 0);
};
function $405d8eb50e97c264$var$requestHostTimeout(callback, ms) {
    $405d8eb50e97c264$var$taskTimeoutID = $405d8eb50e97c264$var$localSetTimeout(function() {
        callback($405d8eb50e97c264$export$c4744153514ff05d());
    }, ms);
}
$405d8eb50e97c264$export$3e506c1ccc9cc1a7 = 5;
$405d8eb50e97c264$export$e26fe2ed2fa76875 = 1;
$405d8eb50e97c264$export$502329bbf4b505b1 = 4;
$405d8eb50e97c264$export$6e3807111c4874c4 = 3;
$405d8eb50e97c264$export$c27134553091fb3a = null;
$405d8eb50e97c264$export$33ee1acdc04fd2a2 = 2;
$405d8eb50e97c264$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$405d8eb50e97c264$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $405d8eb50e97c264$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$405d8eb50e97c264$export$d3dfb8e4810cb555 = function() {
    return $405d8eb50e97c264$var$currentPriorityLevel;
};
$405d8eb50e97c264$export$72fdf0e06517287b = function(eventHandler) {
    switch($405d8eb50e97c264$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $405d8eb50e97c264$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $405d8eb50e97c264$var$currentPriorityLevel;
    $405d8eb50e97c264$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $405d8eb50e97c264$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$405d8eb50e97c264$export$816d2913ae6b83b1 = function() {
    $405d8eb50e97c264$var$needsPaint = !0;
};
$405d8eb50e97c264$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $405d8eb50e97c264$var$currentPriorityLevel;
    $405d8eb50e97c264$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $405d8eb50e97c264$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$405d8eb50e97c264$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $405d8eb50e97c264$export$c4744153514ff05d();
    "object" === (typeof options === "undefined" ? "undefined" : (0, $6zqIC._)(options)) && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $405d8eb50e97c264$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $405d8eb50e97c264$var$push($405d8eb50e97c264$var$timerQueue, priorityLevel), null === $405d8eb50e97c264$var$peek($405d8eb50e97c264$var$taskQueue) && priorityLevel === $405d8eb50e97c264$var$peek($405d8eb50e97c264$var$timerQueue) && ($405d8eb50e97c264$var$isHostTimeoutScheduled ? ($405d8eb50e97c264$var$localClearTimeout($405d8eb50e97c264$var$taskTimeoutID), $405d8eb50e97c264$var$taskTimeoutID = -1) : $405d8eb50e97c264$var$isHostTimeoutScheduled = !0, $405d8eb50e97c264$var$requestHostTimeout($405d8eb50e97c264$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $405d8eb50e97c264$var$push($405d8eb50e97c264$var$taskQueue, priorityLevel), $405d8eb50e97c264$var$isHostCallbackScheduled || $405d8eb50e97c264$var$isPerformingWork || ($405d8eb50e97c264$var$isHostCallbackScheduled = !0, $405d8eb50e97c264$var$isMessageLoopRunning || ($405d8eb50e97c264$var$isMessageLoopRunning = !0, $405d8eb50e97c264$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$405d8eb50e97c264$export$b5836b71941fa3ed = $405d8eb50e97c264$var$shouldYieldToHost;
$405d8eb50e97c264$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $405d8eb50e97c264$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $405d8eb50e97c264$var$currentPriorityLevel;
        $405d8eb50e97c264$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $405d8eb50e97c264$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("4Bt61", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5HVm7"));

});

parcelRegister("bQr77", function(module, exports) {
'use strict';
function $89f99546f5054100$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($89f99546f5054100$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$89f99546f5054100$var$checkDCE();

module.exports = (parcelRequire("kU72X"));

});
parcelRegister("kU72X", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $f37e80f367dab62d$export$69ce8ef3fe5cead0; }, function (v) { return $f37e80f367dab62d$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $f37e80f367dab62d$export$d39a5bbd09211389; }, function (v) { return $f37e80f367dab62d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $f37e80f367dab62d$export$cd75ccfd720a3cd4; }, function (v) { return $f37e80f367dab62d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $f37e80f367dab62d$export$a0816fa17a9e79be; }, function (v) { return $f37e80f367dab62d$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $f37e80f367dab62d$export$7292efcadded39f3; }, function (v) { return $f37e80f367dab62d$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $f37e80f367dab62d$export$da407abadb9b8f86; }, function (v) { return $f37e80f367dab62d$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $f37e80f367dab62d$export$314cfea32580671c; }, function (v) { return $f37e80f367dab62d$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $f37e80f367dab62d$export$513ccb98c53b8039; }, function (v) { return $f37e80f367dab62d$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $f37e80f367dab62d$export$dbca993bc2d264a; }, function (v) { return $f37e80f367dab62d$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $f37e80f367dab62d$export$4797a8006f0655d0; }, function (v) { return $f37e80f367dab62d$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $f37e80f367dab62d$export$c78a37762a8d58e1; }, function (v) { return $f37e80f367dab62d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $f37e80f367dab62d$export$606f11b2eb45ecc6; }, function (v) { return $f37e80f367dab62d$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $f37e80f367dab62d$export$f7e8a0bf92324b1e; }, function (v) { return $f37e80f367dab62d$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $f37e80f367dab62d$export$83d89fbfd8236492; }, function (v) { return $f37e80f367dab62d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $6zqIC = parcelRequire("6zqIC");
var $f37e80f367dab62d$export$69ce8ef3fe5cead0;
var $f37e80f367dab62d$export$d39a5bbd09211389;
var $f37e80f367dab62d$export$cd75ccfd720a3cd4;
var $f37e80f367dab62d$export$a0816fa17a9e79be;
var $f37e80f367dab62d$export$7292efcadded39f3;
var $f37e80f367dab62d$export$da407abadb9b8f86;
var $f37e80f367dab62d$export$314cfea32580671c;
var $f37e80f367dab62d$export$513ccb98c53b8039;
var $f37e80f367dab62d$export$dbca993bc2d264a;
var $f37e80f367dab62d$export$4797a8006f0655d0;
var $f37e80f367dab62d$export$c78a37762a8d58e1;
var $f37e80f367dab62d$export$606f11b2eb45ecc6;
var $f37e80f367dab62d$export$f7e8a0bf92324b1e;
var $f37e80f367dab62d$export$83d89fbfd8236492;
"use strict";

var $4Bt61 = parcelRequire("4Bt61");
function $f37e80f367dab62d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $f37e80f367dab62d$var$noop() {}
var $f37e80f367dab62d$var$Internals = {
    d: {
        f: $f37e80f367dab62d$var$noop,
        r: function r() {
            throw Error($f37e80f367dab62d$var$formatProdErrorMessage(522));
        },
        D: $f37e80f367dab62d$var$noop,
        C: $f37e80f367dab62d$var$noop,
        L: $f37e80f367dab62d$var$noop,
        m: $f37e80f367dab62d$var$noop,
        X: $f37e80f367dab62d$var$noop,
        S: $f37e80f367dab62d$var$noop,
        M: $f37e80f367dab62d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $f37e80f367dab62d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $f37e80f367dab62d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f37e80f367dab62d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $f37e80f367dab62d$var$ReactSharedInternals = $4Bt61.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $f37e80f367dab62d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$f37e80f367dab62d$export$69ce8ef3fe5cead0 = $f37e80f367dab62d$var$Internals;
$f37e80f367dab62d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($f37e80f367dab62d$var$formatProdErrorMessage(299));
    return $f37e80f367dab62d$var$createPortal$1(children, container, null, key);
};
$f37e80f367dab62d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $f37e80f367dab62d$var$ReactSharedInternals.T, previousUpdatePriority = $f37e80f367dab62d$var$Internals.p;
    try {
        if ($f37e80f367dab62d$var$ReactSharedInternals.T = null, $f37e80f367dab62d$var$Internals.p = 2, fn) return fn();
    } finally{
        $f37e80f367dab62d$var$ReactSharedInternals.T = previousTransition, $f37e80f367dab62d$var$Internals.p = previousUpdatePriority, $f37e80f367dab62d$var$Internals.d.f();
    }
};
$f37e80f367dab62d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $f37e80f367dab62d$var$Internals.d.C(href, options));
};
$f37e80f367dab62d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $f37e80f367dab62d$var$Internals.d.D(href);
};
$f37e80f367dab62d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $f37e80f367dab62d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $f37e80f367dab62d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $f37e80f367dab62d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$f37e80f367dab62d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === (typeof options === "undefined" ? "undefined" : (0, $6zqIC._)(options)) && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $f37e80f367dab62d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $f37e80f367dab62d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $f37e80f367dab62d$var$Internals.d.M(href);
    }
};
$f37e80f367dab62d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === (typeof options === "undefined" ? "undefined" : (0, $6zqIC._)(options)) && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $f37e80f367dab62d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $f37e80f367dab62d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$f37e80f367dab62d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $f37e80f367dab62d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $f37e80f367dab62d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $f37e80f367dab62d$var$Internals.d.m(href);
    }
};
$f37e80f367dab62d$export$4797a8006f0655d0 = function(form) {
    $f37e80f367dab62d$var$Internals.d.r(form);
};
$f37e80f367dab62d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$f37e80f367dab62d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $f37e80f367dab62d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$f37e80f367dab62d$export$f7e8a0bf92324b1e = function() {
    return $f37e80f367dab62d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$f37e80f367dab62d$export$83d89fbfd8236492 = "19.1.0";

});



var $2fa82f22a26d0c86$exports = {};
'use strict';

$2fa82f22a26d0c86$exports = (parcelRequire("bLAFc"));


parcelRequire("4Bt61");
var $8949e5ebfdf38b70$exports = {};
'use strict';
function $8949e5ebfdf38b70$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($8949e5ebfdf38b70$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$8949e5ebfdf38b70$var$checkDCE();

$8949e5ebfdf38b70$exports = (parcelRequire("2Q1CL"));


/**
 * React Router v6.11.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $694ec11b01060e1e$export$71511d61b312f219(o) {
    $694ec11b01060e1e$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $694ec11b01060e1e$export$71511d61b312f219(o);
}


function $d6712f806fb9421e$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($d6712f806fb9421e$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $95590d0c8085e427$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $6zqIC = parcelRequire("6zqIC");
function $da22c13eee4a9850$export$71511d61b312f219(self, call) {
    if (call && ((0, $6zqIC._)(call) === "object" || typeof call === "function")) return call;
    return (0, $95590d0c8085e427$export$71511d61b312f219)(self);
}


function $0b418693cc8cec34$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $694ec11b01060e1e$export$71511d61b312f219)(derived);
    return (0, $da22c13eee4a9850$export$71511d61b312f219)(_this, (0, $d6712f806fb9421e$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $694ec11b01060e1e$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}


function $787a87339a4cca7b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $893843b5bdfb5320$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $893843b5bdfb5320$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $893843b5bdfb5320$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $893843b5bdfb5320$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $d0b362515118bdb9$export$71511d61b312f219(o, p) {
    $d0b362515118bdb9$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d0b362515118bdb9$export$71511d61b312f219(o, p);
}


function $ba30ceb37f7eb488$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $d0b362515118bdb9$export$71511d61b312f219)(subClass, superClass);
}


function $86a5dfb33a848ddc$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $409c15c2c71fb6b6$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $e7fed334ed9e06d0$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c6a5cc06c93a0628$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $02d7e0a711145bb5$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c6a5cc06c93a0628$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c6a5cc06c93a0628$export$71511d61b312f219)(o, minLen);
}


function $b0842d51d9c0999a$export$71511d61b312f219(arr, i) {
    return (0, $86a5dfb33a848ddc$export$71511d61b312f219)(arr) || (0, $409c15c2c71fb6b6$export$71511d61b312f219)(arr, i) || (0, $02d7e0a711145bb5$export$71511d61b312f219)(arr, i) || (0, $e7fed334ed9e06d0$export$71511d61b312f219)();
}



function $12a4bd8835c29f80$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c6a5cc06c93a0628$export$71511d61b312f219)(arr);
}


function $e6ef795f3f4cfa0e$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $419cf9fb1c81f8ea$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $15f090c73cfda84a$export$71511d61b312f219(arr) {
    return (0, $12a4bd8835c29f80$export$71511d61b312f219)(arr) || (0, $e6ef795f3f4cfa0e$export$71511d61b312f219)(arr) || (0, $02d7e0a711145bb5$export$71511d61b312f219)(arr) || (0, $419cf9fb1c81f8ea$export$71511d61b312f219)();
}



var $4Bt61 = parcelRequire("4Bt61");
/**
 * @remix-run/router v1.6.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d3fb01611386816$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $1d3fb01611386816$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $1d3fb01611386816$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $1d3fb01611386816$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function $01539ab334a9139b$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}








function $e71697af67a1332e$export$71511d61b312f219(arr) {
    return (0, $86a5dfb33a848ddc$export$71511d61b312f219)(arr) || (0, $e6ef795f3f4cfa0e$export$71511d61b312f219)(arr) || (0, $02d7e0a711145bb5$export$71511d61b312f219)(arr) || (0, $e7fed334ed9e06d0$export$71511d61b312f219)();
}




var $6zqIC = parcelRequire("6zqIC");


function $4d83b6f05d43e420$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $d6712f806fb9421e$export$71511d61b312f219)()) $4d83b6f05d43e420$export$71511d61b312f219 = Reflect.construct;
    else $4d83b6f05d43e420$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $d0b362515118bdb9$export$71511d61b312f219)(instance, Class.prototype);
        return instance;
    };
    return $4d83b6f05d43e420$export$71511d61b312f219.apply(null, arguments);
}



function $0f5db5401a009111$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $4e05a11b9081f740$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $4e05a11b9081f740$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $0f5db5401a009111$export$71511d61b312f219)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $4d83b6f05d43e420$export$71511d61b312f219)(Class, arguments, (0, $694ec11b01060e1e$export$71511d61b312f219)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $d0b362515118bdb9$export$71511d61b312f219)(Wrapper, Class);
    };
    return $4e05a11b9081f740$export$71511d61b312f219(Class);
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $6zqIC = parcelRequire("6zqIC");
var $47055dab5b247348$var$extendStatics = function extendStatics1(d, b) {
    $47055dab5b247348$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $47055dab5b247348$var$extendStatics(d, b);
};
function $47055dab5b247348$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $47055dab5b247348$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $47055dab5b247348$export$18ce0697a983be9b = function __assign1() {
    $47055dab5b247348$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $47055dab5b247348$export$18ce0697a983be9b.apply(this, arguments);
};
function $47055dab5b247348$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $47055dab5b247348$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $6zqIC._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $47055dab5b247348$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $47055dab5b247348$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $6zqIC._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $47055dab5b247348$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $47055dab5b247348$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $6zqIC._)(x)) === "symbol" ? x : "".concat(x);
}
function $47055dab5b247348$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $6zqIC._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $47055dab5b247348$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $6zqIC._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $47055dab5b247348$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $47055dab5b247348$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $47055dab5b247348$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $47055dab5b247348$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $47055dab5b247348$export$45d3717a4c69092e(o, m, p);
}
function $47055dab5b247348$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $47055dab5b247348$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $47055dab5b247348$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($47055dab5b247348$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $47055dab5b247348$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $47055dab5b247348$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $47055dab5b247348$export$10c90e4f7922046c(v) {
    return this instanceof $47055dab5b247348$export$10c90e4f7922046c ? (this.v = v, this) : new $47055dab5b247348$export$10c90e4f7922046c(v);
}
function $47055dab5b247348$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $47055dab5b247348$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $47055dab5b247348$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $47055dab5b247348$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $47055dab5b247348$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $47055dab5b247348$export$19a8beecd37a4c45 === "function" ? $47055dab5b247348$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $47055dab5b247348$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $47055dab5b247348$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $47055dab5b247348$var$ownKeys = function ownKeys1(o) {
    $47055dab5b247348$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $47055dab5b247348$var$ownKeys(o);
};
function $47055dab5b247348$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $47055dab5b247348$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $47055dab5b247348$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $47055dab5b247348$var$__setModuleDefault(result, mod);
    return result;
}
function $47055dab5b247348$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $47055dab5b247348$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $47055dab5b247348$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $47055dab5b247348$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $6zqIC._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $47055dab5b247348$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $6zqIC._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $47055dab5b247348$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $47055dab5b247348$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $47055dab5b247348$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $47055dab5b247348$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $47055dab5b247348$export$2e2bcd8739ae039 = {
    __extends: $47055dab5b247348$export$a8ba968b8961cb8a,
    __assign: $47055dab5b247348$export$18ce0697a983be9b,
    __rest: $47055dab5b247348$export$3c9a16f847548506,
    __decorate: $47055dab5b247348$export$29e00dfd3077644b,
    __param: $47055dab5b247348$export$d5ad3fd78186038f,
    __esDecorate: $47055dab5b247348$export$3a84e1ae4e97e9b0,
    __runInitializers: $47055dab5b247348$export$d831c04e792af3d,
    __propKey: $47055dab5b247348$export$6a2a36740a146cb8,
    __setFunctionName: $47055dab5b247348$export$d1a06452d3489bc7,
    __metadata: $47055dab5b247348$export$f1db080c865becb9,
    __awaiter: $47055dab5b247348$export$1050f835b63b671e,
    __generator: $47055dab5b247348$export$67ebef60e6f28a6,
    __createBinding: $47055dab5b247348$export$45d3717a4c69092e,
    __exportStar: $47055dab5b247348$export$f33643c0debef087,
    __values: $47055dab5b247348$export$19a8beecd37a4c45,
    __read: $47055dab5b247348$export$8d051b38c9118094,
    __spread: $47055dab5b247348$export$afc72e2116322959,
    __spreadArrays: $47055dab5b247348$export$6388937ca91ccae8,
    __spreadArray: $47055dab5b247348$export$1216008129fb82ed,
    __await: $47055dab5b247348$export$10c90e4f7922046c,
    __asyncGenerator: $47055dab5b247348$export$e427f37a30a4de9b,
    __asyncDelegator: $47055dab5b247348$export$bbd80228419bb833,
    __asyncValues: $47055dab5b247348$export$e3b29a3d6162315f,
    __makeTemplateObject: $47055dab5b247348$export$4fb47efe1390b86f,
    __importStar: $47055dab5b247348$export$c21735bcef00d192,
    __importDefault: $47055dab5b247348$export$da59b14a69baef04,
    __classPrivateFieldGet: $47055dab5b247348$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $47055dab5b247348$export$d40a35129aaff81f,
    __classPrivateFieldIn: $47055dab5b247348$export$81fdc39f203e4e04,
    __addDisposableResource: $47055dab5b247348$export$88ac25d8e944e405,
    __disposeResources: $47055dab5b247348$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $47055dab5b247348$export$889dfb5d17574b0b
};



function $3a208abeb0ec52b2$var$_extends() {
    $3a208abeb0ec52b2$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3a208abeb0ec52b2$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $3a208abeb0ec52b2$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($3a208abeb0ec52b2$export$e19cd5f9376f8cee || ($3a208abeb0ec52b2$export$e19cd5f9376f8cee = {}));
var $3a208abeb0ec52b2$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $3a208abeb0ec52b2$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $3a208abeb0ec52b2$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $3a208abeb0ec52b2$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $3a208abeb0ec52b2$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $3a208abeb0ec52b2$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $3a208abeb0ec52b2$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $3a208abeb0ec52b2$export$fe53371bee54353d(to);
    }
    return $3a208abeb0ec52b2$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $3a208abeb0ec52b2$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $3a208abeb0ec52b2$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        return $3a208abeb0ec52b2$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $3a208abeb0ec52b2$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $3a208abeb0ec52b2$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $3a208abeb0ec52b2$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $3a208abeb0ec52b2$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $3a208abeb0ec52b2$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $3a208abeb0ec52b2$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $3a208abeb0ec52b2$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $3a208abeb0ec52b2$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $3a208abeb0ec52b2$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $3a208abeb0ec52b2$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $3a208abeb0ec52b2$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $3a208abeb0ec52b2$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $3a208abeb0ec52b2$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, _$window = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = _$window.history;
    var action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($3a208abeb0ec52b2$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push;
        var location = $3a208abeb0ec52b2$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $3a208abeb0ec52b2$var$getHistoryState(location, index);
        var url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            _$window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace;
        var location = $3a208abeb0ec52b2$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $3a208abeb0ec52b2$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = _$window.location.origin !== "null" ? _$window.location.origin : _$window.location.href;
        var href = typeof to === "string" ? to : $3a208abeb0ec52b2$export$fe53371bee54353d(to);
        $3a208abeb0ec52b2$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(_$window, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            _$window.addEventListener($3a208abeb0ec52b2$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                _$window.removeEventListener($3a208abeb0ec52b2$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(_$window, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $3a208abeb0ec52b2$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($3a208abeb0ec52b2$var$ResultType || ($3a208abeb0ec52b2$var$ResultType = {}));
var $3a208abeb0ec52b2$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $3a208abeb0ec52b2$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $3a208abeb0ec52b2$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $15f090c73cfda84a$export$71511d61b312f219)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $3a208abeb0ec52b2$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $3a208abeb0ec52b2$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($3a208abeb0ec52b2$var$isIndexRoute(route)) {
            var indexRoute = $3a208abeb0ec52b2$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $3a208abeb0ec52b2$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $3a208abeb0ec52b2$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $3a208abeb0ec52b2$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $3a208abeb0ec52b2$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $3a208abeb0ec52b2$var$flattenRoutes(routes);
    $3a208abeb0ec52b2$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $3a208abeb0ec52b2$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $3a208abeb0ec52b2$var$safelyDecodeURI(pathname));
    return matches;
}
function $3a208abeb0ec52b2$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $3a208abeb0ec52b2$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $3a208abeb0ec52b2$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $3a208abeb0ec52b2$export$3e9cee6b33872309(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $3a208abeb0ec52b2$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $3a208abeb0ec52b2$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $3a208abeb0ec52b2$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $3a208abeb0ec52b2$var$explodeOptionalSegments(path) {
    var // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $e71697af67a1332e$export$71511d61b312f219)(segments), first = _segments[0], rest = _segments.slice(1); // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $3a208abeb0ec52b2$var$explodeOptionalSegments(rest.join("/"));
    var result = []; // All child paths with the prefix.  Do this for all children before the
    (_result = result).push.apply(_result, (0, $15f090c73cfda84a$export$71511d61b312f219)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    }))); // Then if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $15f090c73cfda84a$export$71511d61b312f219)(restExploded));
     // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $3a208abeb0ec52b2$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $3a208abeb0ec52b2$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $3a208abeb0ec52b2$var$paramRe = /^:\w+$/;
var $3a208abeb0ec52b2$var$dynamicSegmentValue = 3;
var $3a208abeb0ec52b2$var$indexRouteValue = 2;
var $3a208abeb0ec52b2$var$emptySegmentValue = 1;
var $3a208abeb0ec52b2$var$staticSegmentValue = 10;
var $3a208abeb0ec52b2$var$splatPenalty = -2;
var $3a208abeb0ec52b2$var$isSplat = function(s) {
    return s === "*";
};
function $3a208abeb0ec52b2$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($3a208abeb0ec52b2$var$isSplat)) initialScore += $3a208abeb0ec52b2$var$splatPenalty;
    if (index) initialScore += $3a208abeb0ec52b2$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$3a208abeb0ec52b2$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($3a208abeb0ec52b2$var$paramRe.test(segment) ? $3a208abeb0ec52b2$var$dynamicSegmentValue : segment === "" ? $3a208abeb0ec52b2$var$emptySegmentValue : $3a208abeb0ec52b2$var$staticSegmentValue);
    }, initialScore);
}
function $3a208abeb0ec52b2$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $3a208abeb0ec52b2$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $3a208abeb0ec52b2$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $3a208abeb0ec52b2$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $3a208abeb0ec52b2$export$a5c6d149b50c1d86($3a208abeb0ec52b2$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $3a208abeb0ec52b2$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $3a208abeb0ec52b2$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $3a208abeb0ec52b2$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            var starParam = params[star]; // Apply the splat
            return starParam;
        }
        var keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $b0842d51d9c0999a$export$71511d61b312f219)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $3a208abeb0ec52b2$export$3e9cee6b33872309(false, "Missing \":" + key + "\" param");
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $3a208abeb0ec52b2$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $b0842d51d9c0999a$export$71511d61b312f219)($3a208abeb0ec52b2$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], paramNames = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = paramNames.reduce(function(memo, paramName, index) {
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $3a208abeb0ec52b2$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $3a208abeb0ec52b2$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $3a208abeb0ec52b2$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    var paramNames = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, function(_, paramName) {
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $3a208abeb0ec52b2$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $3a208abeb0ec52b2$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $3a208abeb0ec52b2$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $3a208abeb0ec52b2$export$c0e02632e14916fd(false, "The value for the URL param \"" + paramName + "\" will not be decoded because" + (" the string \"" + value + "\" is a malformed URL segment. This is probably") + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $3a208abeb0ec52b2$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $3a208abeb0ec52b2$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $3a208abeb0ec52b2$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $3a208abeb0ec52b2$var$normalizeSearch(search),
        hash: $3a208abeb0ec52b2$var$normalizeHash(hash)
    };
}
function $3a208abeb0ec52b2$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $3a208abeb0ec52b2$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $3a208abeb0ec52b2$export$90ba53ce1c7fdff2(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
/**
 * @private
 */ function $3a208abeb0ec52b2$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $3a208abeb0ec52b2$export$8ccf933b0513f8d0(toArg);
    else {
        to = $3a208abeb0ec52b2$var$_extends({}, toArg);
        $3a208abeb0ec52b2$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $3a208abeb0ec52b2$var$getInvalidPathError("?", "pathname", "search", to));
        $3a208abeb0ec52b2$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $3a208abeb0ec52b2$var$getInvalidPathError("#", "pathname", "hash", to));
        $3a208abeb0ec52b2$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $3a208abeb0ec52b2$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $3a208abeb0ec52b2$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $3a208abeb0ec52b2$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $3a208abeb0ec52b2$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $3a208abeb0ec52b2$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $3a208abeb0ec52b2$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $3a208abeb0ec52b2$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $3a208abeb0ec52b2$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $3a208abeb0ec52b2$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $3a208abeb0ec52b2$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ba30ceb37f7eb488$export$71511d61b312f219)(AbortedDeferredError, Error1);
    function AbortedDeferredError() {
        (0, $787a87339a4cca7b$export$71511d61b312f219)(this, AbortedDeferredError);
        return (0, $0b418693cc8cec34$export$71511d61b312f219)(this, AbortedDeferredError, arguments);
    }
    return AbortedDeferredError;
}((0, $4e05a11b9081f740$export$71511d61b312f219)(Error));
var $3a208abeb0ec52b2$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $787a87339a4cca7b$export$71511d61b312f219)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $3a208abeb0ec52b2$export$3e9cee6b33872309(data && (typeof data === "undefined" ? "undefined" : (0, $6zqIC._)(data)) === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $3a208abeb0ec52b2$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref) {
            var _$_ref = (0, $b0842d51d9c0999a$export$71511d61b312f219)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            return Object.assign(acc, (0, $01539ab334a9139b$export$71511d61b312f219)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $893843b5bdfb5320$export$71511d61b312f219)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, null, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                }); // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $3a208abeb0ec52b2$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                if (error) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
                    var _this, aborted, onAbort;
                    return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                aborted = false;
                                if (!!this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $3a208abeb0ec52b2$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref2) {
                    var _$_ref2 = (0, $b0842d51d9c0999a$export$71511d61b312f219)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
                    return Object.assign(acc, (0, $01539ab334a9139b$export$71511d61b312f219)({}, key, $3a208abeb0ec52b2$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $3a208abeb0ec52b2$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $3a208abeb0ec52b2$var$unwrapTrackedPromise(value) {
    if (!$3a208abeb0ec52b2$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $3a208abeb0ec52b2$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $3a208abeb0ec52b2$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $3a208abeb0ec52b2$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $3a208abeb0ec52b2$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ var $3a208abeb0ec52b2$export$acf1a680051f5031 = function ErrorResponse(status, statusText, data, internal) {
    "use strict";
    (0, $787a87339a4cca7b$export$71511d61b312f219)(this, ErrorResponse);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $3a208abeb0ec52b2$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $3a208abeb0ec52b2$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $3a208abeb0ec52b2$var$validMutationMethods = new Set($3a208abeb0ec52b2$var$validMutationMethodsArr);
var $3a208abeb0ec52b2$var$validRequestMethodsArr = [
    "get"
].concat((0, $15f090c73cfda84a$export$71511d61b312f219)($3a208abeb0ec52b2$var$validMutationMethodsArr));
var $3a208abeb0ec52b2$var$validRequestMethods = new Set($3a208abeb0ec52b2$var$validRequestMethodsArr);
var $3a208abeb0ec52b2$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $3a208abeb0ec52b2$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $3a208abeb0ec52b2$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
var $3a208abeb0ec52b2$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
var $3a208abeb0ec52b2$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $3a208abeb0ec52b2$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $3a208abeb0ec52b2$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $3a208abeb0ec52b2$var$isServer = !$3a208abeb0ec52b2$var$isBrowser;
var $3a208abeb0ec52b2$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
}; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $3a208abeb0ec52b2$export$baddd0131ee8c05b(init) {
    $3a208abeb0ec52b2$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $3a208abeb0ec52b2$var$defaultMapRouteProperties;
     // Routes keyed by ID
    var manifest = {}; // Routes in tree format for matching
    var dataRoutes = $3a208abeb0ec52b2$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/"; // Config driven behavior flags
    var future = $3a208abeb0ec52b2$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future); // Cleanup function for history
    var unlistenHistory = null; // Externally-provided functions to call on all state changes
    var subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    var getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $3a208abeb0ec52b2$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $3a208abeb0ec52b2$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $3a208abeb0ec52b2$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $01539ab334a9139b$export$71511d61b312f219)({}, route.id, error);
    }
    var initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some(function(m) {
        return m.route.lazy;
    }) && (!initialMatches.some(function(m) {
        return m.route.loader;
    }) || init.hydrationData != null);
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $3a208abeb0ec52b2$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false; // AbortController for the active navigation
    var pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map(); // Track loads based on the order in which they started
    var incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $3a208abeb0ec52b2$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $3a208abeb0ec52b2$var$_extends({}, state, newState);
        subscribers.forEach(function(subscriber) {
            return subscriber(state);
        });
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $3a208abeb0ec52b2$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $3a208abeb0ec52b2$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // so we can start fresh
            for(var _iterator = blockerFunctions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $b0842d51d9c0999a$export$71511d61b312f219)(_step.value, 1), key = _step_value[0];
                deleteBlocker(key);
            } // Always respect the user flag.  Otherwise don't reset on mutation
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $3a208abeb0ec52b2$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($3a208abeb0ec52b2$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $3a208abeb0ec52b2$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    function navigate(to, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, blockerKey;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $3a208abeb0ec52b2$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $3a208abeb0ec52b2$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $3a208abeb0ec52b2$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $3a208abeb0ec52b2$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $3a208abeb0ec52b2$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    }); // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    deleteBlocker(blockerKey);
                                    updateState({
                                        blockers: new Map(state.blockers)
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        })();
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    function startNavigation(historyAction, location, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var routesToUse, loadingNavigation, matches, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, navigation, _ref, shortCircuited, loaderData, errors;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $3a208abeb0ec52b2$export$2708184779ceb39d(routesToUse, location, basename); // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $3a208abeb0ec52b2$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route; // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $01539ab334a9139b$export$71511d61b312f219)({}, route.id, error)
                            });
                            return [
                                2
                            ];
                        } // Short circuit if it's only a hash change and not a mutation submission.
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".
                        // For example, on /page#hash and submit a <Form method="post"> which will
                        // default to a navigation to /page
                        if (state.initialized && $3a208abeb0ec52b2$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $3a208abeb0ec52b2$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            });
                            return [
                                2
                            ];
                        } // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $3a208abeb0ec52b2$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $01539ab334a9139b$export$71511d61b312f219)({}, $3a208abeb0ec52b2$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $3a208abeb0ec52b2$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        navigation = $3a208abeb0ec52b2$var$_extends({
                            state: "loading",
                            location: location
                        }, opts.submission);
                        loadingNavigation = navigation; // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                         // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $3a208abeb0ec52b2$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        })();
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    function handleAction(request, location, submission, matches, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads(); // Put us in a submitting state
                        navigation = $3a208abeb0ec52b2$var$_extends({
                            state: "submitting",
                            location: location
                        }, submission);
                        updateState({
                            navigation: navigation
                        }); // Call our action and get the result
                        actionMatch = $3a208abeb0ec52b2$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $3a208abeb0ec52b2$var$ResultType.error,
                            error: $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $3a208abeb0ec52b2$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$3a208abeb0ec52b2$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($3a208abeb0ec52b2$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $3a208abeb0ec52b2$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $01539ab334a9139b$export$71511d61b312f219)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($3a208abeb0ec52b2$var$isDeferredResult(result)) throw $3a208abeb0ec52b2$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $01539ab334a9139b$export$71511d61b312f219)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        })();
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var loadingNavigation, navigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation;
                        if (!loadingNavigation) {
                            navigation = $3a208abeb0ec52b2$var$_extends({
                                state: "loading",
                                location: location,
                                formMethod: undefined,
                                formAction: undefined,
                                formEncType: undefined,
                                formData: undefined
                            }, submission);
                            loadingNavigation = navigation;
                        } // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
                            formMethod: loadingNavigation.formMethod,
                            formAction: loadingNavigation.formAction,
                            formData: loadingNavigation.formData,
                            formEncType: loadingNavigation.formEncType
                        } : undefined;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $b0842d51d9c0999a$export$71511d61b312f219)($3a208abeb0ec52b2$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1]; // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        }); // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $3a208abeb0ec52b2$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        } // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        if (!isUninterruptedRevalidation) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = {
                                    state: "loading",
                                    data: fetcher && fetcher.data,
                                    formMethod: undefined,
                                    formAction: undefined,
                                    formEncType: undefined,
                                    formData: undefined,
                                    " _hasFetcherDoneAnything ": true
                                };
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($3a208abeb0ec52b2$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                        }
                        pendingNavigationLoadId = ++incrementingLoadId;
                        revalidatingFetchers.forEach(function(rf) {
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        }); // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                         // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        }); // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $3a208abeb0ec52b2$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            startRedirectNavigation(state, redirect, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        _processLoaderData = $3a208abeb0ec52b2$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors; // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $3a208abeb0ec52b2$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        })();
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $3a208abeb0ec52b2$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($3a208abeb0ec52b2$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $3a208abeb0ec52b2$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        var matches = $3a208abeb0ec52b2$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        var _normalizeNavigateOptions = $3a208abeb0ec52b2$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission;
        var match = $3a208abeb0ec52b2$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $3a208abeb0ec52b2$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var error, existingFetcher, fetcher, abortController, fetchRequest, actionResult, loadingFetcher, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher, didAbortFetchLoads;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error);
                            return [
                                2
                            ];
                        } // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        fetcher = $3a208abeb0ec52b2$var$_extends({
                            state: "submitting"
                        }, submission, {
                            data: existingFetcher && existingFetcher.data,
                            " _hasFetcherDoneAnything ": true
                        });
                        state.fetchers.set(key, fetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        }); // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = $3a208abeb0ec52b2$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        return [
                            4,
                            $3a208abeb0ec52b2$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by ou our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if ($3a208abeb0ec52b2$var$isRedirectResult(actionResult)) {
                            fetchControllers.delete(key);
                            fetchRedirectIds.add(key);
                            loadingFetcher = $3a208abeb0ec52b2$var$_extends({
                                state: "loading"
                            }, submission, {
                                data: undefined,
                                " _hasFetcherDoneAnything ": true
                            });
                            state.fetchers.set(key, loadingFetcher);
                            updateState({
                                fetchers: new Map(state.fetchers)
                            });
                            return [
                                2,
                                startRedirectNavigation(state, actionResult, {
                                    submission: submission,
                                    isFetchActionRedirect: true
                                })
                            ];
                        } // Process any non-redirect errors thrown
                        if ($3a208abeb0ec52b2$var$isErrorResult(actionResult)) {
                            setFetcherError(key, routeId, actionResult.error);
                            return [
                                2
                            ];
                        }
                        if ($3a208abeb0ec52b2$var$isDeferredResult(actionResult)) throw $3a208abeb0ec52b2$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                         // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $3a208abeb0ec52b2$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $3a208abeb0ec52b2$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $3a208abeb0ec52b2$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $3a208abeb0ec52b2$var$_extends({
                            state: "loading",
                            data: actionResult.data
                        }, submission, {
                            " _hasFetcherDoneAnything ": true
                        });
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $b0842d51d9c0999a$export$71511d61b312f219)($3a208abeb0ec52b2$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, (0, $01539ab334a9139b$export$71511d61b312f219)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1]; // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = {
                                state: "loading",
                                data: existingFetcher && existingFetcher.data,
                                formMethod: undefined,
                                formAction: undefined,
                                formEncType: undefined,
                                formData: undefined,
                                " _hasFetcherDoneAnything ": true
                            };
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $3a208abeb0ec52b2$var$findRedirect(results);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(state, redirect)
                        ];
                         // Process and commit output from loaders
                        _processLoaderData = $3a208abeb0ec52b2$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        doneFetcher = {
                            state: "idle",
                            data: actionResult.data,
                            formMethod: undefined,
                            formAction: undefined,
                            formEncType: undefined,
                            formData: undefined,
                            " _hasFetcherDoneAnything ": true
                        };
                        state.fetchers.set(key, doneFetcher);
                        didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $3a208abeb0ec52b2$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState($3a208abeb0ec52b2$var$_extends({
                                errors: errors,
                                loaderData: $3a208abeb0ec52b2$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
                            }, didAbortFetchLoads ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var existingFetcher, loadingFetcher, abortController, fetchRequest, result, boundaryMatch, doneFetcher;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
                        loadingFetcher = $3a208abeb0ec52b2$var$_extends({
                            state: "loading",
                            formMethod: undefined,
                            formAction: undefined,
                            formEncType: undefined,
                            formData: undefined
                        }, submission, {
                            data: existingFetcher && existingFetcher.data,
                            " _hasFetcherDoneAnything ": true
                        });
                        state.fetchers.set(key, loadingFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        }); // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = $3a208abeb0ec52b2$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        return [
                            4,
                            $3a208abeb0ec52b2$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$3a208abeb0ec52b2$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $3a208abeb0ec52b2$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                         // If the loader threw a redirect Response, start a new REPLACE navigation
                        if (!$3a208abeb0ec52b2$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        if ($3a208abeb0ec52b2$var$isErrorResult(result)) {
                            boundaryMatch = $3a208abeb0ec52b2$var$findNearestBoundary(state.matches, routeId);
                            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
                            // do we need to behave any differently with our non-redirect errors?
                            // What if it was a non-redirect Response?
                            updateState({
                                fetchers: new Map(state.fetchers),
                                errors: (0, $01539ab334a9139b$export$71511d61b312f219)({}, boundaryMatch.route.id, result.error)
                            });
                            return [
                                2
                            ];
                        }
                        $3a208abeb0ec52b2$export$3e9cee6b33872309(!$3a208abeb0ec52b2$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
                        doneFetcher = {
                            state: "idle",
                            data: result.data,
                            formMethod: undefined,
                            formAction: undefined,
                            formEncType: undefined,
                            formData: undefined,
                            " _hasFetcherDoneAnything ": true
                        };
                        state.fetchers.set(key, doneFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ function startRedirectNavigation(state, redirect, _temp) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var _window, _ref, submission, replace, isFetchActionRedirect, redirectLocation, url, isDifferentBasename, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, formData;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp === void 0 ? {} : _temp, submission = _ref.submission, replace = _ref.replace, isFetchActionRedirect = _ref.isFetchActionRedirect;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $3a208abeb0ec52b2$var$createLocation(state.location, redirect.location, $3a208abeb0ec52b2$var$_extends({
                            _isRedirect: true
                        }, isFetchActionRedirect ? {
                            _isFetchActionRedirect: true
                        } : {}));
                        $3a208abeb0ec52b2$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
                        if ($3a208abeb0ec52b2$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $3a208abeb0ec52b2$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
                            url = init.history.createURL(redirect.location);
                            isDifferentBasename = $3a208abeb0ec52b2$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            if (window.location.origin !== url.origin || isDifferentBasename) {
                                if (replace) window.location.replace(redirect.location);
                                else window.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        } // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace : $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType, formData = _state_navigation.formData;
                        if (!submission && formMethod && formAction && formData && formEncType) submission = {
                            formMethod: formMethod,
                            formAction: formAction,
                            formEncType: formEncType,
                            formData: formData
                        };
                         // If this was a 307/308 submission we want to preserve the HTTP method and
                        if (!($3a208abeb0ec52b2$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $3a208abeb0ec52b2$var$isMutationMethod(submission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $3a208abeb0ec52b2$var$_extends({}, submission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 2:
                        if (!isFetchActionRedirect) return [
                            3,
                            4
                        ];
                        // For a fetch action redirect, we kick off a new loading navigation
                        // without the fetcher submission, but we send it along for shouldRevalidate
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: {
                                    state: "loading",
                                    location: redirectLocation,
                                    formMethod: undefined,
                                    formAction: undefined,
                                    formEncType: undefined,
                                    formData: undefined
                                },
                                fetcherSubmission: submission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        // Otherwise, we kick off a new loading navigation, preserving the
                        // submission info for the duration of this navigation
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: {
                                    state: "loading",
                                    location: redirectLocation,
                                    formMethod: submission ? submission.formMethod : undefined,
                                    formAction: submission ? submission.formAction : undefined,
                                    formEncType: submission ? submission.formEncType : undefined,
                                    formData: submission ? submission.formData : undefined
                                },
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var results, loaderResults, fetcherResults;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $15f090c73cfda84a$export$71511d61b312f219)(matchesToLoad.map(function(match) {
                                return $3a208abeb0ec52b2$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename);
                            })).concat((0, $15f090c73cfda84a$export$71511d61b312f219)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $3a208abeb0ec52b2$var$callLoaderOrAction("loader", $3a208abeb0ec52b2$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                                else {
                                    var error = {
                                        type: $3a208abeb0ec52b2$var$ResultType.error,
                                        error: $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $3a208abeb0ec52b2$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $3a208abeb0ec52b2$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        })();
    }
    function interruptActiveLoads() {
        var // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $15f090c73cfda84a$export$71511d61b312f219)(cancelActiveDeferreds())); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        var boundaryMatch = $3a208abeb0ec52b2$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $01539ab334a9139b$export$71511d61b312f219)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $3a208abeb0ec52b2$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = {
                    state: "idle",
                    data: fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $3a208abeb0ec52b2$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $b0842d51d9c0999a$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $3a208abeb0ec52b2$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $3a208abeb0ec52b2$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $3a208abeb0ec52b2$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $3a208abeb0ec52b2$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $3a208abeb0ec52b2$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $b0842d51d9c0999a$export$71511d61b312f219)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || function(location) {
            return location.key;
        }; // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $3a208abeb0ec52b2$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            var userMatches = matches.map(function(m) {
                return $3a208abeb0ec52b2$var$createUseMatchesMatch(m, state.loaderData);
            });
            var key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            var userMatches = matches.map(function(m) {
                return $3a208abeb0ec52b2$var$createUseMatchesMatch(m, state.loaderData);
            });
            var key = getScrollRestorationKey(location, userMatches) || location.key;
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $3a208abeb0ec52b2$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $3a208abeb0ec52b2$export$4d0306f8f6a4585b = Symbol("deferred");
function $3a208abeb0ec52b2$export$3336b097a6fbc59a(routes, opts) {
    $3a208abeb0ec52b2$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $3a208abeb0ec52b2$var$defaultMapRouteProperties;
    var dataRoutes = $3a208abeb0ec52b2$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ function query(request, _temp2) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp2 === void 0 ? {} : _temp2).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $3a208abeb0ec52b2$var$createLocation("", $3a208abeb0ec52b2$export$fe53371bee54353d(url), null, "default");
                        matches = $3a208abeb0ec52b2$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
                        if (!$3a208abeb0ec52b2$var$isValidMethod(method) && method !== "HEAD") {
                            error = $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $3a208abeb0ec52b2$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $01539ab334a9139b$export$71511d61b312f219)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $3a208abeb0ec52b2$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $01539ab334a9139b$export$71511d61b312f219)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($3a208abeb0ec52b2$var$isResponse(result)) return [
                            2,
                            result
                        ];
                         // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $3a208abeb0ec52b2$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        })();
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ function queryRoute(request, _temp3) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $3a208abeb0ec52b2$var$createLocation("", $3a208abeb0ec52b2$export$fe53371bee54353d(url), null, "default");
                        matches = $3a208abeb0ec52b2$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
                        if (!$3a208abeb0ec52b2$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $3a208abeb0ec52b2$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $3a208abeb0ec52b2$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($3a208abeb0ec52b2$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                         // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$3a208abeb0ec52b2$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        })();
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var result, result1, e;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $3a208abeb0ec52b2$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$3a208abeb0ec52b2$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $3a208abeb0ec52b2$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $3a208abeb0ec52b2$var$isResponse(result1) ? result1 : $3a208abeb0ec52b2$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($3a208abeb0ec52b2$var$isQueryRouteResponse(e)) {
                            if (e.type === $3a208abeb0ec52b2$var$ResultType.error && !$3a208abeb0ec52b2$var$isRedirectResponse(e.response)) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        } // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($3a208abeb0ec52b2$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $3a208abeb0ec52b2$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $3a208abeb0ec52b2$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        }
                        _state.label = 3;
                    case 3:
                        if ($3a208abeb0ec52b2$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($3a208abeb0ec52b2$var$isDeferredResult(result)) {
                            error1 = $3a208abeb0ec52b2$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $3a208abeb0ec52b2$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($3a208abeb0ec52b2$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $01539ab334a9139b$export$71511d61b312f219)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$3a208abeb0ec52b2$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = $3a208abeb0ec52b2$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $01539ab334a9139b$export$71511d61b312f219)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        return [
                            2,
                            $3a208abeb0ec52b2$var$_extends({}, context, {
                                statusCode: $3a208abeb0ec52b2$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $3a208abeb0ec52b2$var$_extends({}, result.headers ? (0, $01539ab334a9139b$export$71511d61b312f219)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $3a208abeb0ec52b2$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $01539ab334a9139b$export$71511d61b312f219)({}, actionMatch.route.id, result.data),
                                actionHeaders: $3a208abeb0ec52b2$var$_extends({}, result.headers ? (0, $01539ab334a9139b$export$71511d61b312f219)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        })();
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $3a208abeb0ec52b2$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $3a208abeb0ec52b2$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        }); // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $01539ab334a9139b$export$71511d61b312f219)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $15f090c73cfda84a$export$71511d61b312f219)(matchesToLoad.map(function(match) {
                                return $3a208abeb0ec52b2$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext);
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        } // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $3a208abeb0ec52b2$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $3a208abeb0ec52b2$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        })();
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $3a208abeb0ec52b2$export$fec11da027c70692(routes, context, error) {
    var newContext = $3a208abeb0ec52b2$var$_extends({}, context, {
        statusCode: 500,
        errors: (0, $01539ab334a9139b$export$71511d61b312f219)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $3a208abeb0ec52b2$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
}
function $3a208abeb0ec52b2$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    } // Resolve the relative path
    var path = $3a208abeb0ec52b2$export$cae722b0cc860f13(to ? to : ".", $3a208abeb0ec52b2$export$90ba53ce1c7fdff2(contextualMatches).map(function(m) {
        return m.pathnameBase;
    }), $3a208abeb0ec52b2$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path"); // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    } // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$3a208abeb0ec52b2$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $3a208abeb0ec52b2$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $3a208abeb0ec52b2$export$fe53371bee54353d(path);
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $3a208abeb0ec52b2$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$3a208abeb0ec52b2$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$3a208abeb0ec52b2$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $3a208abeb0ec52b2$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    var submission;
    if (opts.formData) {
        var formMethod = opts.formMethod || "get";
        submission = {
            formMethod: normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $3a208abeb0ec52b2$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($3a208abeb0ec52b2$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $3a208abeb0ec52b2$export$8ccf933b0513f8d0(path);
    var searchParams = $3a208abeb0ec52b2$var$convertFormDataToSearchParams(opts.formData); // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $3a208abeb0ec52b2$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $3a208abeb0ec52b2$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $3a208abeb0ec52b2$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $3a208abeb0ec52b2$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location); // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $3a208abeb0ec52b2$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($3a208abeb0ec52b2$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $3a208abeb0ec52b2$var$shouldRevalidateLoader(match, $3a208abeb0ec52b2$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $3a208abeb0ec52b2$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some(function(m) {
            return m.route.id === f.routeId;
        })) return;
        var fetcherMatches = $3a208abeb0ec52b2$export$2708184779ceb39d(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        var fetcherMatch = $3a208abeb0ec52b2$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: fetcherMatches,
                match: fetcherMatch,
                controller: new AbortController()
            });
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        var shouldRevalidate = $3a208abeb0ec52b2$var$shouldRevalidateLoader(fetcherMatch, $3a208abeb0ec52b2$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $3a208abeb0ec52b2$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $3a208abeb0ec52b2$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $3a208abeb0ec52b2$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ function $3a208abeb0ec52b2$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $3a208abeb0ec52b2$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $3a208abeb0ec52b2$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
                        if (!isPropertyStaticallyDefined && !$3a208abeb0ec52b2$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    } // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $3a208abeb0ec52b2$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    })();
}
function $3a208abeb0ec52b2$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, isStaticRequest, isRouteRequest, requestContext) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
        var resultType, result, onReject, runHandler, handler, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, data, contentType, _result$init, _result$init2;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (isStaticRequest === void 0) isStaticRequest = false;
                    if (isRouteRequest === void 0) isRouteRequest = false;
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler),
                            $3a208abeb0ec52b2$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $3a208abeb0ec52b2$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $3a208abeb0ec52b2$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $3a208abeb0ec52b2$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$3a208abeb0ec52b2$var$isResponse(result)) return [
                        3,
                        19
                    ];
                    status = result.status; // Process redirects
                    if ($3a208abeb0ec52b2$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $3a208abeb0ec52b2$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
                        if (!$3a208abeb0ec52b2$var$ABSOLUTE_URL_REGEX.test(location)) location = $3a208abeb0ec52b2$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
                        else if (!isStaticRequest) {
                            // Strip off the protocol+origin for same-origin + same-basename absolute
                            // redirects. If this is a static request, we can let it go back to the
                            // browser as-is
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $3a208abeb0ec52b2$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        } // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $3a208abeb0ec52b2$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null
                            }
                        ];
                    } // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (isRouteRequest) // eslint-disable-next-line no-throw-literal
                    throw {
                        type: resultType || $3a208abeb0ec52b2$var$ResultType.data,
                        response: result
                    };
                    contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        result.json()
                    ];
                case 15:
                    data = _state.sent();
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.text()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    if (resultType === $3a208abeb0ec52b2$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $3a208abeb0ec52b2$export$acf1a680051f5031(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 19:
                    if (resultType === $3a208abeb0ec52b2$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($3a208abeb0ec52b2$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $3a208abeb0ec52b2$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    })();
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $3a208abeb0ec52b2$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($3a208abeb0ec52b2$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $3a208abeb0ec52b2$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType, formData = submission.formData; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $3a208abeb0ec52b2$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $3a208abeb0ec52b2$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $b0842d51d9c0999a$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, value instanceof File ? value.name : value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $3a208abeb0ec52b2$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $3a208abeb0ec52b2$export$3e9cee6b33872309(!$3a208abeb0ec52b2$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($3a208abeb0ec52b2$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $3a208abeb0ec52b2$var$findNearestBoundary(matches, id);
            var error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $3a208abeb0ec52b2$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($3a208abeb0ec52b2$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $3a208abeb0ec52b2$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $3a208abeb0ec52b2$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors; // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $3a208abeb0ec52b2$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index]; // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($3a208abeb0ec52b2$var$isErrorResult(result)) {
            var boundaryMatch = $3a208abeb0ec52b2$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $3a208abeb0ec52b2$var$_extends({}, errors, (0, $01539ab334a9139b$export$71511d61b312f219)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($3a208abeb0ec52b2$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $3a208abeb0ec52b2$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($3a208abeb0ec52b2$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $3a208abeb0ec52b2$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $3a208abeb0ec52b2$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $3a208abeb0ec52b2$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $3a208abeb0ec52b2$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $15f090c73cfda84a$export$71511d61b312f219)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $3a208abeb0ec52b2$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $3a208abeb0ec52b2$var$getInternalRouterError(status, _temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $3a208abeb0ec52b2$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $3a208abeb0ec52b2$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($3a208abeb0ec52b2$var$isRedirectResult(result)) return result;
    }
}
function $3a208abeb0ec52b2$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(path) : path;
    return $3a208abeb0ec52b2$export$fe53371bee54353d($3a208abeb0ec52b2$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $3a208abeb0ec52b2$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
     // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $3a208abeb0ec52b2$var$isDeferredResult(result) {
    return result.type === $3a208abeb0ec52b2$var$ResultType.deferred;
}
function $3a208abeb0ec52b2$var$isErrorResult(result) {
    return result.type === $3a208abeb0ec52b2$var$ResultType.error;
}
function $3a208abeb0ec52b2$var$isRedirectResult(result) {
    return (result && result.type) === $3a208abeb0ec52b2$var$ResultType.redirect;
}
function $3a208abeb0ec52b2$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && (typeof deferred === "undefined" ? "undefined" : (0, $6zqIC._)(deferred)) === "object" && (0, $6zqIC._)(deferred.data) === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $3a208abeb0ec52b2$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $6zqIC._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function $3a208abeb0ec52b2$var$isRedirectResponse(result) {
    if (!$3a208abeb0ec52b2$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $3a208abeb0ec52b2$var$isQueryRouteResponse(obj) {
    return obj && $3a208abeb0ec52b2$var$isResponse(obj.response) && (obj.type === $3a208abeb0ec52b2$var$ResultType.data || $3a208abeb0ec52b2$var$ResultType.error);
}
function $3a208abeb0ec52b2$var$isValidMethod(method) {
    return $3a208abeb0ec52b2$var$validRequestMethods.has(method.toLowerCase());
}
function $3a208abeb0ec52b2$var$isMutationMethod(method) {
    return $3a208abeb0ec52b2$var$validMutationMethods.has(method.toLowerCase());
}
function $3a208abeb0ec52b2$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
        var _loop, index;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$3a208abeb0ec52b2$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($3a208abeb0ec52b2$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $3a208abeb0ec52b2$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $3a208abeb0ec52b2$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $47055dab5b247348$export$19a8beecd37a4c45)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $3a208abeb0ec52b2$var$resolveDeferredData(result, signal, unwrap) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
        var aborted;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $3a208abeb0ec52b2$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $3a208abeb0ec52b2$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    })();
}
function $3a208abeb0ec52b2$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $3a208abeb0ec52b2$var$createUseMatchesMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $3a208abeb0ec52b2$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $3a208abeb0ec52b2$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $3a208abeb0ec52b2$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion


function $f0792a32d62fec93$var$_extends() {
    $f0792a32d62fec93$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f0792a32d62fec93$var$_extends.apply(this, arguments);
}
var $f0792a32d62fec93$export$3add0d5dce533e2e = /*#__PURE__*/ $4Bt61.createContext(null);
var $f0792a32d62fec93$export$145dfa71566a64dc = /*#__PURE__*/ $4Bt61.createContext(null);
var $f0792a32d62fec93$var$AwaitContext = /*#__PURE__*/ $4Bt61.createContext(null);
var $f0792a32d62fec93$export$26749e8557646306 = /*#__PURE__*/ $4Bt61.createContext(null);
var $f0792a32d62fec93$export$c7914228fb69b0f5 = /*#__PURE__*/ $4Bt61.createContext(null);
var $f0792a32d62fec93$export$9072aa6dd1f93057 = /*#__PURE__*/ $4Bt61.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $f0792a32d62fec93$var$RouteErrorContext = /*#__PURE__*/ $4Bt61.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $f0792a32d62fec93$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var _React_useContext = $4Bt61.useContext($f0792a32d62fec93$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $f0792a32d62fec93$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $3a208abeb0ec52b2$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $f0792a32d62fec93$export$9c954a9d03d32f4a() {
    return $4Bt61.useContext($f0792a32d62fec93$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $f0792a32d62fec93$export$45d76561a5302f2b() {
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return $4Bt61.useContext($f0792a32d62fec93$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $f0792a32d62fec93$export$1b3f31771c5d07c() {
    return $4Bt61.useContext($f0792a32d62fec93$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $f0792a32d62fec93$export$6c330e8992e8a295(pattern) {
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var pathname = $f0792a32d62fec93$export$45d76561a5302f2b().pathname;
    return $4Bt61.useMemo(function() {
        return (0, $3a208abeb0ec52b2$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $f0792a32d62fec93$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered."; // Mute warnings for calls to useNavigate in SSR environments
function $f0792a32d62fec93$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $4Bt61.useContext($f0792a32d62fec93$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4Bt61.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $f0792a32d62fec93$export$9770f232ac06a008() {
    var isDataRoute = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).isDataRoute; // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $f0792a32d62fec93$var$useNavigateStable() : $f0792a32d62fec93$var$useNavigateUnstable();
}
function $f0792a32d62fec93$var$useNavigateUnstable() {
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var dataRouterContext = $4Bt61.useContext($f0792a32d62fec93$export$3add0d5dce533e2e);
    var _React_useContext = $4Bt61.useContext($f0792a32d62fec93$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var matches = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).matches;
    var _useLocation = $f0792a32d62fec93$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $3a208abeb0ec52b2$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    var activeRef = $4Bt61.useRef(false);
    $f0792a32d62fec93$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $4Bt61.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $3a208abeb0ec52b2$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $3a208abeb0ec52b2$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $f0792a32d62fec93$var$OutletContext = /*#__PURE__*/ $4Bt61.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $f0792a32d62fec93$export$4138103a3ae699cc() {
    return $4Bt61.useContext($f0792a32d62fec93$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $f0792a32d62fec93$export$a3be3530d8e40d0b(context) {
    var outlet = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $f0792a32d62fec93$export$99eaa27ddbbb95ef() {
    var matches = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $f0792a32d62fec93$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var matches = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).matches;
    var _useLocation = $f0792a32d62fec93$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $3a208abeb0ec52b2$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    return $4Bt61.useMemo(function() {
        return (0, $3a208abeb0ec52b2$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $f0792a32d62fec93$export$5d3fca4a98652595(routes, locationArg) {
    return $f0792a32d62fec93$export$5fcee62552a12fbf(routes, locationArg);
} // Internal implementation with accept optional param for RouterProvider usage
function $f0792a32d62fec93$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var navigator = $4Bt61.useContext($f0792a32d62fec93$export$26749e8557646306).navigator;
    var _React_useContext = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $f0792a32d62fec93$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $3a208abeb0ec52b2$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $3a208abeb0ec52b2$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $f0792a32d62fec93$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $3a208abeb0ec52b2$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $3a208abeb0ec52b2$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $f0792a32d62fec93$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $3a208abeb0ec52b2$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f0792a32d62fec93$var$DefaultErrorComponent() {
    var error = $f0792a32d62fec93$export$ed527bf60f6e05f2();
    var message = (0, $3a208abeb0ec52b2$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $4Bt61.createElement($4Bt61.Fragment, null, /*#__PURE__*/ $4Bt61.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4Bt61.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4Bt61.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $f0792a32d62fec93$var$defaultErrorElement = /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$DefaultErrorComponent, null);
var $f0792a32d62fec93$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $ba30ceb37f7eb488$export$71511d61b312f219)(RenderErrorBoundary, _React_Component);
    function RenderErrorBoundary(props) {
        (0, $787a87339a4cca7b$export$71511d61b312f219)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $0b418693cc8cec34$export$71511d61b312f219)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $893843b5bdfb5320$export$71511d61b312f219)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                 // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error || state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($4Bt61.Component);
function $f0792a32d62fec93$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $4Bt61.useContext($f0792a32d62fec93$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $f0792a32d62fec93$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        var errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $f0792a32d62fec93$var$defaultErrorElement;
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4Bt61.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $f0792a32d62fec93$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($f0792a32d62fec93$var$DataRouterHook || ($f0792a32d62fec93$var$DataRouterHook = {}));
var $f0792a32d62fec93$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($f0792a32d62fec93$var$DataRouterStateHook || ($f0792a32d62fec93$var$DataRouterStateHook = {}));
function $f0792a32d62fec93$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $f0792a32d62fec93$var$useDataRouterContext(hookName) {
    var ctx = $4Bt61.useContext($f0792a32d62fec93$export$3add0d5dce533e2e);
    !ctx && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return ctx;
}
function $f0792a32d62fec93$var$useDataRouterState(hookName) {
    var state = $4Bt61.useContext($f0792a32d62fec93$export$145dfa71566a64dc);
    !state && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return state;
}
function $f0792a32d62fec93$var$useRouteContext(hookName) {
    var route = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057);
    !route && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return route;
} // Internal version with hookName-aware debugging
function $f0792a32d62fec93$var$useCurrentRouteId(hookName) {
    var route = $f0792a32d62fec93$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $f0792a32d62fec93$export$5fc8298006ad9e58() {
    return $f0792a32d62fec93$var$useCurrentRouteId($f0792a32d62fec93$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $f0792a32d62fec93$export$d0fd4b7106de2769() {
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $f0792a32d62fec93$export$600dc272ed516c15() {
    var dataRouterContext = $f0792a32d62fec93$var$useDataRouterContext($f0792a32d62fec93$var$DataRouterHook.UseRevalidator);
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $f0792a32d62fec93$export$2378eb7f5ff86053() {
    var _useDataRouterState = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $4Bt61.useMemo(function() {
        return matches.map(function(match) {
            var pathname = match.pathname, params = match.params; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $f0792a32d62fec93$export$1448a5050d252c4d() {
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseLoaderData);
    var routeId = $f0792a32d62fec93$var$useCurrentRouteId($f0792a32d62fec93$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $f0792a32d62fec93$export$fd5d37484eab868d(routeId) {
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $f0792a32d62fec93$export$fdc00f3f26066d5e() {
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseActionData);
    var route = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057);
    !route && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $f0792a32d62fec93$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $4Bt61.useContext($f0792a32d62fec93$var$RouteErrorContext);
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseRouteError);
    var routeId = $f0792a32d62fec93$var$useCurrentRouteId($f0792a32d62fec93$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $f0792a32d62fec93$export$78a72ddb39bdd145() {
    var value = $4Bt61.useContext($f0792a32d62fec93$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $f0792a32d62fec93$export$17f53340677d5831() {
    var value = $4Bt61.useContext($f0792a32d62fec93$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $f0792a32d62fec93$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $f0792a32d62fec93$export$2af03a1de5c0910(shouldBlock) {
    var router = $f0792a32d62fec93$var$useDataRouterContext($f0792a32d62fec93$var$DataRouterHook.UseBlocker).router;
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $b0842d51d9c0999a$export$71511d61b312f219)($4Bt61.useState(function() {
        return String(++$f0792a32d62fec93$var$blockerId);
    }), 1), blockerKey = _React_useState[0];
    var blockerFunction = $4Bt61.useCallback(function(args) {
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    var blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $4Bt61.useEffect(function() {
        return function() {
            return router.deleteBlocker(blockerKey);
        };
    }, [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $f0792a32d62fec93$var$useNavigateStable() {
    var router = $f0792a32d62fec93$var$useDataRouterContext($f0792a32d62fec93$var$DataRouterHook.UseNavigateStable).router;
    var id = $f0792a32d62fec93$var$useCurrentRouteId($f0792a32d62fec93$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $4Bt61.useRef(false);
    $f0792a32d62fec93$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $4Bt61.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $f0792a32d62fec93$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $f0792a32d62fec93$var$alreadyWarned = {};
function $f0792a32d62fec93$var$warningOnce(key, cond, message) {
    if (!cond && !$f0792a32d62fec93$var$alreadyWarned[key]) $f0792a32d62fec93$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f0792a32d62fec93$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    var _React_useState = (0, $b0842d51d9c0999a$export$71511d61b312f219)($4Bt61.useState(router.state), 2), state = _React_useState[0], setState = _React_useState[1];
    $4Bt61.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    var navigator = $4Bt61.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $4Bt61.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4Bt61.createElement($4Bt61.Fragment, null, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $f0792a32d62fec93$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, state = _ref2.state;
    return $f0792a32d62fec93$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $f0792a32d62fec93$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex;
    var historyRef = $4Bt61.useRef();
    if (historyRef.current == null) historyRef.current = (0, $3a208abeb0ec52b2$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $b0842d51d9c0999a$export$71511d61b312f219)($4Bt61.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    $4Bt61.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $f0792a32d62fec93$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var matches = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).matches;
    var _useLocation = $f0792a32d62fec93$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $f0792a32d62fec93$export$9770f232ac06a008(); // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $3a208abeb0ec52b2$export$cae722b0cc860f13)(to, (0, $3a208abeb0ec52b2$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $4Bt61.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $f0792a32d62fec93$export$910ae8079b2c2852(props) {
    return $f0792a32d62fec93$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $f0792a32d62fec93$export$e7b0ac011bb776c6(_props) {
    (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $f0792a32d62fec93$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $3a208abeb0ec52b2$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1;
    !!$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $4Bt61.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $3a208abeb0ec52b2$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $4Bt61.useMemo(function() {
        var trailingPathname = (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $f0792a32d62fec93$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $f0792a32d62fec93$export$5d3fca4a98652595($f0792a32d62fec93$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $f0792a32d62fec93$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$ResolveAwait, null, children));
}
var $f0792a32d62fec93$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($f0792a32d62fec93$var$AwaitRenderStatus || ($f0792a32d62fec93$var$AwaitRenderStatus = {}));
var $f0792a32d62fec93$var$neverSettledPromise = new Promise(function() {});
var $f0792a32d62fec93$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $ba30ceb37f7eb488$export$71511d61b312f219)(AwaitErrorBoundary, _React_Component);
    function AwaitErrorBoundary(props) {
        (0, $787a87339a4cca7b$export$71511d61b312f219)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $0b418693cc8cec34$export$71511d61b312f219)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $893843b5bdfb5320$export$71511d61b312f219)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $f0792a32d62fec93$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $f0792a32d62fec93$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $f0792a32d62fec93$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $f0792a32d62fec93$var$AwaitRenderStatus.error : promise._data !== undefined ? $f0792a32d62fec93$var$AwaitRenderStatus.success : $f0792a32d62fec93$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $f0792a32d62fec93$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $f0792a32d62fec93$var$AwaitRenderStatus.error && promise._error instanceof (0, $3a208abeb0ec52b2$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $f0792a32d62fec93$var$neverSettledPromise;
                if (status === $f0792a32d62fec93$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $f0792a32d62fec93$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $f0792a32d62fec93$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                 // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($4Bt61.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $f0792a32d62fec93$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $f0792a32d62fec93$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4Bt61.createElement($4Bt61.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $f0792a32d62fec93$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $4Bt61.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $4Bt61.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $15f090c73cfda84a$export$71511d61b312f219)(parentPath).concat([
            index
        ]);
        if (element.type === $4Bt61.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $f0792a32d62fec93$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $f0792a32d62fec93$export$e7b0ac011bb776c6) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $f0792a32d62fec93$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $f0792a32d62fec93$export$daf73786167a7f72(matches) {
    return $f0792a32d62fec93$var$_renderMatches(matches);
}
function $f0792a32d62fec93$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4Bt61.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4Bt61.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $f0792a32d62fec93$export$f30f7e456d254e83(routes, opts) {
    return (0, $3a208abeb0ec52b2$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f0792a32d62fec93$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $3a208abeb0ec52b2$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $f0792a32d62fec93$export$52b333d321859367
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////




/**
 * React Router DOM v6.11.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $4Bt61 = parcelRequire("4Bt61");


function $8f0ad21e84364a49$var$_extends() {
    $8f0ad21e84364a49$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8f0ad21e84364a49$var$_extends.apply(this, arguments);
}
function $8f0ad21e84364a49$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8f0ad21e84364a49$var$defaultMethod = "get";
var $8f0ad21e84364a49$var$defaultEncType = "application/x-www-form-urlencoded";
function $8f0ad21e84364a49$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $8f0ad21e84364a49$var$isButtonElement(object) {
    return $8f0ad21e84364a49$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $8f0ad21e84364a49$var$isFormElement(object) {
    return $8f0ad21e84364a49$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $8f0ad21e84364a49$var$isInputElement(object) {
    return $8f0ad21e84364a49$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $8f0ad21e84364a49$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $8f0ad21e84364a49$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$8f0ad21e84364a49$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $8f0ad21e84364a49$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $8f0ad21e84364a49$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $8f0ad21e84364a49$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
                    searchParams.append(key, value);
                });
            };
            for(var _iterator = defaultSearchParams.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return searchParams;
}
function $8f0ad21e84364a49$var$getFormSubmissionInfo(target, options, basename) {
    var method;
    var action = null;
    var encType;
    var formData;
    if ($8f0ad21e84364a49$var$isFormElement(target)) {
        var submissionTrigger = options.submissionTrigger;
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            var attr = target.getAttribute("action");
            action = attr ? (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("method") || $8f0ad21e84364a49$var$defaultMethod;
        encType = options.encType || target.getAttribute("enctype") || $8f0ad21e84364a49$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($8f0ad21e84364a49$var$isButtonElement(target) || $8f0ad21e84364a49$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
         // <button>/<input type="submit"> may override attributes of <form>
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
            action = attr1 ? (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(attr1, basename) : null;
        }
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $8f0ad21e84364a49$var$defaultMethod;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $8f0ad21e84364a49$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($8f0ad21e84364a49$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $8f0ad21e84364a49$var$defaultMethod;
        action = options.action || null;
        encType = options.encType || $8f0ad21e84364a49$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (target instanceof URLSearchParams) try {
                for(var _iterator = target[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $b0842d51d9c0999a$export$71511d61b312f219)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                    formData.append(name, value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else if (target != null) try {
                for(var _iterator1 = Object.keys(target)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var name1 = _step1.value;
                    formData.append(name1, target[name1]);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
var $8f0ad21e84364a49$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $8f0ad21e84364a49$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $8f0ad21e84364a49$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $8f0ad21e84364a49$export$1f3f55432a00e06d(routes, opts) {
    return (0, $3a208abeb0ec52b2$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8f0ad21e84364a49$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $3a208abeb0ec52b2$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8f0ad21e84364a49$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f0792a32d62fec93$export$52b333d321859367)
    }).initialize();
}
function $8f0ad21e84364a49$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $3a208abeb0ec52b2$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8f0ad21e84364a49$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $3a208abeb0ec52b2$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8f0ad21e84364a49$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f0792a32d62fec93$export$52b333d321859367)
    }).initialize();
}
function $8f0ad21e84364a49$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $8f0ad21e84364a49$var$_extends({}, state, {
        errors: $8f0ad21e84364a49$var$deserializeErrors(state.errors)
    });
    return state;
}
function $8f0ad21e84364a49$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $b0842d51d9c0999a$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $3a208abeb0ec52b2$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                var error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $8f0ad21e84364a49$export$9ba4e89fdfa1fc54(_ref) {
    var basename = _ref.basename, children = _ref.children, _$window = _ref.window;
    var historyRef = $4Bt61.useRef();
    if (historyRef.current == null) historyRef.current = (0, $3a208abeb0ec52b2$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $b0842d51d9c0999a$export$71511d61b312f219)($4Bt61.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    $4Bt61.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ $4Bt61.createElement((0, $f0792a32d62fec93$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $8f0ad21e84364a49$export$7221d69dcfc8e36b(_ref2) {
    var basename = _ref2.basename, children = _ref2.children, _$window = _ref2.window;
    var historyRef = $4Bt61.useRef();
    if (historyRef.current == null) historyRef.current = (0, $3a208abeb0ec52b2$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $b0842d51d9c0999a$export$71511d61b312f219)($4Bt61.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    $4Bt61.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ $4Bt61.createElement((0, $f0792a32d62fec93$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $8f0ad21e84364a49$export$eefb0c834599897e(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, history = _ref3.history;
    var _React_useState = (0, $b0842d51d9c0999a$export$71511d61b312f219)($4Bt61.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    $4Bt61.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ $4Bt61.createElement((0, $f0792a32d62fec93$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
var $8f0ad21e84364a49$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $8f0ad21e84364a49$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ var $8f0ad21e84364a49$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4Bt61.forwardRef(function LinkWithRef(_ref4, ref) {
    var onClick = _ref4.onClick, relative = _ref4.relative, reloadDocument = _ref4.reloadDocument, replace = _ref4.replace, state = _ref4.state, target = _ref4.target, to = _ref4.to, preventScrollReset = _ref4.preventScrollReset, rest = $8f0ad21e84364a49$var$_objectWithoutPropertiesLoose(_ref4, $8f0ad21e84364a49$var$_excluded);
    var basename = $4Bt61.useContext((0, $f0792a32d62fec93$export$26749e8557646306)).basename; // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $8f0ad21e84364a49$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if ($8f0ad21e84364a49$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    } // Rendered into <a href> for relative URLs
    var href = (0, $f0792a32d62fec93$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $8f0ad21e84364a49$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4Bt61.createElement("a", $8f0ad21e84364a49$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $8f0ad21e84364a49$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4Bt61.forwardRef(function NavLinkWithRef(_ref5, ref) {
    var tmp = _ref5["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref5_caseSensitive = _ref5.caseSensitive, caseSensitive = _ref5_caseSensitive === void 0 ? false : _ref5_caseSensitive, tmp1 = _ref5.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref5_end = _ref5.end, end = _ref5_end === void 0 ? false : _ref5_end, styleProp = _ref5.style, to = _ref5.to, children = _ref5.children, rest = $8f0ad21e84364a49$var$_objectWithoutPropertiesLoose(_ref5, $8f0ad21e84364a49$var$_excluded2);
    var path = (0, $f0792a32d62fec93$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    var routerState = $4Bt61.useContext((0, $f0792a32d62fec93$export$145dfa71566a64dc));
    var navigator = $4Bt61.useContext((0, $f0792a32d62fec93$export$26749e8557646306)).navigator;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $4Bt61.createElement($8f0ad21e84364a49$export$a6c7ac8248d6e38a, $8f0ad21e84364a49$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $8f0ad21e84364a49$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4Bt61.forwardRef(function(props, ref) {
    return /*#__PURE__*/ $4Bt61.createElement($8f0ad21e84364a49$var$FormImpl, $8f0ad21e84364a49$var$_extends({}, props, {
        ref: ref
    }));
});
var $8f0ad21e84364a49$var$FormImpl = /*#__PURE__*/ $4Bt61.forwardRef(function(_ref6, forwardedRef) {
    var reloadDocument = _ref6.reloadDocument, replace = _ref6.replace, _ref6_method = _ref6.method, method = _ref6_method === void 0 ? $8f0ad21e84364a49$var$defaultMethod : _ref6_method, action = _ref6.action, onSubmit = _ref6.onSubmit, fetcherKey = _ref6.fetcherKey, routeId = _ref6.routeId, relative = _ref6.relative, preventScrollReset = _ref6.preventScrollReset, props = $8f0ad21e84364a49$var$_objectWithoutPropertiesLoose(_ref6, $8f0ad21e84364a49$var$_excluded3);
    var submit = $8f0ad21e84364a49$var$useSubmitImpl(fetcherKey, routeId);
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var formAction = $8f0ad21e84364a49$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $4Bt61.createElement("form", $8f0ad21e84364a49$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $8f0ad21e84364a49$export$11aac1aab828f1fa(_ref7) {
    var getKey = _ref7.getKey, storageKey = _ref7.storageKey;
    $8f0ad21e84364a49$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $8f0ad21e84364a49$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($8f0ad21e84364a49$var$DataRouterHook || ($8f0ad21e84364a49$var$DataRouterHook = {}));
var $8f0ad21e84364a49$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($8f0ad21e84364a49$var$DataRouterStateHook || ($8f0ad21e84364a49$var$DataRouterStateHook = {}));
function $8f0ad21e84364a49$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $8f0ad21e84364a49$var$useDataRouterContext(hookName) {
    var ctx = $4Bt61.useContext((0, $f0792a32d62fec93$export$3add0d5dce533e2e));
    !ctx && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return ctx;
}
function $8f0ad21e84364a49$var$useDataRouterState(hookName) {
    var state = $4Bt61.useContext((0, $f0792a32d62fec93$export$145dfa71566a64dc));
    !state && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $8f0ad21e84364a49$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative;
    var navigate = (0, $f0792a32d62fec93$export$9770f232ac06a008)();
    var location = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    var path = (0, $f0792a32d62fec93$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $4Bt61.useCallback(function(event) {
        if ($8f0ad21e84364a49$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $3a208abeb0ec52b2$export$fe53371bee54353d)(location) === (0, $3a208abeb0ec52b2$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $8f0ad21e84364a49$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $4Bt61.useRef($8f0ad21e84364a49$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $4Bt61.useRef(false);
    var location = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    var searchParams = $4Bt61.useMemo(function() {
        return(// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $8f0ad21e84364a49$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $f0792a32d62fec93$export$9770f232ac06a008)();
    var setSearchParams = $4Bt61.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $8f0ad21e84364a49$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $8f0ad21e84364a49$export$47c85c6e3a081d3() {
    return $8f0ad21e84364a49$var$useSubmitImpl();
}
function $8f0ad21e84364a49$var$useSubmitImpl(fetcherKey, fetcherRouteId) {
    var router = $8f0ad21e84364a49$var$useDataRouterContext($8f0ad21e84364a49$var$DataRouterHook.UseSubmitImpl).router;
    var basename = $4Bt61.useContext((0, $f0792a32d62fec93$export$26749e8557646306)).basename;
    var currentRouteId = (0, $f0792a32d62fec93$export$5fc8298006ad9e58)();
    return $4Bt61.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        var _getFormSubmissionInfo = $8f0ad21e84364a49$var$getFormSubmissionInfo(target, options, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData; // Base options shared between fetch() and navigate()
        var opts = {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(fetcherRouteId != null) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, fetcherRouteId, action, opts);
        } else router.navigate(action, $8f0ad21e84364a49$var$_extends({}, opts, {
            replace: options.replace,
            fromRouteId: currentRouteId
        }));
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId,
        currentRouteId
    ]);
} // v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $8f0ad21e84364a49$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $4Bt61.useContext((0, $f0792a32d62fec93$export$26749e8557646306)).basename;
    var routeContext = $4Bt61.useContext((0, $f0792a32d62fec93$export$9072aa6dd1f93057));
    !routeContext && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $b0842d51d9c0999a$export$71511d61b312f219)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0]; // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $8f0ad21e84364a49$var$_extends({}, (0, $f0792a32d62fec93$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            var params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $3a208abeb0ec52b2$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $3a208abeb0ec52b2$export$fe53371bee54353d)(path);
}
function $8f0ad21e84364a49$var$createFetcherForm(fetcherKey, routeId) {
    var FetcherForm = /*#__PURE__*/ $4Bt61.forwardRef(function(props, ref) {
        return /*#__PURE__*/ $4Bt61.createElement($8f0ad21e84364a49$var$FormImpl, $8f0ad21e84364a49$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
var $8f0ad21e84364a49$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $8f0ad21e84364a49$export$5b0d2d9a9921565a() {
    var _route$matches;
    var router = $8f0ad21e84364a49$var$useDataRouterContext($8f0ad21e84364a49$var$DataRouterHook.UseFetcher).router;
    var route = $4Bt61.useContext((0, $f0792a32d62fec93$export$9072aa6dd1f93057));
    !route && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var _React_useState = (0, $b0842d51d9c0999a$export$71511d61b312f219)($4Bt61.useState(function() {
        return String(++$8f0ad21e84364a49$var$fetcherId);
    }), 1), fetcherKey = _React_useState[0];
    var _React_useState1 = (0, $b0842d51d9c0999a$export$71511d61b312f219)($4Bt61.useState(function() {
        !routeId && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
        return $8f0ad21e84364a49$var$createFetcherForm(fetcherKey, routeId);
    }), 1), Form = _React_useState1[0];
    var _React_useState2 = (0, $b0842d51d9c0999a$export$71511d61b312f219)($4Bt61.useState(function() {
        return function(href) {
            !router && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
            !routeId && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        };
    }), 1), load = _React_useState2[0];
    var submit = $8f0ad21e84364a49$var$useSubmitImpl(fetcherKey, routeId);
    var fetcher = router.getFetcher(fetcherKey);
    var fetcherWithComponents = $4Bt61.useMemo(function() {
        return $8f0ad21e84364a49$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher);
    }, [
        fetcher,
        Form,
        submit,
        load
    ]);
    $4Bt61.useEffect(function() {
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return function() {
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $8f0ad21e84364a49$export$fa996778a3a31087() {
    var state = $8f0ad21e84364a49$var$useDataRouterState($8f0ad21e84364a49$var$DataRouterStateHook.UseFetchers);
    return (0, $15f090c73cfda84a$export$71511d61b312f219)(state.fetchers.values());
}
var $8f0ad21e84364a49$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $8f0ad21e84364a49$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $8f0ad21e84364a49$export$25057cfe5591e3e9(_temp3) {
    var _ref = _temp3 === void 0 ? {} : _temp3, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $8f0ad21e84364a49$var$useDataRouterContext($8f0ad21e84364a49$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $8f0ad21e84364a49$var$useDataRouterState($8f0ad21e84364a49$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var location = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    var matches = (0, $f0792a32d62fec93$export$2378eb7f5ff86053)();
    var navigation = (0, $f0792a32d62fec93$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $4Bt61.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $8f0ad21e84364a49$var$usePageHide($4Bt61.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $8f0ad21e84364a49$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $8f0ad21e84364a49$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($8f0ad21e84364a49$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Bt61.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $8f0ad21e84364a49$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $8f0ad21e84364a49$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Bt61.useLayoutEffect(function() {
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($8f0ad21e84364a49$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKey);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Bt61.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8f0ad21e84364a49$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $4Bt61.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8f0ad21e84364a49$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $4Bt61.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $8f0ad21e84364a49$export$39f4eb3dbd812741(_ref8) {
    var when = _ref8.when, message = _ref8.message;
    var blocker = (0, $f0792a32d62fec93$export$2af03a1de5c0910)(when);
    $4Bt61.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $4Bt61.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}




var $4Bt61 = parcelRequire("4Bt61");


function $3618b99971548a79$var$Hero() {
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
        className: "w-full mt-14 px-12 h-[42vh] lg:h-[64vh] gap-10 lg:px-36 flex justify-center items-center",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                className: "flex flex-col gap-14 lg:gap-6",
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                        className: "text-4xl lg:text-5xl text-center lg:text-left font-extrabold leading-tight",
                        children: "Get queued. Manage queues. Efficient actions."
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "flex gap-4 justify-center items-center lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                to: "/agent-domain",
                                children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("button", {
                                    className: "bg-[#dc9209] min-w-36 rounded-lg p-2 cursor-pointer",
                                    children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                        className: "font-extrabold text-gray-200 hover:text-gray-300",
                                        children: "For Brokers"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                to: "/buyer-query",
                                children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("button", {
                                    className: "hover:bg-gray-300 hover:text-[#dc9209] bg-gray-200 min-w-36 rounded-lg p-2 cursor-pointer",
                                    children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                        className: "font-extrabold",
                                        children: "For Investors"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                className: "max-w-[30vw] hidden md:hidden lg:block",
                children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("img", {
                    src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1751383081/hero-splash_c1lxxs.png",
                    alt: "AttnQ-cuts-through-noise-and-connects-with-serious-high-intent-property-buyers\u2014not-random-leads.-Buyers-enter-their-exact-budget-and-dream-property-specs-and-AttnQ-prioritizes-and-queues-them-for-you-based-on-relevance-and-conversion-potential.-You-get-a-clear-ranked-list-of-prospects-ready-to-be-contacted-without-chasing-cold-inquiries."
                })
            })
        ]
    });
}
var $3618b99971548a79$export$2e2bcd8739ae039 = $3618b99971548a79$var$Hero;



function $e313dadf2b746219$var$Why() {
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
        className: "w-full h-fit flex flex-col justify-center items-center gap-8 mb-4 p-12 lg:p-16",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h1", {
                className: "text-center text-2xl font-bold",
                children: "Why AttnQ?"
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                className: "text-center leading-8",
                children: [
                    "AttnQ connects property brokers and investors by matching exact budgets and needs. Close the deal faster with serious, relevant leads. It cuts through noise and connects with serious, high-intent property buyers \u2014 not random leads. Buyers enter their exact budget and dream property specs, and AttnQ prioritizes and queues them for you based on relevance and conversion potential. You get a clear, ranked list of prospects ready to be contacted, without chasing cold inquiries.",
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                    "It\u2019s built to",
                    " ",
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                        className: "bg-yellow-200 p-1 border-b-3 border-b-[#dc9209]",
                        children: "save"
                    }),
                    " ",
                    "time and",
                    " ",
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                        className: "bg-yellow-200 p-1 border-b-3 border-b-[#dc9209]",
                        children: "boost"
                    }),
                    " ",
                    "closures."
                ]
            })
        ]
    });
}
var $e313dadf2b746219$export$2e2bcd8739ae039 = $e313dadf2b746219$var$Why;



function $86b07c7ca3f15c67$var$Features() {
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
        id: "features",
        className: "w-full h-fit flex flex-col justify-center items-center gap-10 lg:gap-12 p-8 px-12 lg:px-16",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h1", {
                className: "text-center text-2xl font-bold",
                children: "Features"
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                className: "flex justify-center items-center gap-24",
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                        className: "w-[23vw] hidden md:hidden lg:block",
                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("img", {
                            className: "hidden lg:block",
                            src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750782597/feature-1_ganr2d.png",
                            alt: "feature-1"
                        })
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "min-w-[30vw] flex flex-col justify-center items-start",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                className: "font-semibold text-lg",
                                children: "Smart Intake Flow"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                className: "list-disc p-3",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Conversational, step-by-step form"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Location selection via map or pin"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "\u201CMust-have\u201D vs. \u201CNice-to-have\u201D inputs"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Capture detailed, usable property requirements effortlessly"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                className: "flex justify-center items-center gap-24",
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "min-w-[30vw] flex flex-col justify-center items-start",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                className: "font-semibold text-lg",
                                children: "Relevancy-Based Lead Queue"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                className: "list-disc p-3",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Matches based on property-fit"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Prioritizes high-conversion leads"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Tracks broker responsiveness for each forwarded lead"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Confidence score for each match"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                        className: "w-[23vw] hidden md:hidden lg:block",
                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("img", {
                            className: "hidden lg:block",
                            src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750783646/feature-2_uch7hr.png",
                            alt: "feature-2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                className: "flex justify-center items-center gap-24",
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                        className: "w-[23vw] hidden md:hidden lg:block",
                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("img", {
                            className: "hidden lg:block",
                            src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750783648/feature-3_jvcd56.png",
                            alt: "feature-3"
                        })
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "min-w-[30vw] flex flex-col justify-center items-start",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                className: "font-semibold text-lg",
                                children: "Broker Dashboard"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                className: "list-disc p-3",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Snapshot cards for each buyer"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "One-click call, WhatsApp, or message"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Auto-grouping by buyer demand type, budget, size"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Learn-as-you-go lead rejection filter"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                className: "flex justify-center items-center gap-24",
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "min-w-[30vw] flex flex-col justify-center items-start",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                className: "font-semibold text-lg",
                                children: "Lead Quality Feedback Loop"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                className: "list-disc p-3",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Broker success score"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Buyer confirmation on success and rejection"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Keeps the platform clean, informative, and trustworthy"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Lead flagging (TBA)"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                        className: "w-[23vw] hidden md:hidden lg:block",
                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("img", {
                            className: "hidden lg:block",
                            src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750783649/feature-4_ojiidz.png",
                            alt: "feature-4"
                        })
                    })
                ]
            })
        ]
    });
}
var $86b07c7ca3f15c67$export$2e2bcd8739ae039 = $86b07c7ca3f15c67$var$Features;



// ProtectedImage.jsx

function $5f1309c2fb31fc13$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $01539ab334a9139b$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $9ca29dfc63273075$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $a2545ede434994c7$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $9ca29dfc63273075$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



function $c45d40101d54f6a2$export$2e2bcd8739ae039(_param) {
    var src = _param.src, _param_alt = _param.alt, alt = _param_alt === void 0 ? "" : _param_alt, _param_className = _param.className, className = _param_className === void 0 ? "" : _param_className, _param_imgClass = _param.imgClass, imgClass = _param_imgClass === void 0 ? "" : _param_imgClass, rest // any other <img> props
     = (0, $a2545ede434994c7$export$71511d61b312f219)(_param, [
        "src",
        "alt",
        "className",
        "imgClass"
    ]);
    return(/* 1️⃣  Wrapper:  relative  so overlay can be absolute
                      inline‑block so it auto‑sizes to the image
                      any Tailwind classes you pass in `className` */ /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
        className: "relative inline-block ".concat(className),
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("img", (0, $5f1309c2fb31fc13$export$71511d61b312f219)({
                src: src,
                alt: alt,
                draggable: false,
                onContextMenu: function(e) {
                    return e.preventDefault();
                },
                className: "pointer-events-none select-none ".concat(imgClass)
            }, rest)),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                className: "absolute inset-0 pointer-events-auto",
                onContextMenu: function(e) {
                    return e.preventDefault();
                },
                draggable: false
            })
        ]
    }));
}


function $11d7af66ecc98614$var$Visionaries() {
    var coFounders = [
        {
            name: "Darshan Gupta",
            title: "Founder & CEO",
            image: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1751637441/darshan-gupta-web_q4mmyn.png",
            role: "Oversees operations, strategy, and sales.",
            background: "With a strong background in real estate, he brings domain-specific insight to align product with market needs."
        },
        {
            name: "Jay Bajaj",
            title: "Co-founder & Tech Manager",
            image: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1751637442/jay-bajaj-web_vizffb.png",
            role: "Leads the tech team, and backend systems.",
            background: "Having worked on large-scale backend platforms, he ensures the product scales reliably and securely."
        }
    ];
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
        className: "max-w-6xl mx-auto px-8 py-10 lg:mt-8",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                className: "text-2xl font-bold text-center",
                children: "The Founders"
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-10 mt-10",
                children: coFounders.map(function(person, index) {
                    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "flex flex-col items-center text-center bg-[#FAF9F6] p-6 rounded-xl shadow-md",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $c45d40101d54f6a2$export$2e2bcd8739ae039), {
                                src: person.image,
                                alt: person.name,
                                className: "w-48 h-48" // Tailwind sizing / styling
                                ,
                                imgClass: "rounded-full object-cover shadow"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h3", {
                                className: "text-xl font-semibold text-gray-900 pt-4 pb-1",
                                children: person.name
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                className: "text-sm text-[#dc9209] font-medium mb-2",
                                children: person.title
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                className: "text-gray-800 text-sm py-1",
                                children: person.role
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                className: "text-gray-500 text-sm",
                                children: person.background
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
}
var $11d7af66ecc98614$export$2e2bcd8739ae039 = $11d7af66ecc98614$var$Visionaries;




var $4Bt61 = parcelRequire("4Bt61");

function $8ecadbf3eef68bdf$export$2e2bcd8739ae039() {
    var pathname = (0, $f0792a32d62fec93$export$45d76561a5302f2b)().pathname;
    (0, $4Bt61.useEffect)(function() {
        // Use 'instant' so it just snaps; switch to 'smooth' if you want the glide effect
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
        className: "scroll-smooth"
    }); // nothing to render
}



function $0f826931ec95a1d2$var$Shadow() {
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("section", {
        className: "w-full h-1 shadow"
    });
}
var $0f826931ec95a1d2$export$2e2bcd8739ae039 = $0f826931ec95a1d2$var$Shadow;


function $b61b6077bcc96e04$var$MainHome() {
    (0, $4Bt61.useEffect)(function() {
        document.title = "AttnQ - Home | Get Real Estate Leads for Brokers and Investors";
    }, []);
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8ecadbf3eef68bdf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $3618b99971548a79$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $e313dadf2b746219$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $86b07c7ca3f15c67$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $11d7af66ecc98614$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $0f826931ec95a1d2$export$2e2bcd8739ae039), {})
        ]
    });
}
var $b61b6077bcc96e04$export$2e2bcd8739ae039 = $b61b6077bcc96e04$var$MainHome;




var $4Bt61 = parcelRequire("4Bt61");

function $364a03e7fcb2d1c4$var$MainPrivacyPolicy() {
    (0, $4Bt61.useEffect)(function() {
        document.title = "Privacy Policy | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("main", {
        className: "text-gray-800 px-8 py-20 shadow",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8ecadbf3eef68bdf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                className: "max-w-5xl mx-auto space-y-10",
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("header", {
                        className: "text-center space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h1", {
                                className: "text-xl md:text-3xl font-bold",
                                children: "Privacy\xa0Policy"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                className: "text-sm text-gray-500",
                                children: [
                                    "Updated on and effective from:",
                                    " ",
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                        className: "italic",
                                        children: "[02\xa006\xa02024]"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("article", {
                        className: "space-y-8",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "1. Who we are"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "AttnQ (also pronounced ",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: "Attain Queue"
                                            }),
                                            ") (\u201C",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: "we"
                                            }),
                                            ",\u201D \u201C",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: "our"
                                            }),
                                            ",\u201D \u201C",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: "us"
                                            }),
                                            "\u201D) is a property-matching platform that connects buyers/investors with vetted real-estate brokers. We operate the website",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: "\xa0attnq.com"
                                            }),
                                            " and related services (collectively, the \u201C",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: "Platform"
                                            }),
                                            "\u201D). ",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "The web domain ",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: "attnq.com"
                                            }),
                                            " and all email addresses ending with",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: " @attnq.com"
                                            }),
                                            " are the official digital properties of AttnQ; any communication or interaction originating from these domains should be considered as authorized and representative of the AttnQ company."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "2. Scope"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "This Policy explains how we collect, use, disclose, and safeguard your information when you browse, submit property requirements, or access buyer leads through the Platform."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "3. Information we collect"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                                        className: "overflow-x-auto",
                                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("table", {
                                            className: "w-full text-left border border-gray-200 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("thead", {
                                                    className: "bg-yellow-50",
                                                    children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("th", {
                                                                className: "p-3 font-medium",
                                                                children: "Category"
                                                            }),
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("th", {
                                                                className: "p-3 font-medium",
                                                                children: "Examples"
                                                            }),
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("th", {
                                                                className: "p-3 font-medium",
                                                                children: "Source"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tbody", {
                                                    className: "text-sm text-gray-600",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3 font-medium",
                                                                    children: "Identity"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Name, Company, Location"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "You"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3 font-medium",
                                                                    children: "Contact"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Email, Phone"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "You"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3 font-medium",
                                                                    children: "Property\xa0Preferences"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Budget, Location, Space, Amenities, Plot type, Project stage, Deal-breakers, Buying intent"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "You"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3 font-medium",
                                                                    children: "Usage\xa0&\xa0Device"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "IP, Browser, Device ID, Device OS, Pages viewed, Time viewed"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Cookies / analytics"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3 font-medium",
                                                                    children: "Payment"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Masked card details, UPI ref-IDs"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Payment partner"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600 mt-6",
                                        children: [
                                            "*We do ",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: "not"
                                            }),
                                            " knowingly collect data from children under\xa018."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "4. How we use your information"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ol", {
                                        className: "list-decimal list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Matchmaking \u2013 Queue and score buyer requirements for relevant brokers."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Service delivery \u2013 Create and manage your account, send confirmations/OTP."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Communication \u2013 Emails, calls, SMS"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Improvement & analytics \u2013 Diagnose errors, test new features, measure demand."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "5. Legal bases\xa0(GDPR / DPDP Act)"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                                        className: "overflow-x-auto",
                                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("table", {
                                            className: "w-full text-left border border-gray-200 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("thead", {
                                                    className: "bg-yellow-50",
                                                    children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("th", {
                                                                className: "p-3 font-medium",
                                                                children: "Purpose"
                                                            }),
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("th", {
                                                                className: "p-3 font-medium",
                                                                children: "Legal basis"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tbody", {
                                                    className: "text-sm text-gray-600",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Account creation & matchmaking"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Contractual necessity"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Marketing emails (opt-in)"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Consent"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Service analytics"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Legitimate interest"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Regulatory disclosures"
                                                                }),
                                                                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Legal obligation"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "6. Sharing & disclosure"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "Data is shared only when necessary \u2014 with vetted brokers. We never sell personal data. Company and it's operational data won't be shared with non-government or private entities. Employees and their project specific data won't be shared with non-government or private entities. ",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "Your data is shared only when necessary to provide our services\u2014for example, when presenting buyer requirements to verified brokers, or when using trusted third-party tools for infrastructure, analytics, or communication. All such partners are bound by strict confidentiality and data protection agreements."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                                className: "text-xl md:text-2xl font-semibold",
                                                children: "7. International transfers"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "Data may be processed outside your country (e.g., AWS Singapore) with adequate safeguards."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                                className: "text-xl md:text-2xl font-semibold my-2",
                                                children: "8. Data retention"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                                className: "text-sm text-gray-600",
                                                children: [
                                                    "We retain personal data only for as long as it\u2019s necessary to deliver our services effectively, comply with legal obligations, and maintain platform integrity. ",
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                                    "Buyer information is kept while their account remains active or until a prolonged period of inactivity, after which it may be deleted or anonymized. Broker-related data is retained as long as the account is in use, and may be purged within a reasonable period after closure. Certain non-personal or aggregated data may be stored indefinitely for analytics, system improvement, or reporting purposes."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                                className: "text-xl md:text-2xl font-semibold my-2",
                                                children: "9. Security"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                                className: "text-sm text-gray-600",
                                                children: [
                                                    "Encryption in transit (TLS 1.2+), at rest (AES-256), role-based access, and regular security testing. ",
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                                    "We are committed to protecting your personal information with robust security practices across all levels of our platform. All data transmitted between you and our servers is encrypted using modern TLS protocols, and sensitive information is securely stored using encryption at rest. Access to personal data is restricted to authorized personnel only, and is granted based on the principle of least privilege to ensure that only those with a clear operational need can access user information. ",
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                                    "Our infrastructure is hosted on trusted, industry-leading cloud service providers that implement strong physical and network safeguards, including firewalls, intrusion detection, and automated patching of known vulnerabilities. We monitor our systems for suspicious activity and actively work to prevent unauthorized access or misuse. User authentication is protected with secure password handling, and we are working toward optional support for two-factor authentication to enhance account security for brokers and teams. We also routinely audit our code, infrastructure, and internal processes to identify and fix potential vulnerabilities, while ensuring that all employees handling data are trained in data privacy and security best practices. ",
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                                    "In the unlikely event of a data breach, we have a response plan in place to investigate, contain, and notify affected users without undue delay, and within legal timeframes where applicable. We continuously evaluate and improve our security measures to stay ahead of evolving threats and to keep your data safe as the platform grows."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                                className: "text-xl md:text-2xl font-semibold my-2",
                                                children: "10. Third-party links"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "Our platform may contain links to third-party websites, tools, or services that are not operated or controlled by AttnQ. We are not responsible for the privacy practices or content of these external sites. Once you leave our platform and interact with a third-party service, their terms and privacy policies apply. We recommend reviewing those policies before providing any personal information or engaging with their services."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                                className: "text-xl md:text-2xl font-semibold my-2",
                                                children: "11. Changes to this Policy"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "We may update this Privacy Policy from time to time to reflect changes in our services, legal requirements, or internal practices, and we encourage you to review it periodically. Whenever a material revision is made, we will post the new version on our website and, where feasible, provide additional notice\u2014such as sending an email or displaying an in-app alert\u2014so that you remain informed about how your data is handled. Because our product evolves quickly, we reserve the right to amend or replace the policy without prior notice when immediate changes are necessary to protect user data, comply with urgent legal directives, or address emerging security concerns. Your continued use of AttnQ after any modification constitutes acceptance of the revised terms; if you do not agree, you should discontinue use of the platform."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $364a03e7fcb2d1c4$export$2e2bcd8739ae039 = $364a03e7fcb2d1c4$var$MainPrivacyPolicy;




var $4Bt61 = parcelRequire("4Bt61");


function $7f9744aea433ca37$var$MainAboutUs() {
    (0, $4Bt61.useEffect)(function() {
        document.title = "About Us | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("main", {
        className: "h-fit w-full mt-14 p-8 lg:px-16 lg:py-12 shadow",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8ecadbf3eef68bdf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                        className: "text-lg text-center mb-14 italic",
                        children: 'AttnQ is stylized, witty, and short for "Attain Queue". The name captures the startup\'s mission and process in a clean and modern way.'
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "flex flex-col lg:flex-row justify-center gap-10 mt-20",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                className: "lg:max-w-[38vw]",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl font-semibold",
                                        children: "What We Do?"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        className: "pt-2 text-gray-700",
                                        children: [
                                            "AttnQ capture buyer needs, queue them by priority, and surface them to vetted agents who can deliver.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "The result? Fewer cold calls, faster deals, and happier clients on both sides."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl font-semibold",
                                        children: "Why AttnQ?"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                        className: "list-disc list-inside space-y-2 pt-2 text-gray-700",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Smart buyer\u2013agent matchmaking"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Zero spam, 100 % relevance"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Simplified workflow for agents"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Transparent, data-driven platform"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $11d7af66ecc98614$export$2e2bcd8739ae039), {})
        ]
    });
}
var $7f9744aea433ca37$export$2e2bcd8739ae039 = $7f9744aea433ca37$var$MainAboutUs;








function $88b8073c72dea9d1$var$Navbar() {
    var currentUrl = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("nav", {
        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
            className: "flex justify-between items-center gap-6",
            children: [
                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                    to: "about-us",
                    className: "text-sm cursor-pointer hover:underline",
                    children: "About Us"
                }),
                currentUrl.pathname === "/" ? /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("a", {
                    className: "text-sm cursor-pointer hover:underline",
                    href: "#features",
                    children: "Features"
                }) : null,
                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                    to: "careers",
                    className: "text-sm cursor-pointer hover:underline",
                    children: "Careers"
                })
            ]
        })
    });
}
var $88b8073c72dea9d1$export$2e2bcd8739ae039 = $88b8073c72dea9d1$var$Navbar;


function $7fe6959b4e9f5a5c$var$Header() {
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("header", {
        className: "h-14 p-4 bg-[#f5f3ef] flex justify-between items-center fixed top-0 left-0 w-full z-50 shadow",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                to: "/",
                children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                    className: "w-32 flex justify-center items-center",
                    children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("img", {
                        src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750517657/logo-landscape-attnq_de2l3q.png",
                        alt: "attnq-logo-header"
                    })
                })
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $88b8073c72dea9d1$export$2e2bcd8739ae039), {})
        ]
    });
}
var $7fe6959b4e9f5a5c$export$2e2bcd8739ae039 = $7fe6959b4e9f5a5c$var$Header;





function $55329fec1ffe2d5e$var$Footer() {
    var currentYear = new Date().getFullYear();
    var currentUrl = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("footer", {
        className: "w-full h-fit px-8",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                className: "flex  flex-wrap justify-around items-start gap-6",
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "w-[40vw] lg:w-[20vw] pt-12 flex flex-col justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                                className: "w-20 lg:w-32",
                                children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("img", {
                                    src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750517663/logo-sqaure-attnq_cwnyfe.png",
                                    alt: "attnq-logo-footer"
                                })
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                className: "text-gray-700 text-sm leading-[1.62rem] mt-[-1rem] text-center",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        children: [
                                            "Business:",
                                            " ",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                                className: "underline-offset-3 underline",
                                                children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("a", {
                                                    href: "mailto:info@attnq.com",
                                                    children: "info@attnq.com"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        children: [
                                            "HR:",
                                            " ",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                                className: "underline underline-offset-3",
                                                children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("a", {
                                                    href: "mailto:hr@attnq.com",
                                                    children: "hr@attnq.com"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "w-[40vw] lg:w-[20vw] pt-16 text-center",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                className: "font-semibold",
                                children: "COMPANY"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                className: "text-gray-700 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "pt-3",
                                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                            to: "about-us",
                                            children: "About Us"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "py-3",
                                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                            to: "careers",
                                            children: "Careers"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("a", {
                                        href: "",
                                        className: "py-3",
                                        children: "LinkedIn"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "w-[40vw] lg:w-[20vw] pt-16 text-center",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                className: "font-semibold",
                                children: "QUICK LINKS"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                className: "text-gray-700 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "pt-3",
                                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                            to: "agent-domain",
                                            children: "For Brokers"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "py-3",
                                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                            to: "buyer-query",
                                            children: "For Investors"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        children: currentUrl.pathname === "/" ? /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("a", {
                                            href: "#features",
                                            children: "Features"
                                        }) : null
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "w-[40vw] lg:w-[20vw] pt-16 text-center",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                className: "font-semibold",
                                children: "POLICIES"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                className: "text-gray-700 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "pt-3",
                                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                            to: "privacy-policy",
                                            children: "Privacy Policy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                        className: "py-3",
                                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                            to: "terms-conditions",
                                            children: "Terms And Conditions"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                className: "mt-10 flex justify-center items-center",
                children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                    className: "inline-block text-gray-700 text-sm border-t border-gray-400 py-1 px-6",
                    children: [
                        "Copyright \xa9 ",
                        currentYear,
                        " AttnQ. All rights reserved."
                    ]
                })
            })
        ]
    });
}
var $55329fec1ffe2d5e$export$2e2bcd8739ae039 = $55329fec1ffe2d5e$var$Footer;


function $004c81b2deaf14e1$var$Home() {
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $7fe6959b4e9f5a5c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $f0792a32d62fec93$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $55329fec1ffe2d5e$export$2e2bcd8739ae039), {})
        ]
    });
}
var $004c81b2deaf14e1$export$2e2bcd8739ae039 = $004c81b2deaf14e1$var$Home;




var $4Bt61 = parcelRequire("4Bt61");

function $a87c7545fef1fb46$var$PageNotFound() {
    (0, $4Bt61.useEffect)(function() {
        document.title = "404:Page Not Found | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("main", {
        className: "min-h-screen flex flex-col justify-center items-center px-4 text-center",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                className: "mt-12 w-[50vw] lg:w-[25vw]",
                children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("img", {
                    src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750781851/error-404_njd9cr.png",
                    alt: "404",
                    className: "max-w-xs md:max-w-md w-full mx-auto opacity-80"
                })
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                className: "text-2xl font-semibold text-gray-800 mt-4",
                children: "Page Not Found"
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                to: "/",
                className: "inline-block bg-[#dc9209] text-gray-100 hover:text-gray-300 px-6 py-2 mt-4 font-semibold rounded-lg shadow hover:bg-[#dc9209] transition",
                children: "Back to Home"
            })
        ]
    });
}
var $a87c7545fef1fb46$export$2e2bcd8739ae039 = $a87c7545fef1fb46$var$PageNotFound;





var $4Bt61 = parcelRequire("4Bt61");

function $776928c06432ec7c$export$2e2bcd8739ae039() {
    var placeholders = Array.from({
        length: 2
    });
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("section", {
        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
            className: "flex flex-col gap-6",
            children: placeholders.map(function(_, idx) {
                return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                    className: "flex-1 border rounded-lg p-5 animate-pulse flex flex-col gap-4 bg-yellow-50",
                    children: [
                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                            className: "h-6 bg-gray-300/70 rounded w-2/3"
                        }),
                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                            className: "h-4 bg-gray-300/60 rounded w-1/2"
                        }),
                        /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                            className: "mt-auto h-4 bg-gray-300/50 rounded w-1/3 self-start"
                        })
                    ]
                }, idx);
            })
        })
    });
}



function $344d3296b507e56e$var$MainCareers() {
    var _useState = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)([]), 2), openings = _useState[0], setOpenings = _useState[1];
    var _useState1 = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(null), 2), err = _useState2[0], setErr = _useState2[1];
    var _useState3 = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(false), 2), isOpen = _useState3[0], setIsOpen = _useState3[1];
    (0, $4Bt61.useEffect)(function() {
        document.title = "Careers | AttnQ";
    }, []);
    (0, $4Bt61.useEffect)(function() {
        fetch("https://attnq.free.beeceptor.com/vacancies").then(function(res) {
            if (!res.ok) throw new Error("There was an error updating available openings. Please try again after sometime");
            return res.json();
        }).then(function(data) {
            setOpenings(data);
        }).catch(function(err) {
            setErr("There was an error updating available openings. Please try again after sometime.");
        }).finally(function() {
            return setLoading(false);
        });
    }, []);
    var hrContacts = [
        {
            id: 1,
            name: "HR Desk",
            role: "Human Resource",
            email: "hr@attnq.com"
        }
    ];
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("main", {
        className: "w-full h-fit px-6 lg:px-32 py-16 mt-14 shadow",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8ecadbf3eef68bdf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                className: "flex flex-col gap-10 md:flex-row mt-[-3rem]",
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                className: "text-2xl font-semibold py-6",
                                children: "Open Positions"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("ul", {
                                className: "space-y-4",
                                children: loading === true ? /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $776928c06432ec7c$export$2e2bcd8739ae039), {}) : err == null ? openings.map(function(job) {
                                    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("li", {
                                        onClick: function() {
                                            return setIsOpen(!isOpen);
                                        },
                                        className: "bg-yellow-50 border cursor-pointer rounded-lg p-5 flex flex-col md:flex-row md:items-center md:justify-between hover:shadow transition",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                                        className: "font-medium text-lg",
                                                        children: job.title
                                                    }),
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                                        className: "text-sm text-gray-500",
                                                        children: job.location
                                                    }),
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                                        className: "text-sm text-gray-500",
                                                        children: "Required ".concat(job.exp, " Years of Experience")
                                                    }),
                                                    isOpen && /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                                        className: "mt-4 text-sm text-gray-600 space-y-2 border-t p-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                                                className: "p-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                                        children: "Description:"
                                                                    }),
                                                                    " ",
                                                                    job.description || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                                                className: "p-1 pl-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                                        children: "1:"
                                                                    }),
                                                                    " ",
                                                                    job.descA || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                                                className: "p-1 pl-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                                        children: "2:"
                                                                    }),
                                                                    " ",
                                                                    job.descB || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                                                className: "p-1 pl-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                                        children: "3:"
                                                                    }),
                                                                    " ",
                                                                    job.descC || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                                                className: "p-1 pl-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                                        children: "4:"
                                                                    }),
                                                                    " ",
                                                                    job.descD || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                                                className: "p-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                                        children: "Estimate Salary:"
                                                                    }),
                                                                    " ",
                                                                    job.pay || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                                                className: "p-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                                        children: "Status:"
                                                                    }),
                                                                    " ",
                                                                    job.status || "Filled"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                                className: "mt-2 md:mt-0 inline-block px-3 py-1 bg-amber-100 text-amber-800 text-xs rounded-full",
                                                children: job.type
                                            })
                                        ]
                                    }, job.id);
                                }) : /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                    children: err
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("aside", {
                        className: "md:w-80",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                className: "text-2xl font-semibold py-6",
                                children: "HR Contact"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("ul", {
                                className: "space-y-4",
                                children: hrContacts.map(function(hr) {
                                    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("li", {
                                        className: "bg-yellow-50 border rounded-lg p-5 flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                                className: "font-medium",
                                                children: hr.name
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("a", {
                                                href: "mailto:".concat(hr.email),
                                                className: "text-sm text-[#dc9209] hover:underline",
                                                children: hr.email
                                            })
                                        ]
                                    }, hr.id);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $344d3296b507e56e$export$2e2bcd8739ae039 = $344d3296b507e56e$var$MainCareers;





function $d5be4a96a008f2f4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d5be4a96a008f2f4$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d5be4a96a008f2f4$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}






var $4Bt61 = parcelRequire("4Bt61");

var $3424d20697382d7c$var$DUMMY_AUTH_URL = "https://run.mocky.io/v3/5185415ba171ea3a00704eed?mocky-delay=3s";
var $3424d20697382d7c$var$MainForAgent = function() {
    var _useState = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)({
        username: "",
        password: ""
    }), 2), form = _useState[0], setForm = _useState[1];
    var _useState1 = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(false), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(""), 2), error = _useState2[0], setError = _useState2[1];
    var _useState3 = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(true), 2), showBanner = _useState3[0], setShowBanner = _useState3[1];
    var handleChange = function(e) {
        return setForm((0, $d5be4a96a008f2f4$export$71511d61b312f219)((0, $5f1309c2fb31fc13$export$71511d61b312f219)({}, form), (0, $01539ab334a9139b$export$71511d61b312f219)({}, e.target.name, e.target.value)));
    };
    var handleSubmit = function(e) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1d3fb01611386816$export$71511d61b312f219)(function() {
            var artTimer, e1;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setLoading(true);
                        setError("");
                        artTimer = Math.floor(Math.random() * 4001) + 1000;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            fetch($3424d20697382d7c$var$DUMMY_AUTH_URL, {
                                method: "POST",
                                body: JSON.stringify(form)
                            })
                        ];
                    case 2:
                        _state.sent();
                        setTimeout(function() {
                            setError("Incorrect User ID or Login Pin");
                        }, artTimer);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e1 = _state.sent();
                        setTimeout(function() {
                            setError("Incorrect User ID or Login Pin.");
                        }, artTimer);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setTimeout(function() {
                            setForm({
                                username: "",
                                password: ""
                            });
                            setLoading(false);
                        }, artTimer);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    (0, $4Bt61.useEffect)(function() {
        document.title = "Broker Login | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("main", {
        className: "h-fit w-full flex items-center justify-center px-4 shadow mt-14 p-6 py-14",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8ecadbf3eef68bdf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                className: "w-full max-w-md bg-gray-100 rounded-xl shadow-md p-6 space-y-6",
                children: [
                    showBanner && /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "bg-yellow-100 text-yellow-800 px-4 py-3 rounded relative text-center text-sm",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                className: "font-semibold",
                                children: "Notice:"
                            }),
                            " Our pilot program to onboard new brokers is temporarily on hold as the broker pool is currently full."
                        ]
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h1", {
                        className: "text-2xl text-center font-semibold pb-6",
                        children: "Broker Login"
                    }),
                    error && /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                        className: "bg-red-100 text-red-700 px-4 py-2 rounded text-center text-sm",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("form", {
                        onSubmit: handleSubmit,
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                type: "text",
                                name: "username",
                                placeholder: "User ID",
                                autoComplete: "user-id",
                                value: form.username,
                                onChange: handleChange,
                                className: "w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                type: "password",
                                name: "password",
                                placeholder: "Login Pin",
                                autoComplete: "pin",
                                value: form.password,
                                onChange: handleChange,
                                className: "w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("button", {
                                type: "submit",
                                disabled: loading,
                                className: "w-full bg-[#163944] text-white font-medium py-3 rounded-lg cursor-pointer disabled:opacity-60 flex items-center justify-center",
                                children: loading ? /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                    className: "animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"
                                }) : "Log In"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3424d20697382d7c$export$2e2bcd8739ae039 = $3424d20697382d7c$var$MainForAgent;








var $4Bt61 = parcelRequire("4Bt61");


function $c4cc29fb9a035ec4$export$2e2bcd8739ae039() {
    var initialFormState = {
        name: "",
        phone: "",
        email: "",
        propertyType: "",
        budget: "",
        location: "",
        space: "",
        amenities: "",
        projectStage: "",
        dealBreakers: "",
        buyingIntent: ""
    };
    var _useState = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(initialFormState), 2), form = _useState[0], setForm = _useState[1];
    var _useState1 = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(false), 2), agreed = _useState1[0], setAgreed = _useState1[1];
    var _useState2 = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(""), 2), error = _useState2[0], setError = _useState2[1];
    var _useState3 = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(false), 2), showSuccess = _useState3[0], setShowSuccess = _useState3[1];
    var _useState4 = (0, $b0842d51d9c0999a$export$71511d61b312f219)((0, $4Bt61.useState)(false), 2), loading = _useState4[0], setLoading = _useState4[1];
    var handleChange = function(e) {
        setForm((0, $d5be4a96a008f2f4$export$71511d61b312f219)((0, $5f1309c2fb31fc13$export$71511d61b312f219)({}, form), (0, $01539ab334a9139b$export$71511d61b312f219)({}, e.target.name, e.target.value)));
    };
    var handleSubmit = function(e) {
        e.preventDefault();
        setLoading(true);
        var artTimer = Math.floor(Math.random() * 4001) + 1000;
        if (!agreed) {
            setError("You must agree to the Privacy Policy and Terms & Conditions.");
            return;
        }
        setError("");
        console.log("Investor Requirements Submitted:", form);
        // Simulate success
        setTimeout(function() {
            setShowSuccess(true);
            // Reset form
            setForm(initialFormState);
            setAgreed(false);
            setLoading(false);
        }, artTimer);
        // Hide success message after 10 seconds
        setTimeout(function() {
            setShowSuccess(false);
        }, 15000);
    };
    (0, $4Bt61.useEffect)(function() {
        document.title = "Investor Requirements | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("main", {
        className: "h-fit w-full px-6 lg:px-20 py-6 mt-14 relative shadow",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8ecadbf3eef68bdf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                className: "text-2xl font-semibold text-center pb-6",
                children: "Submit Your Requirements"
            }),
            showSuccess && /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                className: "absolute inset-0 m-auto w-max h-max bg-green-100 border border-green-400 text-green-800 px-4 py-5 rounded-lg shadow z-10",
                children: "Thank you for submitting your requirement. You are now queued and our vetted brokers with any property match will contact you soon."
            }),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "bg-white border rounded-xl p-8 lg:px-16 shadow-sm flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                className: "md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Full Name"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                        type: "text",
                                        name: "name",
                                        value: form.name || "",
                                        onChange: handleChange,
                                        placeholder: "Enter your full name",
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Phone Number"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                        type: "tel",
                                        name: "phone",
                                        value: form.phone || "",
                                        onChange: handleChange,
                                        placeholder: "e.g., +91 9876543210",
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Email Address"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                        type: "email",
                                        name: "email",
                                        value: form.email || "",
                                        onChange: handleChange,
                                        placeholder: "you@example.com",
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Property Type"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("select", {
                                        name: "propertyType",
                                        value: form.propertyType,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true,
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "",
                                                children: "Select type"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "Residential",
                                                children: "Residential"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "Commercial",
                                                children: "Commercial"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "Plot",
                                                children: "Plot"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "Mixed-use",
                                                children: "Mixed-use"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Budget"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                        type: "number",
                                        name: "budget",
                                        placeholder: "e.g., 20000000",
                                        value: form.budget,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Preferred Location(s)"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                        type: "text",
                                        name: "location",
                                        placeholder: "City, Area, Landmark",
                                        value: form.location,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Minimum Space Required (sq ft)"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                        type: "number",
                                        name: "space",
                                        value: form.space,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                className: "md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Desired Amenities"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                        type: "text",
                                        name: "amenities",
                                        placeholder: "e.g., parking, lift, security",
                                        value: form.amenities,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Project Stage"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("select", {
                                        name: "projectStage",
                                        value: form.projectStage,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "",
                                                children: "Any"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "Under Construction",
                                                children: "Under Construction"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "Ready to Move",
                                                children: "Ready to Move"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "Pre-Launch",
                                                children: "Pre-Launch"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Deal-breakers"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                        type: "text",
                                        name: "dealBreakers",
                                        placeholder: "e.g., no resale, no ground floor",
                                        value: form.dealBreakers,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                                className: "md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Buying Intent"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("select", {
                                        name: "buyingIntent",
                                        value: form.buyingIntent,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "",
                                                children: "Select intent"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "Actively Searching",
                                                children: "Actively Searching"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "Within 3 Months",
                                                children: "Within 3 Months"
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("option", {
                                                value: "Exploring Options",
                                                children: "Exploring Options"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("label", {
                        className: "flex items-start gap-3",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("input", {
                                type: "checkbox",
                                checked: agreed,
                                onChange: function() {
                                    return setAgreed(!agreed);
                                },
                                className: "mt-1 h-4 w-4 border rounded-sm text-[#1D4753] focus:ring-[#1D4753]"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("span", {
                                className: "text-sm",
                                children: [
                                    "I agree to the",
                                    " ",
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                        to: "/terms-conditions",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                                className: "text-[#dc9209] hover:underline",
                                                children: "Terms & Conditions"
                                            }),
                                            " "
                                        ]
                                    }),
                                    "and",
                                    " ",
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                        to: "/privacy-policy",
                                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                            className: "text-[#dc9209] hover:underline",
                                            children: "Privacy Policies."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                        className: "text-red-600 text-sm",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("button", {
                            type: "submit",
                            disabled: !agreed,
                            className: "bg-[#163944] text-white font-medium p-3 rounded-lg disabled:opacity-60 flex items-center justify-center\n              ".concat(agreed ? "bg-[#1D4753] text-white hover:bg-[#163944] cursor-pointer" : "bg-gray-300 text-gray-500 cursor-not-allowed"),
                            children: loading ? /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                className: "animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"
                            }) : "Submit Requirements"
                        })
                    })
                ]
            })
        ]
    });
}




var $4Bt61 = parcelRequire("4Bt61");

function $9d9d4246aa54288a$var$MainTermsConditions() {
    (0, $4Bt61.useEffect)(function() {
        document.title = "Terms And Conditions | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("main", {
        className: "text-gray-800 px-8 py-20 shadow",
        children: [
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8ecadbf3eef68bdf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("div", {
                className: "max-w-5xl mx-auto space-y-10",
                children: [
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("header", {
                        className: "text-center space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h1", {
                                className: "text-xl md:text-3xl font-bold",
                                children: "Terms\xa0&\xa0Conditions"
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                className: "text-sm text-gray-500",
                                children: [
                                    "Updated on and effective from:",
                                    " ",
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("span", {
                                        className: "italic",
                                        children: "[04\xa006\xa02024]"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("article", {
                        className: "space-y-8",
                        children: [
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "1. Acceptance of Terms"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "By accessing or using the AttnQ platform (\u201C",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: "Platform"
                                            }),
                                            "\u201D), you agree to be bound by these Terms and Conditions (\u201C",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                children: "Terms"
                                            }),
                                            "\u201D). If you do not accept the Terms, you must not use the Platform."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "2. Definitions"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                        className: "list-disc list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                        children: '\u201CBuyer\u201D / "Investor"'
                                                    }),
                                                    " \u2013 any user submitting property requirements."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                        children: "\u201CBroker\u201D / \u201CAgent\u201D"
                                                    }),
                                                    " \u2013 any user accessing those requirements to offer properties."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("strong", {
                                                        children: "\u201CLead\u201D"
                                                    }),
                                                    " \u2013 a buyer/investor requirement shared with a broker."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "3. Eligibility & Accounts"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ol", {
                                        className: "list-decimal list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "You must be at least 18\xa0years old."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Provide accurate, complete registration data."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Maintain the confidentiality of your login credentials."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Notify AttnQ immediately of any unauthorised use of your account."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "4. Platform Use & Licence"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "AttnQ grants you a limited, non-exclusive, non-transferable, and revocable license to access and use the Platform strictly in accordance with these Terms and Conditions. This license is intended solely to enable you to evaluate, submit, or respond to property requirements as a buyer or broker through AttnQ's matchmaking features. You may use the Platform only for your personal or professional real estate purposes, and not for any commercial resale, redistribution, or mass extraction of data.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "You are not permitted to copy, modify, distribute, reverse-engineer, or create derivative works from any part of the Platform, including its design, structure, codebase, or user data. Automated scripts, bots, or unauthorized software to access the Platform are strictly prohibited. The Platform and its content remain the sole intellectual property of AttnQ, and your use of the service does not grant you ownership of any part of it.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "AttnQ reserves the right to suspend or revoke your access at any time, without prior notice, if it determines that your use violates these Terms, applicable law, or harms the integrity of the platform or its users."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "5. Buyer Obligations"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                        className: "list-disc list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Provide truthful property requirements."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Respond courteously to broker outreach."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Avoid posting fraudulent or misleading information."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Comply with all applicable real-estate regulations."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "6. Broker Obligations"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                        className: "list-disc list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Hold valid licences/registrations required by law (e.g., RERA)."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Contact buyers only via consented channels and within rate limits."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Provide accurate property details; no misrepresentation."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Pay all fees and commissions due to AttnQ in a timely manner."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "7. Fees, Payments & Refunds"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "AttnQ operates on a hybrid pricing model designed to keep the platform accessible while rewarding performance. Brokers can purchase lead credits in prepaid bundles or activate a recurring subscription that unlocks a set number of qualified buyer profiles each month. All fees are denominated in Indian Rupees (INR) unless otherwise stated and are exclusive of applicable taxes, which will be added at checkout. Payment is processed through our integrated gateway partners, and by completing a transaction you authorize AttnQ to charge the selected payment method for the agreed amount, including any recurring charges tied to a subscription plan.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "Buyers are not charged for posting requirements; however, when a successful match results in a finalized property transaction, a success-based commission may be invoiced. This commission is always disclosed in advance and must be settled within the payment window specified on the invoice. Failure to pay may lead to suspension of platform privileges for both parties involved and may trigger additional collection procedures.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "Except where mandatory consumer-protection law requires otherwise, all purchases of lead credits, subscription fees, and success commissions are non-refundable. Refunds are considered only in cases of duplicate billing or demonstrable technical errors that prevent delivery of the paid service. Any approved refund will be issued to the original payment method within fifteen business days and will exclude third-party transaction charges that AttnQ cannot recover."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "8. Intellectual Property"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "All content, features, and functionality available on the AttnQ Platform\u2014including but not limited to the website design, codebase, branding, logos, matching algorithms, written copy, and user interface elements\u2014are the exclusive property of AttnQ or its licensors. These elements are protected under applicable intellectual property laws, including copyright, trademark, and trade secret regulations. No part of the Platform may be copied, reproduced, republished, uploaded, or distributed in any form without prior written consent from AttnQ.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "By using the Platform, you do not acquire any ownership rights or licenses to AttnQ\u2019s intellectual property. You may not use AttnQ\u2019s name, logo, or any content from the Platform in a way that implies partnership, endorsement, or association without express written approval.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "However, when you submit content to the Platform\u2014such as property requirements, listings, or profile details\u2014you retain ownership of that content. You grant AttnQ a non-exclusive, royalty-free, global license to store, process, display, and share your submitted content solely for the purposes of enabling property matchmaking, fulfilling service functionality, and improving the Platform.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "Any unauthorized use or reproduction of AttnQ\u2019s intellectual property may result in legal action, including suspension of account access and pursuit of damages where applicable."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "9. Prohibited Activities"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("ul", {
                                        className: "list-disc list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Data scraping or automated collection of leads."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Sending spam or unsolicited messages."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Posting illegal, defamatory, or obscene content."
                                            }),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("li", {
                                                children: "Engaging in fraudulent or deceptive practices."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "10. Disclaimer of Warranties"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "The AttnQ Platform is provided on an \u201Cas is\u201D and \u201Cas available\u201D basis, without any express or implied warranties of any kind. While we strive to offer a seamless and reliable service, AttnQ makes no guarantees regarding the accuracy, completeness, or reliability of any content, listings, buyer or broker information, or property matches available through the Platform.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "We do not warrant that the Platform will be error-free, uninterrupted, or immune to bugs, delays, or technical issues. You acknowledge that occasional downtime, system updates, and third-party service interruptions may occur, and that these are not grounds for compensation or refunds unless otherwise specified.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "AttnQ does not endorse, verify, or guarantee the legitimacy of any user, broker, property, or deal listed on the Platform. All decisions made based on information available on AttnQ\u2014such as contacting a broker or proceeding with a transaction\u2014are made at your own discretion and risk.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "To the fullest extent permitted by law, AttnQ disclaims all warranties, whether statutory, express, or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement. You assume full responsibility for the outcomes of using the Platform and are encouraged to conduct independent due diligence before entering into any financial or real estate agreement."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "11. Limitation of Liability"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "To the maximum extent permitted by applicable law, AttnQ shall not be held liable for any direct, indirect, incidental, consequential, special, or exemplary damages arising out of or in connection with your access to, use of, or inability to use the Platform. This includes\u2014but is not limited to\u2014loss of profits, goodwill, property deals, data, business opportunities, or reputational harm, even if AttnQ has been advised of the possibility of such damages.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "AttnQ acts solely as a technology intermediary between property buyers and brokers. We do not participate in or control any offline interactions, negotiations, or transactions between users. As a result, we cannot and do not guarantee that a match will lead to a successful property transaction, nor can we be held responsible for any disputes, misrepresentations, or contractual failures that may arise between parties.",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "Our total aggregate liability, in any circumstance and regardless of the cause of action, shall not exceed the greater of (a) the amount paid by you (if any) to AttnQ in the past six months for use of the Platform, or (b) \u20B95,000 (INR five thousand only).",
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("br", {}),
                                            "Some jurisdictions may not allow certain limitations on liability, so portions of this clause may not apply to you. In all cases, AttnQ\u2019s liability will be limited to the fullest extent allowed by law."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "12. Indemnification"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "You agree to indemnify, defend, and hold harmless AttnQ, its parent company, directors, officers, employees, affiliates, and authorized service providers from and against any and all claims, demands, liabilities, losses, damages, penalties, fines, expenses, and legal fees (including reasonable attorneys\u2019 fees) arising out of or related to your violation of these Terms and Conditions; your use or misuse of the Platform; your interactions or disputes with other users, including but not limited to property buyers, brokers, or third-party vendors; any content or information you submit, upload, or transmit through the Platform; any breach of applicable laws, regulations, or third-party rights (including intellectual property or data protection laws) committed during your use of the Platform."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "13. Termination & Suspension"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "AttnQ may suspend or terminate your account at any time for violation of these Terms, with or without notice. Upon termination, your right to use the Platform ceases immediately."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "14. Changes to Terms"
                                    }),
                                    /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "We may update this Terms and Conditions from time to time to reflect changes in our services, legal requirements, or internal practices, and we encourage you to review it periodically. Whenever a material revision is made, we will post the new version on our website and, where feasible, provide additional notice\u2014such as sending an email or displaying an in-app alert\u2014so that you remain informed about how your data is handled. Because our product evolves quickly, we reserve the right to amend or replace the policy without prior notice when immediate changes are necessary to protect user data, comply with urgent legal directives, or address emerging security concerns. Your continued use of AttnQ after any modification constitutes acceptance of the revised terms; if you do not agree, you should discontinue use of the platform."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $9d9d4246aa54288a$export$2e2bcd8739ae039 = $9d9d4246aa54288a$var$MainTermsConditions;


var $069604d9b9ef22b8$var$router = (0, $8f0ad21e84364a49$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsxs)((0, $2fa82f22a26d0c86$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $8f0ad21e84364a49$export$11aac1aab828f1fa), {}),
                /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $004c81b2deaf14e1$export$2e2bcd8739ae039), {})
            ]
        }),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $b61b6077bcc96e04$export$2e2bcd8739ae039), {})
            },
            {
                path: "about-us",
                element: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $7f9744aea433ca37$export$2e2bcd8739ae039), {})
            },
            {
                path: "careers",
                element: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $344d3296b507e56e$export$2e2bcd8739ae039), {})
            },
            {
                path: "agent-domain",
                element: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $3424d20697382d7c$export$2e2bcd8739ae039), {})
            },
            {
                path: "buyer-query",
                element: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $c4cc29fb9a035ec4$export$2e2bcd8739ae039), {})
            },
            {
                path: "privacy-policy",
                element: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $364a03e7fcb2d1c4$export$2e2bcd8739ae039), {})
            },
            {
                path: "terms-conditions",
                element: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $9d9d4246aa54288a$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        path: "*",
        element: /*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $a87c7545fef1fb46$export$2e2bcd8739ae039), {})
    }
]);
var $069604d9b9ef22b8$export$2e2bcd8739ae039 = $069604d9b9ef22b8$var$router;


var $4df4ab1e4712179f$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8949e5ebfdf38b70$exports))).createRoot(document.getElementById("root"));
$4df4ab1e4712179f$var$root.render(/*#__PURE__*/ (0, $2fa82f22a26d0c86$exports.jsx)((0, $f0792a32d62fec93$export$323e4fc2fa4753fb), {
    router: (0, $069604d9b9ef22b8$export$2e2bcd8739ae039)
}));

})();
//# sourceMappingURL=site-update-2025.22bae59f.js.map
